// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./loading.gif", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";

/* 04/24/2017 Paul.  Old background #2A3F54 */
/* 12/28/2017 Paul.  Dark menu */
.left_col {
	background: #64707B;
	color: white;
}

/* 06/29/2017 Paul.  Increase to 100px. */
.nav-sm .container.body .col-md-3.left_col {
	width: 100px;
	padding: 0;
	z-index: 9999;
	position: absolute
}

.nav-sm .container.body .col-md-3.left_col.menu_fixed {
	position: fixed;
	height: 100%
}

.nav-sm .container.body .col-md-3.left_col .mCSB_container,
.nav-sm .container.body .col-md-3.left_col .mCustomScrollBox {
	overflow: visible
}

.nav-sm .hidden-small {
	visibility: hidden
}

/* 06/29/2017 Paul.  Increase to 100px. */
.nav-sm .container.body .right_col {
	padding: 10px 20px;
	margin-left: 100px;
	z-index: 2
}

/* 06/29/2017 Paul.  Increase to 100px. */
.nav-sm .navbar.nav_title {
	width: 100px;
}

.nav-sm .navbar.nav_title a span {
	display: none
}

.nav-sm .navbar.nav_title a i {
	font-size: 27px;
	margin: 13px 0 0 3px
}

/* 12/28/2017 Paul.  Keep Splendid yellow background #FFD14E. */
.site_title
{
	background-color: #FFD14E;

}
.site_title i {
	border: 1px solid #EAEAEA;
	padding: 5px 6px;
	border-radius: 50%
}

/* 06/29/2017 Paul.  Increase to 100px. */
.nav-sm .main_container .top_nav {
	display: block;
	margin-left: 100px;
	z-index: 2
}

/* 12/28/2017 Paul.  font-size 10px is too small. */
.nav-sm .nav.side-menu li a {
	text-align: center !important;
	font-weight: 400;
	padding: 10px 5px
}

/* 12/28/2017 Paul.  Dark menu */
.nav-sm .nav.child_menu li.active,
.nav-sm .nav.side-menu li.active-sm {
	border-right: 5px solid #cccccc
}

.nav-sm ul.nav.child_menu ul,
.nav-sm .nav.side-menu li.active-sm ul ul {
	position: static;
	width: 200px;
	background: none
}

.nav-sm > .nav.side-menu > li.active-sm > a {
	color: #1ABB9C !important
}

.nav-sm .nav.side-menu li a i.toggle-up {
	display: none !important
}

.nav-sm .nav.side-menu li a i {
	font-size: 25px !important;
	text-align: center;
	width: 100% !important;
	margin-bottom: 5px
}

/* 04/24/2017 Paul.  Old background #3E5367 */
/* 12/28/2017 Paul.  Dark menu */
.nav-sm ul.nav.child_menu {
	left: 100%;
	position: absolute;
	top: 0;
	width: 210px;
	z-index: 4000;
	background: #64707B;
	color: white;
	display: none;
}

.nav-sm ul.nav.child_menu li {
	padding: 0 10px
}

.nav-sm ul.nav.child_menu li a {
	text-align: left !important
}

.nav-sm .profile {
	display: none
}

.menu_section {
	margin-bottom: 35px
}

.menu_section h3 {
	padding-left: 23px;
	color: #fff;
	text-transform: uppercase;
	letter-spacing: .5px;
	font-weight: bold;
	font-size: 11px;
	margin-bottom: 0;
	margin-top: 0;
	text-shadow: 1px 1px #000
}

.menu_section > ul {
	margin-top: 10px
}

.profile_pic {
	width: 35%;
	float: left
}

.img-circle.profile_img {
	width: 70%;
	background: #fff;
	margin-left: 15%;
	z-index: 1000;
	position: inherit;
	margin-top: 20px;
	border: 1px solid rgba(52, 73, 94, 0.44);
	padding: 4px
}

.profile_info {
	padding: 25px 10px 10px;
	width: 65%;
	float: left
}

	/* 04/24/2017 Paul.  Old color #BAB8B8 */
	/* 12/28/2017 Paul.  Dark menu */
	.profile_info span {
		font-size: 13px;
		line-height: 30px;
		color: white;
	}

	/* 04/24/2017 Paul.  Old color #ECF0F1 */
	/* 12/28/2017 Paul.  Dark menu */
	.profile_info h2 {
		font-size: 14px;
		color: white;
		margin: 0;
		font-weight: 300;
	}

.profile.img_2 {
	text-align: center
}

.profile.img_2 .profile_pic {
	width: 100%
}

.profile.img_2 .profile_pic .img-circle.profile_img {
	width: 50%;
	margin: 10px 0 0
}

.profile.img_2 .profile_info {
	padding: 15px 10px 0;
	width: 100%;
	margin-bottom: 10px;
	float: left
}

/* 04/24/2017 Paul.  Old color #C4CFDA, font-size: 10px; */
/* 12/28/2017 Paul.  Dark menu */
.main_menu span.fa {
	float: right;
	text-align: center;
	margin-top: 5px;
	min-width: inherit;
	color: white;
}

.active a span.fa {
	text-align: right !important;
	margin-right: 4px
}

.nav-sm .menu_section {
	margin: 0
}

.nav-sm span.fa,
.nav-sm .menu_section h3 {
	display: none
}

.nav-sm li li span.fa {
	display: inline-block
}

.nav_menu {
	float: left;
	background: #EDEDED;
	border-bottom: 1px solid #D9DEE4;
	margin-bottom: 10px;
	width: 100%;
	position: relative
}

@media (min-width: 480px) {
	.nav_menu {
		position: static
	}
}

.nav-md .container.body .col-md-3.left_col {
	width: 230px;
	padding: 0;
	position: absolute;
	display: -ms-flexbox;
	display: flex;
	z-index: 9999
}

.nav-md .container.body .col-md-3.left_col.menu_fixed {
	height: 100%;
	position: fixed
}

body .container.body .right_col {
	background: #F7F7F7
}

.nav-md .container.body .right_col {
	padding: 10px 20px 0;
	margin-left: 230px
}

/* 04/24/2017 Paul.  Old background #2A3F54 */
/* 12/28/2017 Paul.  Dark menu */
.nav_title {
	width: 230px;
	float: left;
	background: #64707B;
	color: white;
	border-radius: 0;
	height: 57px;
}

@media (max-width: 991px) {
	.nav-md .container.body .right_col,
	.nav-md .container.body .top_nav {
		width: 100%;
		margin: 0
	}
	.nav-md .container.body .col-md-3.left_col {
		display: none
	}
	.nav-md .container.body .right_col {
		width: 100%;
		padding-right: 0
	}
	.right_col {
		padding: 10px !important
	}
}

@media (max-width: 1200px) {
	.x_title h2 {
		width: 62%;
		font-size: 17px
	}
	.tile,
	.graph {
		zoom: 85%;
		height: inherit
	}
}

@media (max-width: 1270px) and (min-width: 192px) {
	.x_title h2 small {
		display: none
	}
}

.left_col .mCSB_scrollTools {
	width: 6px
}

.left_col .mCSB_dragger {
	max-height: 400px !important
}

.blue {
	color: #3498DB
}

.purple {
	color: #9B59B6
}

.green {
	color: #1ABB9C
}

.aero {
	color: #9CC2CB
}

.red {
	color: #E74C3C
}

.dark {
	color: #34495E
}

.border-blue {
	border-color: #3498DB !important
}

.border-purple {
	border-color: #9B59B6 !important
}

.border-green {
	border-color: #1ABB9C !important
}

.border-aero {
	border-color: #9CC2CB !important
}

.border-red {
	border-color: #E74C3C !important
}

.border-dark {
	border-color: #34495E !important
}

.bg-white {
	background: #fff !important;
	border: 1px solid #fff !important;
	color: #73879C
}

.bg-green {
	background: #1ABB9C !important;
	border: 1px solid #1ABB9C !important;
	color: #fff
}

.bg-red {
	background: #E74C3C !important;
	border: 1px solid #E74C3C !important;
	color: #fff
}

.bg-blue {
	background: #3498DB !important;
	border: 1px solid #3498DB !important;
	color: #fff
}

.bg-orange {
	background: #F39C12 !important;
	border: 1px solid #F39C12 !important;
	color: #fff
}

.bg-purple {
	background: #9B59B6 !important;
	border: 1px solid #9B59B6 !important;
	color: #fff
}

.bg-blue-sky {
	background: #50C1CF !important;
	border: 1px solid #50C1CF !important;
	color: #fff
}

.container {
	width: 100%;
	padding: 0
}

.navbar-nav > li > a,
.navbar-brand,
.navbar-nav > li > a {
	color: #fff !important
}

.top_nav .nav > li > a:focus,
.top_nav .nav > li > a:hover,
.top_nav .nav .open > a,
.top_nav .nav .open > a:focus,
.top_nav .nav .open > a:hover {
	background: #D9DEE4
}

/* 04/24/2017 Paul.  Old background #2A3F54 */
/* 12/14/2019 Paul.  Old color: #73879C; */
body {
	background: white;
	font-family: "Helvetica Neue", Roboto, Arial, "Droid Sans", sans-serif;
	font-size: 13px;
	font-weight: 400;
	line-height: 1.471;
}

.main_container .top_nav {
	display: block;
	margin-left: 230px
}

.no-padding {
	padding: 0 !important
}

.page-title {
	width: 100%;
	height: 65px;
	padding: 10px 0
}

.page-title .title_left {
	width: 45%;
	float: left;
	display: block
}

.page-title .title_left h3 {
	margin: 9px 0
}

.page-title .title_right {
	width: 55%;
	float: left;
	display: block
}

		/* 04/25/2017 Paul.  Remove margin */
		.page-title .title_right .pull-right {
			margin: 0px 0;
		}

.fixed_height_320 {
	height: 320px
}

.fixed_height_390 {
	height: 390px
}

.fixed_height_200 {
	height: 200px
}

.overflow_hidden {
	overflow: hidden
}

.progress-bar-dark {
	background-color: #34495E !important
}

.progress-bar-gray {
	background-color: #BDC3C7 !important
}

table.no-margin .progress {
	margin-bottom: 0
}

.main_content {
	padding: 10px 20px
}

.col-md-55 {
	width: 50%;
	margin-bottom: 10px
}

@media (min-width: 768px) {
	.col-md-55 {
		width: 20%
	}
}

@media (min-width: 992px) {
	.col-md-55 {
		width: 20%
	}
}

@media (min-width: 1200px) {
	.col-md-55 {
		width: 20%
	}
}

@media (min-width: 192px) and (max-width: 1270px) {
	table.tile_info span.right {
		margin-right: 7px;
		float: left
	}
}

.center-margin {
	margin: 0 auto;
	float: none !important
}

.col-md-55,
.col-xs-1,
.col-sm-1,
.col-md-1,
.col-lg-1,
.col-xs-2,
.col-sm-2,
.col-md-2,
.col-lg-2,
.col-xs-3,
.col-sm-3,
.col-md-3,
.col-lg-3,
.col-xs-4,
.col-sm-4,
.col-md-4,
.col-lg-4,
.col-xs-5,
.col-sm-5,
.col-md-5,
.col-lg-5,
.col-xs-6,
.col-sm-6,
.col-md-6,
.col-lg-6,
.col-xs-7,
.col-sm-7,
.col-md-7,
.col-lg-7,
.col-xs-8,
.col-sm-8,
.col-md-8,
.col-lg-8,
.col-xs-9,
.col-sm-9,
.col-md-9,
.col-lg-9,
.col-xs-10,
.col-sm-10,
.col-md-10,
.col-lg-10,
.col-xs-11,
.col-sm-11,
.col-md-11,
.col-lg-11,
.col-xs-12,
.col-sm-12,
.col-md-12,
.col-lg-12 {
	position: relative;
	min-height: 1px;
	float: left;
	padding-right: 10px;
	padding-left: 10px
}

.row {
	margin-right: -10px;
	margin-left: -10px
}

.grid_slider .col-md-6 {
	padding: 0 40px
}

h1,
.h1,
h2,
.h2,
h3,
.h3 {
	margin-top: 10px;
	margin-bottom: 10px
}

/* 11/02/2020 Paul.  Change gentelella color to SplendidCRM color.  Restore underline. */
/* 02/22/2021 Paul.  Remove underline. */
a {
	color: #444444;
	text-decoration: inherit;
}

a,
a:visited,
a:focus,
a:active,
:visited,
:focus,
:active,
.btn:focus,
.btn:active:focus,
.btn.active:focus,
.btn.focus,
.btn:active.focus,
.btn.active.focus {
	outline: 0
}

a:hover,
a:focus {
	text-decoration: none
}

.navbar {
	margin-bottom: 0
}

.navbar-header {
	background: #34495E
}

.navbar-right {
	margin-right: 0
}

.top_nav .navbar-right {
	margin: 0;
	width: 70%;
	float: right
}

.top_nav .navbar-right li {
	display: inline-block;
	float: right;
	position: static
}

@media (min-width: 480px) {
	.top_nav .navbar-right li {
		position: relative
	}
}

.top_nav .dropdown-menu li {
	width: 100%
}

.top_nav .dropdown-menu li a {
	width: 100%;
	padding: 12px 20px
}

.top_nav li a i {
	font-size: 15px
}

.navbar-static-top {
	position: fixed;
	top: 0;
	width: 100%
}

.sidebar-header {
	border-bottom: 0;
	margin-top: 46px
}

.sidebar-header:first-of-type {
	margin-top: 0
}

.nav.side-menu > li {
	position: relative;
	display: block;
	cursor: pointer
}

.nav.side-menu > li > a {
	margin-bottom: 6px
}

.nav.side-menu > li > a:hover {
	color: #F2F5F7 !important
}

.nav.side-menu > li > a:hover,
.nav > li > a:focus {
	text-decoration: none;
	background: transparent
}

.nav.child_menu {
	display: none
}

	/* 04/24/2017 Paul.  Old background color rgba(255, 255, 255, 0.06) */
	.nav.child_menu li:hover,
	.nav.child_menu li.active {
		background-color: rgba(255, 255, 255, 0.26);
	}

.nav.child_menu li {
	padding-left: 36px
}

.nav-md ul.nav.child_menu li:before {
	background: #425668;
	bottom: auto;
	content: "";
	height: 8px;
	left: 23px;
	margin-top: 15px;
	position: absolute;
	right: auto;
	width: 8px;
	z-index: 1;
	border-radius: 50%
}

.nav-md ul.nav.child_menu li:after {
	border-left: 1px solid #425668;
	bottom: 0;
	content: "";
	left: 27px;
	position: absolute;
	top: 0
}

.nav.side-menu > li > a,
.nav.child_menu > li > a {
	color: #E7E7E7;
	font-weight: 500
}

.nav.child_menu li li:hover,
.nav.child_menu li li.active {
	background: none
}

.nav.child_menu li li a:hover,
.nav.child_menu li li a.active {
	color: #fff
}

.nav > li > a {
	position: relative;
	display: block;
	padding: 13px 15px 12px
}

/* 04/18/2017 Paul.  We want to allow clicking on name to navigate to list. */
/* 04/24/2017 Paul.  Old color #E7E7E7 */
/* 12/28/2017 Paul.  Dark menu */
.nav > li > div
{
	position: relative;
	display: block;
	padding: 13px 15px 12px;
	color: white;
	font-weight: 500;
}

/* 04/24/2017 Paul.  New background color rgba(255, 255, 255, 0.26) */
.nav > li > div:hover
{
	background-color: rgba(255, 255, 255, 0.26);
}

/* 04/24/2017 Paul.  Old color #1ABB9C */
/* 12/28/2017 Paul.  Dark menu */
.nav.side-menu > li.current-page, .nav.side-menu > li.active {
	border-right: 5px solid #cccccc;
}

.nav li.current-page {
	background: rgba(255, 255, 255, 0.05)
}

.nav li li li.current-page {
	background: none
}

.nav li li.current-page a {
	color: #fff
}

.nav.side-menu > li.active > a {
	text-shadow: rgba(0, 0, 0, 0.25) 0 -1px 0;
	background: linear-gradient(#334556, #2C4257), #2A3F54;
	box-shadow: rgba(0, 0, 0, 0.25) 0 1px 0, inset rgba(255, 255, 255, 0.16) 0 1px 0
}

.navbar-brand,
.navbar-nav > li > a {
	font-weight: 500;
	color: #ECF0F1 !important;
	margin-left: 0 !important;
	line-height: 32px
}

/* 04/24/2017 Paul.  Old color #ECF0F1 */
/* 12/28/2017 Paul.  Dark menu */
.site_title {
	text-overflow: ellipsis;
	overflow: hidden;
	font-weight: 400;
	font-size: 22px;
	width: 100%;
	color: white !important;
	margin-left: 0 !important;
	line-height: 59px;
	display: block;
	height: 55px;
	margin: 0;
	padding-left: 10px;
}

.site_title:hover,
.site_title:focus {
	text-decoration: none
}

/* 04/24/2017 Paul.  Old color #515356 */
/* 12/28/2017 Paul.  Dark menu */
.nav.navbar-nav > li > a {
	color: #5e6974 !important;
}

.nav.top_menu > li > a {
	position: relative;
	display: block;
	padding: 10px 15px;
	color: #34495E !important
}

.nav > li > a:hover,
.nav > li > a:focus {
	background-color: transparent
}

.top_search {
	padding: 0
}

.top_search .form-control {
	border-right: 0;
	box-shadow: inset 0 1px 0px rgba(0, 0, 0, 0.075);
	border-radius: 25px 0px 0px 25px;
	padding-left: 20px;
	border: 1px solid rgba(221, 226, 232, 0.49)
}

.top_search .form-control:focus {
	border: 1px solid rgba(221, 226, 232, 0.49);
	border-right: 0
}

.top_search .input-group-btn button {
	border-radius: 0px 25px 25px 0px;
	border: 1px solid rgba(221, 226, 232, 0.49);
	border-left: 0;
	box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
	color: #93A2B2;
	margin-bottom: 0 !important
}

/* 06/29/2017 Paul.  Increase to 100px. */
.toggle {
	float: left;
	margin: 0;
	padding-top: 16px;
	width: 100px
}

.toggle a {
	padding: 15px 15px 0;
	margin: 0;
	cursor: pointer
}

.toggle a i {
	font-size: 26px
}

/* 04/24/2017 Paul.  Old color rgba(255, 255, 255, 0.75) */
/* 12/28/2017 Paul.  Dark menu */
.nav.child_menu > li > a {
	color: white;
	font-size: 12px;
	padding: 9px;
}

/* 06/29/2017 Paul.  Increase to 100px. */
.panel_toolbox {
	float: right;
	min-width: 100px
}

.panel_toolbox > li {
	float: left;
	cursor: pointer
}

.panel_toolbox > li > a {
	padding: 5px;
	color: #C5C7CB;
	font-size: 14px
}

.panel_toolbox > li > a:hover {
	background: #F5F7FA
}

/* 04/14/2017 Paul.  We want to use in sub panels. */
.subpanel_toolbox
{
	color: #C5C7CB;
}
.line_30 {
	line-height: 30px
}

.main_menu_side {
	padding: 0
}

.bs-docs-sidebar .nav > li > a {
	display: block;
	padding: 4px 6px
}

/* 04/25/2017 Paul.  Reduce top and bottom to 10. */
footer {
	background: #fff;
	padding: 5px 20px 20px 20px;
	display: block;
}

@media (min-width: 768px) {
	footer {
		margin-left: 230px
	}
}

/* 06/29/2017 Paul.  Increase to 100px. */
.nav-sm footer {
	margin-left: 100px
}

.footer_fixed footer {
	position: fixed;
	left: 0px;
	bottom: 0px;
	width: 100%
}

@media (min-width: 768px) {
	.footer_fixed footer {
		margin-left: 0
	}
}

@media (min-width: 768px) {
	.footer_fixed .nav-sm footer {
		margin-left: 0
	}
}

.tile-stats.sparkline {
	padding: 10px;
	text-align: center
}

.jqstooltip {
	background: #34495E !important;
	width: 30px !important;
	height: 22px !important;
	text-decoration: none
}

.tooltip {
	display: block !important
}

.tiles {
	border-top: 1px solid #ccc;
	margin-top: 15px;
	padding-top: 5px;
	margin-bottom: 0
}

.tile {
	overflow: hidden
}

.top_tiles {
	margin-bottom: 0
}

.top_tiles .tile h2 {
	font-size: 30px;
	line-height: 30px;
	margin: 3px 0 7px;
	font-weight: bold
}

article.media {
	width: 100%
}

*,
*:before,
*:after {
	box-sizing: border-box
}

#integration-list {
	width: 100%;
	margin: 0 auto;
	display: table
}

#integration-list ul {
	padding: 0;
	margin: 20px 0;
	color: #555
}

#integration-list ul > li {
	list-style: none;
	border-top: 1px solid #ddd;
	display: block;
	padding: 15px;
	overflow: hidden
}

#integration-list ul:last-child {
	border-bottom: 1px solid #ddd
}

#integration-list ul > li:hover {
	background: #efefef
}

.expand {
	display: block;
	text-decoration: none;
	color: #555;
	cursor: pointer
}

.expand h2 {
	width: 85%;
	float: left
}

h2 {
	font-size: 18px;
	font-weight: 400
}

#left,
#right {
	display: table
}

#sup {
	display: table-cell;
	vertical-align: middle;
	width: 80%
}

.detail a {
	text-decoration: none;
	color: #C0392B;
	border: 1px solid #C0392B;
	padding: 6px 10px 5px;
	font-size: 13px;
	margin-right: 7px
}

.detail {
	margin: 10px 0 10px 0px;
	display: none;
	line-height: 22px;
	height: 150px
}

.detail span {
	margin: 0
}

.right-arrow {
	width: 10px;
	float: right;
	font-weight: bold;
	font-size: 20px
}

.accordion .panel {
	margin-bottom: 5px;
	border-radius: 0;
	border-bottom: 1px solid #efefef
}

.accordion .panel-heading {
	background: #F2F5F7;
	padding: 13px;
	width: 100%;
	display: block
}

.accordion .panel:hover {
	background: #F2F5F7
}

.x_panel {
	position: relative;
	width: 100%;
	margin-bottom: 10px;
	padding: 10px 17px;
	display: inline-block;
	background: #fff;
	border: 1px solid #E6E9ED;
	-webkit-column-break-inside: avoid;
	-moz-column-break-inside: avoid;
	column-break-inside: avoid;
	opacity: 1;
	transition: all .2s ease
}

.x_title {
	border-bottom: 2px solid #E6E9ED;
	padding: 1px 5px 6px;
	margin-bottom: 10px
}

.x_title .filter {
	width: 40%;
	float: right
}

.x_title h2 {
	margin: 5px 0 6px;
	float: left;
	display: block;
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap
}

.x_title h2 small {
	margin-left: 10px
}

.x_title span {
	color: #BDBDBD
}

.x_content {
	padding: 0 5px 6px;
	position: relative;
	width: 100%;
	float: left;
	clear: both;
	margin-top: 5px
}

.x_content h4 {
	font-size: 16px;
	font-weight: 500
}

legend {
	padding-bottom: 7px
}

.demo-placeholder {
	height: 280px
}

.profile_details:nth-child(3n) {
	clear: both
}

.profile_details .profile_view {
	display: inline-block;
	padding: 10px 0 0;
	background: #fff
}

.profile_details .profile_view .divider {
	border-top: 1px solid #e5e5e5;
	padding-top: 5px;
	margin-top: 5px
}

.profile_details .profile_view .ratings {
	margin-bottom: 0
}

.profile_details .profile_view .bottom {
	background: #F2F5F7;
	padding: 9px 0;
	border-top: 1px solid #E6E9ED
}

.profile_details .profile_view .left {
	margin-top: 20px
}

.profile_details .profile_view .left p {
	margin-bottom: 3px
}

.profile_details .profile_view .right {
	margin-top: 0px;
	padding: 10px
}

.profile_details .profile_view .img-circle {
	border: 1px solid #E6E9ED;
	padding: 2px
}

.profile_details .profile_view h2 {
	margin: 5px 0
}

.profile_details .profile_view .ratings {
	text-align: left;
	font-size: 16px
}

.profile_details .profile_view .brief {
	margin: 0;
	font-weight: 300
}

.profile_details .profile_left {
	background: white
}

.pagination.pagination-split li {
	display: inline-block;
	margin-right: 3px
}

.pagination.pagination-split li a {
	border-radius: 4px;
	color: #768399;
	-moz-border-radius: 4px;
	-webkit-border-radius: 4px
}

table.tile h3,
table.tile h4,
table.tile span {
	font-weight: bold;
	vertical-align: middle !important
}

table.tile th,
table.tile td {
	text-align: center
}

table.tile th {
	border-bottom: 1px solid #E6ECEE
}

table.tile td {
	padding: 5px 0
}

table.tile td ul {
	text-align: left;
	padding-left: 0
}

table.tile td ul li {
	list-style: none;
	width: 100%
}

table.tile td ul li a {
	width: 100%
}

table.tile td ul li a big {
	right: 0;
	float: right;
	margin-right: 13px
}

table.tile_info {
	width: 100%
}

table.tile_info td {
	text-align: left;
	padding: 1px;
	font-size: 15px
}

table.tile_info td p {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	margin: 0;
	line-height: 28px
}

table.tile_info td i {
	margin-right: 8px;
	font-size: 17px;
	float: left;
	width: 18px;
	line-height: 28px
}

table.tile_info td:first-child {
	width: 83%
}

td span {
	line-height: 28px
}

.sidebar-widget {
	overflow: hidden
}

.error-number {
	font-size: 90px;
	line-height: 90px;
	margin: 20px 0
}

.col-middle {
	margin-top: 5%
}

.mid_center {
	width: 370px;
	margin: 0 auto;
	text-align: center;
	padding: 10px 20px
}

h3.degrees {
	font-size: 22px;
	font-weight: 400;
	text-align: center
}

.degrees:after {
	content: "o";
	position: relative;
	top: -12px;
	font-size: 13px;
	font-weight: 300
}

.daily-weather .day {
	font-size: 14px;
	border-top: 2px solid rgba(115, 135, 156, 0.36);
	text-align: center;
	border-bottom: 2px solid rgba(115, 135, 156, 0.36);
	padding: 5px 0
}

.weather-days .col-sm-2 {
	overflow: hidden;
	width: 16.66666667%
}

.weather .row {
	margin-bottom: 0
}

.bulk-actions {
	display: none
}

table.countries_list {
	width: 100%
}

table.countries_list td {
	padding: 0 10px;
	line-height: 30px;
	border-top: 1px solid #eeeeee
}

.dataTables_paginate a {
	padding: 6px 9px !important;
	background: #ddd !important;
	border-color: #ddd !important
}

.paging_full_numbers a.paginate_active {
	background-color: rgba(38, 185, 154, 0.59) !important;
	border-color: rgba(38, 185, 154, 0.59) !important
}

button.DTTT_button,
div.DTTT_button,
a.DTTT_button {
	border: 1px solid #E7E7E7 !important;
	background: #E7E7E7 !important;
	box-shadow: none !important
}

table.jambo_table {
	border: 1px solid rgba(221, 221, 221, 0.78)
}

table.jambo_table thead {
	background: rgba(52, 73, 94, 0.94);
	color: #ECF0F1
}

table.jambo_table tbody tr:hover td {
	background: rgba(38, 185, 154, 0.07);
	border-top: 1px solid rgba(38, 185, 154, 0.11);
	border-bottom: 1px solid rgba(38, 185, 154, 0.11)
}

table.jambo_table tbody tr.selected {
	background: rgba(38, 185, 154, 0.16)
}

table.jambo_table tbody tr.selected td {
	border-top: 1px solid rgba(38, 185, 154, 0.4);
	border-bottom: 1px solid rgba(38, 185, 154, 0.4)
}

.dataTables_paginate a {
	background: #ff0000
}

.dataTables_wrapper {
	position: relative;
	clear: both;
	zoom: 1
}

.dataTables_processing {
	position: absolute;
	top: 50%;
	left: 50%;
	width: 250px;
	height: 30px;
	margin-left: -125px;
	margin-top: -15px;
	padding: 14px 0 2px 0;
	border: 1px solid #ddd;
	text-align: center;
	color: #999;
	font-size: 14px;
	background-color: white
}

.dataTables_length {
	width: 40%;
	float: left
}

.dataTables_filter {
	width: 50%;
	float: right;
	text-align: right
}

.dataTables_info {
	width: 60%;
	float: left
}

.dataTables_paginate {
	float: right;
	text-align: right
}

table.dataTable th.focus,
table.dataTable td.focus {
	outline: 2px solid #1ABB9C !important;
	outline-offset: -1px
}

.paginate_disabled_previous,
.paginate_enabled_previous,
.paginate_disabled_next,
.paginate_enabled_next {
	height: 19px;
	float: left;
	cursor: pointer;
	color: #111 !important
}

.paginate_disabled_previous:hover,
.paginate_enabled_previous:hover,
.paginate_disabled_next:hover,
.paginate_enabled_next:hover {
	text-decoration: none !important
}

.paginate_disabled_previous:active,
.paginate_enabled_previous:active,
.paginate_disabled_next:active,
.paginate_enabled_next:active {
	outline: none
}

.paginate_disabled_previous,
.paginate_disabled_next {
	color: #666 !important
}

.paginate_disabled_previous,
.paginate_enabled_previous {
	padding-left: 23px
}

.paginate_disabled_next,
.paginate_enabled_next {
	padding-right: 23px;
	margin-left: 10px
}

table.display {
	margin: 0 auto;
	clear: both;
	width: 100%
}

table.display thead th {
	padding: 8px 18px 8px 10px;
	border-bottom: 1px solid black;
	font-weight: bold;
	cursor: pointer
}

table.display tfoot th {
	padding: 3px 18px 3px 10px;
	border-top: 1px solid black;
	font-weight: bold
}

table.display tr.heading2 td {
	border-bottom: 1px solid #aaa
}

table.display td {
	padding: 3px 10px
}

table.display td.center {
	text-align: center
}

table.display thead th:active,
table.display thead td:active {
	outline: none
}

.dataTables_scroll {
	clear: both
}

.dataTables_scrollBody {
	*margin-top: -1px;
	-webkit-overflow-scrolling: touch
}

.top .dataTables_info {
	float: none
}

.clear {
	clear: both
}

.dataTables_empty {
	text-align: center
}

tfoot input {
	margin: 0.5em 0;
	width: 100%;
	color: #444
}

tfoot input.search_init {
	color: #999
}

td.group {
	background-color: #d1cfd0;
	border-bottom: 2px solid #A19B9E;
	border-top: 2px solid #A19B9E
}

td.details {
	background-color: #d1cfd0;
	border: 2px solid #A19B9E
}

.example_alt_pagination div.dataTables_info {
	width: 40%
}

.paging_full_numbers {
	width: 400px;
	height: 22px;
	line-height: 22px
}

.paging_full_numbers a:active {
	outline: none
}

.paging_full_numbers a:hover {
	text-decoration: none
}

.paging_full_numbers a.paginate_button,
.paging_full_numbers a.paginate_active {
	border: 1px solid #aaa;
	-webkit-border-radius: 5px;
	-moz-border-radius: 5px;
	padding: 2px 5px;
	margin: 0 3px;
	cursor: pointer
}

.paging_full_numbers a.paginate_button {
	background-color: #ddd
}

.paging_full_numbers a.paginate_button:hover {
	background-color: #ccc;
	text-decoration: none !important
}

.paging_full_numbers a.paginate_active {
	background-color: #99B3FF
}

table.display tr.even.row_selected td {
	background-color: #B0BED9
}

table.display tr.odd.row_selected td {
	background-color: #9FAFD1
}

div.box {
	height: 100px;
	padding: 10px;
	overflow: auto;
	border: 1px solid #8080FF;
	background-color: #E5E5FF
}

ul.msg_list li {
	background: #f7f7f7;
	padding: 5px;
	display: -ms-flexbox;
	display: flex;
	margin: 6px 6px 0;
	width: 96% !important
}

ul.msg_list li:last-child {
	margin-bottom: 6px;
	padding: 10px
}

ul.msg_list li a {
	padding: 3px 5px !important
}

ul.msg_list li a .image img {
	border-radius: 2px 2px 2px 2px;
	-webkit-border-radius: 2px 2px 2px 2px;
	float: left;
	margin-right: 10px;
	width: 11%
}

ul.msg_list li a .time {
	font-size: 11px;
	font-style: italic;
	font-weight: bold;
	position: absolute;
	right: 35px
}

ul.msg_list li a .message {
	display: block !important;
	font-size: 11px
}

.dropdown-menu.msg_list span {
	white-space: normal
}

.dropdown-menu {
	border: medium none;
	box-shadow: none;
	display: none;
	float: left;
	font-size: 12px;
	left: 0;
	list-style: none outside none;
	padding: 0;
	position: absolute;
	text-shadow: none;
	top: 100%;
	z-index: 9998;
	border: 1px solid #D9DEE4;
	border-top-left-radius: 0;
	border-top-right-radius: 0
}

.dropdown-menu > li > a {
	color: #5A738E
}

.navbar-nav .open .dropdown-menu {
	position: absolute;
	background: #fff;
	margin-top: 0;
	border: 1px solid #D9DEE4;
	-webkit-box-shadow: none;
	right: 0;
	left: auto;
	width: 220px
}

.navbar-nav .open .dropdown-menu.msg_list {
	width: 300px
}

.info-number .badge {
	font-size: 10px;
	font-weight: normal;
	line-height: 13px;
	padding: 2px 6px;
	position: absolute;
	right: 2px;
	top: 8px
}

ul.to_do {
	padding: 0
}

ul.to_do li {
	background: #f3f3f3;
	border-radius: 3px;
	position: relative;
	padding: 7px;
	margin-bottom: 5px;
	list-style: none
}

ul.to_do p {
	margin: 0
}

.dashboard-widget {
	background: #f6f6f6;
	border-top: 5px solid #79C3DF;
	border-radius: 3px;
	padding: 5px 10px 10px
}

.dashboard-widget .dashboard-widget-title {
	font-weight: normal;
	border-bottom: 1px solid #c1cdcd;
	margin: 0 0 10px 0;
	padding-bottom: 5px;
	padding-left: 40px;
	line-height: 30px
}

.dashboard-widget .dashboard-widget-title i {
	font-size: 100%;
	margin-left: -35px;
	margin-right: 10px;
	color: #33a1c9;
	padding: 3px 6px;
	border: 1px solid #abd9ea;
	border-radius: 5px;
	background: #fff
}

ul.quick-list {
	width: 45%;
	padding-left: 0;
	display: inline-block
}

ul.quick-list li {
	padding-left: 10px;
	list-style: none;
	margin: 0;
	padding-bottom: 6px;
	padding-top: 4px;
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden
}

ul.quick-list li i {
	padding-right: 10px;
	color: #757679
}

.dashboard-widget-content {
	padding-top: 9px
}

.dashboard-widget-content .sidebar-widget {
	width: 50%;
	display: inline-block;
	vertical-align: top;
	background: #fff;
	border: 1px solid #abd9ea;
	border-radius: 5px;
	text-align: center;
	float: right;
	padding: 2px;
	margin-top: 10px
}

.widget_summary {
	width: 100%;
	display: -ms-inline-flexbox;
	display: inline-flex
}

.widget_summary .w_left {
	float: left;
	text-align: left
}

.widget_summary .w_center {
	float: left
}

.widget_summary .w_right {
	float: left;
	text-align: right
}

.widget_summary .w_right span {
	font-size: 20px
}

.w_20 {
	width: 20%
}

.w_25 {
	width: 25%
}

.w_55 {
	width: 55%
}

h5.graph_title {
	text-align: left;
	margin-left: 10px
}

h5.graph_title i {
	margin-right: 10px;
	font-size: 17px
}

span.right {
	float: right;
	font-size: 14px !important
}

.tile_info a {
	text-overflow: ellipsis
}

/* 04/24/2017 Paul.  Old background #2A3F54 */
/* 12/28/2017 Paul.  Dark menu */
.sidebar-footer {
	bottom: 0px;
	clear: both;
	display: block;
	padding: 5px 0 0 0;
	position: fixed;
	width: 230px;
	background: #64707B;
	color: white;
}

.sidebar-footer a {
	padding: 7px 0 3px;
	text-align: center;
	width: 25%;
	font-size: 17px;
	display: block;
	float: left;
	background: #172D44
}

.sidebar-footer a:hover {
	background: #425567
}

.tile_count {
	margin-bottom: 20px;
	margin-top: 20px
}

.tile_count .tile_stats_count {
	border-bottom: 1px solid #D9DEE4;
	padding: 0 10px 0 20px;
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
	position: relative
}

@media (min-width: 992px) {
	.tile_count .tile_stats_count {
		margin-bottom: 10px;
		border-bottom: 0;
		padding-bottom: 10px
	}
}

.tile_count .tile_stats_count:before {
	content: "";
	position: absolute;
	left: 0;
	height: 65px;
	border-left: 2px solid #ADB2B5;
	margin-top: 10px
}

@media (min-width: 992px) {
	.tile_count .tile_stats_count:first-child:before {
		border-left: 0
	}
}

.tile_count .tile_stats_count .count {
	font-size: 30px;
	line-height: 47px;
	font-weight: 600
}

@media (min-width: 768px) {
	.tile_count .tile_stats_count .count {
		font-size: 40px
	}
}

@media (min-width: 992px) and (max-width: 1100px) {
	.tile_count .tile_stats_count .count {
		font-size: 30px
	}
}

.tile_count .tile_stats_count span {
	font-size: 12px
}

@media (min-width: 768px) {
	.tile_count .tile_stats_count span {
		font-size: 13px
	}
}

.tile_count .tile_stats_count .count_bottom i {
	width: 12px
}

.dashboard_graph {
	background: #fff;
	padding: 7px 10px
}

.dashboard_graph .col-md-9,
.dashboard_graph .col-md-3 {
	padding: 0
}

a.user-profile {
	color: #5E6974 !important
}

.user-profile img {
	width: 29px;
	height: 29px;
	border-radius: 50%;
	margin-right: 10px
}

ul.top_profiles {
	height: 330px;
	width: 100%
}

ul.top_profiles li {
	margin: 0;
	padding: 3px 5px
}

ul.top_profiles li:nth-child(odd) {
	background-color: #eee
}

.media .profile_thumb {
	border: 1px solid;
	width: 50px;
	height: 50px;
	margin: 5px 10px 5px 0;
	border-radius: 50%;
	padding: 9px 12px
}

.media .profile_thumb i {
	font-size: 30px
}

.media .date {
	background: #ccc;
	width: 52px;
	margin-right: 10px;
	border-radius: 10px;
	padding: 5px
}

.media .date .month {
	margin: 0;
	text-align: center;
	color: #fff
}

.media .date .day {
	text-align: center;
	color: #fff;
	font-size: 27px;
	margin: 0;
	line-height: 27px;
	font-weight: bold
}

.event .media-body a.title {
	font-weight: bold
}

.event .media-body p {
	margin-bottom: 0
}

h4.graph_title {
	margin: 7px;
	text-align: center
}

.fontawesome-icon-list .fa-hover a:hover {
	background-color: #ddd;
	color: #fff;
	text-decoration: none
}

.fontawesome-icon-list .fa-hover a {
	display: block;
	line-height: 32px;
	height: 32px;
	padding-left: 10px;
	border-radius: 4px
}

.fontawesome-icon-list .fa-hover a:hover .fa {
	font-size: 28px;
	vertical-align: -6px
}

.fontawesome-icon-list .fa-hover a .fa {
	width: 32px;
	font-size: 16px;
	display: inline-block;
	text-align: right;
	margin-right: 10px
}

.main_menu .fa {
	width: 26px;
	opacity: .99;
	display: inline-block;
	font-family: FontAwesome;
	font-style: normal;
	font-weight: normal;
	font-size: 18px;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale
}

.tile-stats {
	position: relative;
	display: block;
	margin-bottom: 12px;
	border: 1px solid #E4E4E4;
	-webkit-border-radius: 5px;
	overflow: hidden;
	padding-bottom: 5px;
	-webkit-background-clip: padding-box;
	-moz-border-radius: 5px;
	-moz-background-clip: padding;
	border-radius: 5px;
	background-clip: padding-box;
	background: #FFF;
	transition: all 300ms ease-in-out
}

.tile-stats:hover .icon i {
	animation-name: tansformAnimation;
	animation-duration: .5s;
	animation-iteration-count: 1;
	color: rgba(58, 58, 58, 0.41);
	animation-timing-function: ease;
	animation-fill-mode: forwards;
	-webkit-animation-name: tansformAnimation;
	-webkit-animation-duration: .5s;
	-webkit-animation-iteration-count: 1;
	-webkit-animation-timing-function: ease;
	-webkit-animation-fill-mode: forwards;
	-moz-animation-name: tansformAnimation;
	-moz-animation-duration: .5s;
	-moz-animation-iteration-count: 1;
	-moz-animation-timing-function: ease;
	-moz-animation-fill-mode: forwards
}

.tile-stats .icon {
	width: 20px;
	height: 20px;
	color: #BAB8B8;
	position: absolute;
	right: 53px;
	top: 22px;
	z-index: 1
}

.tile-stats .icon i {
	margin: 0;
	font-size: 60px;
	line-height: 0;
	vertical-align: bottom;
	padding: 0
}

.tile-stats .count {
	font-size: 38px;
	font-weight: bold;
	line-height: 1.65857
}

.tile-stats .count,
.tile-stats h3,
.tile-stats p {
	position: relative;
	margin: 0;
	margin-left: 10px;
	z-index: 5;
	padding: 0
}

.tile-stats h3 {
	color: #BAB8B8
}

.tile-stats p {
	margin-top: 5px;
	font-size: 12px
}

.tile-stats > .dash-box-footer {
	position: relative;
	text-align: center;
	margin-top: 5px;
	padding: 3px 0;
	color: #fff;
	color: rgba(255, 255, 255, 0.8);
	display: block;
	z-index: 10;
	background: rgba(0, 0, 0, 0.1);
	text-decoration: none
}

.tile-stats > .dash-box-footer:hover {
	color: #fff;
	background: rgba(0, 0, 0, 0.15)
}

.tile-stats > .dash-box-footer:hover {
	color: #fff;
	background: rgba(0, 0, 0, 0.15)
}

table.tile_info {
	padding: 10px 15px
}

table.tile_info span.right {
	margin-right: 0;
	float: right;
	position: absolute;
	right: 4%
}

.tile:hover {
	text-decoration: none
}

.tile_header {
	border-bottom: transparent;
	padding: 7px 15px;
	margin-bottom: 15px;
	background: #E7E7E7
}

.tile_head h4 {
	margin-top: 0;
	margin-bottom: 5px
}

.tiles-bottom {
	padding: 5px 10px;
	margin-top: 10px;
	background: rgba(194, 194, 194, 0.3);
	text-align: left
}

a.star {
	color: #428bca !important
}

.mail_content {
	background: none repeat scroll 0 0 #FFFFFF;
	border-radius: 4px;
	margin-top: 20px;
	min-height: 500px;
	padding: 10px 11px;
	width: 100%
}

.list-btn-mail {
	margin-bottom: 15px
}

.list-btn-mail.active {
	border-bottom: 1px solid #39B3D7;
	padding: 0 0 14px
}

.list-btn-mail > i {
	float: left;
	font-size: 18px;
	font-style: normal;
	width: 33px
}

.list-btn-mail > .cn {
	background: none repeat scroll 0 0 #39B3D7;
	border-radius: 12px;
	color: #FFFFFF;
	float: right;
	font-style: normal;
	padding: 0 5px
}

.button-mail {
	margin: 0 0 15px !important;
	text-align: left;
	width: 100%
}

/* 05/31/2017 Paul.  margin-right to 0 */
.buttons,
button,
.btn {
	margin-bottom: 5px;
	margin-right: 0px
}

.btn-group-vertical .btn,
.btn-group .btn {
	margin-bottom: 0;
	margin-right: 0
}

.mail_list_column {
	border-left: 1px solid #DBDBDB
}

.mail_view {
	border-left: 1px solid #DBDBDB
}

.mail_list {
	width: 100%;
	border-bottom: 1px solid #DBDBDB;
	margin-bottom: 2px;
	display: inline-block
}

.mail_list .left {
	width: 5%;
	float: left;
	margin-right: 3%
}

.mail_list .right {
	width: 90%;
	float: left
}

.mail_list h3 {
	font-size: 15px;
	font-weight: bold;
	margin: 0px 0 6px
}

.mail_list h3 small {
	float: right;
	color: #ADABAB;
	font-size: 11px;
	line-height: 20px
}

.mail_list .badge {
	padding: 3px 6px;
	font-size: 8px;
	background: #BAB7B7
}

@media (max-width: 767px) {
	.mail_list {
		margin-bottom: 5px;
		display: inline-block
	}
}

.mail_heading h4 {
	font-size: 18px;
	border-bottom: 1px solid #ddd;
	padding-bottom: 10px;
	margin-top: 20px
}

.attachment {
	margin-top: 30px
}

.attachment ul {
	width: 100%;
	list-style: none;
	padding-left: 0;
	display: inline-block;
	margin-bottom: 30px
}

.attachment ul li {
	float: left;
	width: 150px;
	margin-right: 10px;
	margin-bottom: 10px
}

.attachment ul li img {
	height: 150px;
	border: 1px solid #ddd;
	padding: 5px;
	margin-bottom: 10px
}

.attachment ul li span {
	float: right
}

.attachment .file-name {
	float: left
}

.attachment .links {
	width: 100%;
	display: inline-block
}

.compose {
	padding: 0;
	position: fixed;
	bottom: 0;
	right: 0;
	background: #fff;
	border: 1px solid #D9DEE4;
	border-right: 0;
	border-bottom: 0;
	border-top-left-radius: 5px;
	z-index: 9999;
	display: none
}

.compose .compose-header {
	padding: 5px;
	background: #169F85;
	color: #fff;
	border-top-left-radius: 5px
}

.compose .compose-header .close {
	text-shadow: 0 1px 0 #ffffff;
	line-height: .8
}

.compose .compose-body .editor.btn-toolbar {
	margin: 0
}

.compose .compose-body .editor-wrapper {
	height: 100%;
	min-height: 50px;
	max-height: 180px;
	border-radius: 0;
	border-left: none;
	border-right: none;
	overflow: auto
}

.compose .compose-footer {
	padding: 10px
}

.editor.btn-toolbar {
	zoom: 1;
	background: #F7F7F7;
	margin: 5px 2px;
	padding: 3px 0;
	border: 1px solid #EFEFEF
}

.input-group {
	margin-bottom: 10px
}

.ln_solid {
	border-top: 1px solid #e5e5e5;
	color: #ffffff;
	background-color: #ffffff;
	height: 1px;
	margin: 20px 0
}

span.section {
	display: block;
	width: 100%;
	padding: 0;
	margin-bottom: 20px;
	font-size: 21px;
	line-height: inherit;
	color: #333;
	border: 0;
	border-bottom: 1px solid #e5e5e5
}

.form-control {
	border-radius: 0;
	width: 100%
}

.form-horizontal .control-label {
	padding-top: 8px
}

.form-control:focus {
	border-color: #CCD0D7;
	box-shadow: none !important
}

legend {
	font-size: 18px;
	color: inherit
}

.form-horizontal .form-group {
	margin-right: 0;
	margin-left: 0
}

.form-control-feedback {
	margin-top: 8px;
	height: 23px;
	color: #bbb;
	line-height: 24px;
	font-size: 15px
}

.form-control-feedback.left {
	border-right: 1px solid #ccc;
	left: 13px
}

.form-control-feedback.right {
	border-left: 1px solid #ccc;
	right: 13px
}

.form-control.has-feedback-left {
	padding-left: 45px
}

.form-control.has-feedback-right {
	padding-right: 45px
}

.form-group {
	margin-bottom: 10px
}

.validate {
	margin-top: 10px
}

.invalid-form-error-message {
	margin-top: 10px;
	padding: 5px
}

.invalid-form-error-message.filled {
	border-left: 2px solid #E74C3C
}

p.parsley-success {
	color: #468847;
	background-color: #DFF0D8;
	border: 1px solid #D6E9C6
}

p.parsley-error {
	color: #B94A48;
	background-color: #F2DEDE;
	border: 1px solid #EED3D7
}

ul.parsley-errors-list {
	list-style: none;
	color: #E74C3C;
	padding-left: 0
}

input.parsley-error,
textarea.parsley-error,
select.parsley-error {
	background: #FAEDEC;
	border: 1px solid #E85445
}

.btn-group .parsley-errors-list {
	display: none
}

.bad input,
.bad select,
.bad textarea {
	border: 1px solid #CE5454;
	box-shadow: 0 0 4px -2px #CE5454;
	position: relative;
	left: 0;
	-moz-animation: .7s 1 shake linear;
	-webkit-animation: 0.7s 1 shake linear
}

.item input,
.item textarea {
	transition: 0.42s
}

.item .alert {
	float: left;
	margin: 0 0 0 20px;
	padding: 3px 10px;
	color: #FFF;
	border-radius: 3px 4px 4px 3px;
	background-color: #CE5454;
	max-width: 170px;
	white-space: pre;
	position: relative;
	left: -15px;
	opacity: 0;
	z-index: 1;
	transition: 0.15s ease-out
}

.item .alert::after {
	content: '';
	display: block;
	height: 0;
	width: 0;
	border-color: transparent #CE5454 transparent transparent;
	border-style: solid;
	border-width: 11px 7px;
	position: absolute;
	left: -13px;
	top: 1px
}

.item.bad .alert {
	left: 0;
	opacity: 1
}

.inl-bl {
	display: inline-block
}

.well .markup {
	background: #fff;
	color: #777;
	position: relative;
	padding: 45px 15px 15px;
	margin: 15px 0 0 0;
	background-color: #fff;
	border-radius: 0 0 4px 4px;
	box-shadow: none
}

.well .markup::after {
	content: "Example";
	position: absolute;
	top: 15px;
	left: 15px;
	font-size: 12px;
	font-weight: bold;
	color: #bbb;
	text-transform: uppercase;
	letter-spacing: 1px
}

.autocomplete-suggestions {
	border: 1px solid #e4e4e4;
	background: #F4F4F4;
	cursor: default;
	overflow: auto
}

.autocomplete-suggestion {
	padding: 2px 5px;
	font-size: 1.2em;
	white-space: nowrap;
	overflow: hidden
}

.autocomplete-selected {
	background: #f0f0f0
}

.autocomplete-suggestions strong {
	font-weight: normal;
	color: #3399ff;
	font-weight: bolder
}

.btn {
	border-radius: 3px
}

a.btn-success,
a.btn-primary,
a.btn-warning,
a.btn-danger {
	color: #fff
}

.btn-success {
	background: #26B99A;
	border: 1px solid #169F85
}

.btn-success:hover,
.btn-success:focus,
.btn-success:active,
.btn-success.active,
.open .dropdown-toggle.btn-success {
	background: #169F85
}

.btn-dark {
	color: #E9EDEF;
	background-color: #4B5F71;
	border-color: #364B5F
}

.btn-dark:hover,
.btn-dark:focus,
.btn-dark:active,
.btn-dark.active,
.open .dropdown-toggle.btn-dark {
	color: #FFFFFF;
	background-color: #394D5F;
	border-color: #394D5F
}

.btn-round {
	border-radius: 30px
}

.btn.btn-app {
	position: relative;
	padding: 15px 5px;
	margin: 0 0 10px 10px;
	min-width: 80px;
	height: 60px;
	box-shadow: none;
	border-radius: 0;
	text-align: center;
	color: #666;
	border: 1px solid #ddd;
	background-color: #fafafa;
	font-size: 12px
}

.btn.btn-app > .fa,
.btn.btn-app > .glyphicon,
.btn.btn-app > .ion {
	font-size: 20px;
	display: block
}

.btn.btn-app:hover {
	background: #f4f4f4;
	color: #444;
	border-color: #aaa
}

.btn.btn-app:active,
.btn.btn-app:focus {
	box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125)
}

.btn.btn-app > .badge {
	position: absolute;
	top: -3px;
	right: -10px;
	font-size: 10px;
	font-weight: 400
}

/* 02/16/2020 Paul.  padding: 10px is terrible. */
textarea {
	vertical-align: top;
	width: 200px
}

textarea:focus {
	outline-style: solid;
	outline-width: 2px
}

.btn_ {
	display: inline-block;
	padding: 3px 9px;
	margin-bottom: 0;
	font-size: 14px;
	line-height: 20px;
	text-align: center;
	vertical-align: middle;
	cursor: pointer;
	color: #333333;
	text-shadow: 0 1px 1px rgba(255, 255, 255, 0.75);
	background-color: #f5f5f5;
	background-image: linear-gradient(to bottom, #fff, #e6e6e6);
	background-repeat: repeat-x;
	filter: progid: DXImageTransform.Microsoft.gradient(startColorstr='#ffffffff', endColorstr='#ffe6e6e6', GradientType=0);
	border-color: #e6e6e6 #e6e6e6 #bfbfbf;
	border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);
	filter: progid: DXImageTransform.Microsoft.gradient(enabled=false);
	border: 1px solid #cccccc;
	border-bottom-color: #b3b3b3;
	border-radius: 4px;
	box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2), 0 1px 2px rgba(0, 0, 0, 0.05)
}

.bs-glyphicons {
	margin: 0 -10px 20px;
	overflow: hidden
}

.bs-glyphicons-list {
	padding-left: 0;
	list-style: none
}

.bs-glyphicons li {
	float: left;
	width: 25%;
	height: 115px;
	padding: 10px;
	font-size: 10px;
	line-height: 1.4;
	text-align: center;
	background-color: #f9f9f9;
	border: 1px solid #fff
}

.bs-glyphicons .glyphicon {
	margin-top: 5px;
	margin-bottom: 10px;
	font-size: 24px
}

.bs-glyphicons .glyphicon-class {
	display: block;
	text-align: center;
	word-wrap: break-word
}

.bs-glyphicons li:hover {
	color: #fff;
	background-color: #1ABB9C
}

@media (min-width: 768px) {
	.bs-glyphicons {
		margin-right: 0;
		margin-left: 0
	}
	.bs-glyphicons li {
		width: 12.5%;
		font-size: 12px
	}
}

.tagsinput {
	border: 1px solid #CCC;
	background: #FFF;
	padding: 6px 6px 0;
	width: 300px;
	overflow-y: auto
}

span.tag {
	-moz-border-radius: 2px;
	-webkit-border-radius: 2px;
	display: block;
	float: left;
	padding: 5px 9px;
	text-decoration: none;
	background: #1ABB9C;
	color: #F1F6F7;
	margin-right: 5px;
	font-weight: 500;
	margin-bottom: 5px;
	font-family: helvetica
}

span.tag a {
	color: #F1F6F7 !important
}

.tagsinput span.tag a {
	font-weight: bold;
	color: #82ad2b;
	text-decoration: none;
	font-size: 11px
}

.tagsinput input {
	width: 80px;
	margin: 0px;
	font-family: helvetica;
	font-size: 13px;
	border: 1px solid transparent;
	padding: 3px;
	background: transparent;
	color: #000;
	outline: 0px
}

.tagsinput div {
	display: block;
	float: left
}

.tags_clear {
	clear: both;
	width: 100%;
	height: 0px
}

.not_valid {
	background: #FBD8DB !important;
	color: #90111A !important
}

ul.bar_tabs {
	overflow: visible;
	background: #F5F7FA;
	height: 25px;
	margin: 21px 0 14px;
	padding-left: 14px;
	position: relative;
	z-index: 1;
	width: 100%;
	border-bottom: 1px solid #E6E9ED
}

ul.bar_tabs > li {
	border: 1px solid #E6E9ED;
	color: #333 !important;
	margin-top: -17px;
	margin-left: 8px;
	background: #fff;
	border-bottom: none;
	border-radius: 4px 4px 0 0
}

ul.bar_tabs > li.active {
	border-right: 6px solid #D3D6DA;
	border-top: 0;
	margin-top: -15px
}

ul.bar_tabs > li a {
	padding: 10px 17px;
	background: #F5F7FA;
	margin: 0;
	border-top-right-radius: 0
}

ul.bar_tabs > li a:hover {
	border: 1px solid transparent
}

ul.bar_tabs > li.active a {
	border-bottom: none
}

ul.bar_tabs.right {
	padding-right: 14px
}

ul.bar_tabs.right li {
	float: right
}

a:focus {
	outline: none
}

ul.timeline li {
	position: relative;
	border-bottom: 1px solid #e8e8e8;
	clear: both
}

.timeline .block {
	margin: 0;
	border-left: 3px solid #e8e8e8;
	overflow: visible;
	padding: 10px 15px;
	margin-left: 105px
}

.timeline.widget {
	min-width: 0;
	max-width: inherit
}

.timeline.widget .block {
	margin-left: 5px
}

.timeline .tags {
	position: absolute;
	top: 15px;
	left: 0;
	width: 84px
}

.timeline .tag {
	display: block;
	height: 30px;
	font-size: 13px;
	padding: 8px
}

.timeline .tag span {
	display: block;
	overflow: hidden;
	width: 100%;
	white-space: nowrap;
	text-overflow: ellipsis
}

.tag {
	line-height: 1;
	background: #1ABB9C;
	color: #fff !important
}

.tag:after {
	content: " ";
	height: 30px;
	width: 0;
	position: absolute;
	left: 100%;
	top: 0;
	margin: 0;
	pointer-events: none;
	border-top: 14px solid transparent;
	border-bottom: 14px solid transparent;
	border-left: 11px solid #1ABB9C
}

.timeline h2.title {
	position: relative;
	font-size: 16px;
	margin: 0
}

.timeline h2.title:before {
	content: "";
	position: absolute;
	left: -23px;
	top: 3px;
	display: block;
	width: 14px;
	height: 14px;
	border: 3px solid #d2d3d2;
	border-radius: 14px;
	background: #f9f9f9
}

.timeline .byline {
	padding: .25em 0
}

.byline {
	-webkit-font-smoothing: antialiased;
	font-style: italic;
	font-size: .9375em;
	line-height: 1.3;
	color: #aab6aa
}

ul.social li {
	border: 0
}

.social-sidebar,
.social-body {
	float: right
}

.social-sidebar {
	background: #EDEDED;
	width: 22%
}

.social-body {
	border: 1px solid #ccc;
	width: 78%
}

.thumb img {
	width: 50px;
	height: 50px;
	border-radius: 50%
}

.chat .thumb img {
	width: 27px;
	height: 27px;
	border-radius: 50%
}

.chat .status {
	float: left;
	margin: 16px 0 0 -16px;
	font-size: 14px;
	font-weight: bold;
	width: 12px;
	height: 12px;
	display: block;
	border: 2px solid #FFF;
	z-index: 12312;
	border-radius: 50%
}

.chat .status.online {
	background: #1ABB9C
}

.chat .status.away {
	background: #F39C12
}

.chat .status.offline {
	background: #ccc
}

.chat .media-body {
	padding-top: 5px
}

.dashboard_graph .x_title {
	padding: 5px 5px 7px
}

.dashboard_graph .x_title h3 {
	margin: 0;
	font-weight: normal
}

.chart {
	position: relative;
	display: inline-block;
	width: 110px;
	height: 110px;
	margin-top: 5px;
	margin-bottom: 5px;
	text-align: center
}

.chart canvas {
	position: absolute;
	top: 0;
	left: 0
}

.percent {
	display: inline-block;
	line-height: 110px;
	z-index: 2;
	font-size: 18px
}

.percent:after {
	content: '%';
	margin-left: 0.1em;
	font-size: .8em
}

.angular {
	margin-top: 100px
}

.angular .chart {
	margin-top: 0
}

.widget {
	min-width: 250px;
	max-width: 310px
}

.widget_tally_box .btn-group button {
	text-align: center
}

.widget_tally_box .btn-group button {
	color: inherit;
	font-weight: 500;
	background-color: #f5f5f5;
	border: 1px solid #e7e7e7
}

ul.widget_tally,
ul.widget_tally li {
	width: 100%
}

ul.widget_tally li {
	padding: 2px 10px;
	border-bottom: 1px solid #ECECEC;
	padding-bottom: 4px
}

ul.widget_tally .month {
	width: 70%;
	float: left
}

ul.widget_tally .count {
	width: 30%;
	float: left;
	text-align: right
}

.pie_bg {
	border-bottom: 1px solid rgba(101, 204, 182, 0.16);
	padding-bottom: 15px;
	border-radius: 4px;
	filter: progid: DXImageTransform.Microsoft.gradient(startColorstr='#ffffffff', endColorstr='#ffe6e6e6', GradientType=0);
	filter: progid: DXImageTransform.Microsoft.gradient(enabled=false);
	padding-bottom: 10px;
	box-shadow: 0 4px 6px -6px #222
}

.widget_tally_box .flex {
	display: -ms-flexbox;
	display: flex
}

ul.widget_profile_box {
	width: 100%;
	height: 42px;
	padding: 3px;
	background: #ececec;
	margin-top: 40px;
	margin-left: 1px
}

ul.widget_profile_box li:first-child {
	width: 25%;
	float: left
}

ul.widget_profile_box li:first-child a {
	float: left
}

ul.widget_profile_box li:last-child {
	width: 25%;
	float: right
}

ul.widget_profile_box li:last-child a {
	float: right
}

ul.widget_profile_box li a {
	font-size: 22px;
	text-align: center;
	width: 35px;
	height: 35px;
	border: 1px solid rgba(52, 73, 94, 0.44);
	display: block;
	border-radius: 50%;
	padding: 0px
}

ul.widget_profile_box li a:hover {
	color: #1ABB9C !important;
	border: 1px solid #26b99a
}

ul.widget_profile_box li .profile_img {
	width: 85px;
	height: 85px;
	margin: 0;
	margin-top: -28px
}

.widget_tally_box p,
.widget_tally_box span {
	text-align: center
}

.widget_tally_box .name {
	text-align: center;
	margin: 25px
}

.widget_tally_box .name_title {
	text-align: center;
	margin: 5px
}

.widget_tally_box ul.legend {
	margin: 0
}

.widget_tally_box ul.legend p,
.widget_tally_box ul.legend span {
	text-align: left
}

.widget_tally_box ul.legend li .icon {
	font-size: 20px;
	float: left;
	width: 14px
}

.widget_tally_box ul.legend li .name {
	font-size: 14px;
	margin: 5px 0 0 14px;
	text-overflow: ellipsis;
	float: left
}

.widget_tally_box ul.legend p {
	display: inline-block;
	margin: 0
}

.widget_tally_box ul.verticle_bars li {
	height: 140px;
	width: 23%
}

.widget .verticle_bars li .progress.vertical.progress_wide {
	width: 65%
}

ul.count2 {
	width: 100%;
	margin-left: 1px;
	border: 1px solid #ddd;
	border-left: 0;
	border-right: 0;
	padding: 10px 0
}

ul.count2 li {
	width: 30%;
	text-align: center
}

ul.count2 li h3 {
	font-weight: 400;
	margin: 0
}

ul.count2 li span {
	font-weight: 300
}

.divider {
	border-bottom: 1px solid #ddd;
	margin: 10px
}

.divider-dashed {
	border-top: 1px dashed #e7eaec;
	background-color: #ffffff;
	height: 1px;
	margin: 10px 0
}

ul.messages {
	padding: 0;
	list-style: none
}

ul.messages li,
.tasks li {
	border-bottom: 1px dotted #e6e6e6;
	padding: 8px 0
}

ul.messages li img.avatar,
img.avatar {
	height: 32px;
	width: 32px;
	float: left;
	display: inline-block;
	border-radius: 2px;
	padding: 2px;
	background: #f7f7f7;
	border: 1px solid #e6e6e6
}

ul.messages li .message_date {
	float: right;
	text-align: right
}

ul.messages li .message_wrapper {
	margin-left: 50px;
	margin-right: 40px
}

ul.messages li .message_wrapper h4.heading {
	font-weight: 600;
	margin: 0;
	cursor: pointer;
	margin-bottom: 10px;
	line-height: 100%
}

ul.messages li .message_wrapper blockquote {
	padding: 0px 10px;
	margin: 0;
	border-left: 5px solid #eee
}

ul.user_data li {
	margin-bottom: 6px
}

ul.user_data li p {
	margin-bottom: 0
}

ul.user_data li .progress {
	width: 90%
}

.project_progress .progress {
	margin-bottom: 3px !important;
	margin-top: 5px
}

.projects .list-inline {
	margin: 0
}

.profile_title {
	background: #F5F7FA;
	border: 0;
	padding: 7px 0;
	display: -ms-flexbox;
	display: flex
}

ul.stats-overview {
	border-bottom: 1px solid #e8e8e8;
	padding-bottom: 10px;
	margin-bottom: 10px
}

ul.stats-overview li {
	display: inline-block;
	text-align: center;
	padding: 0 15px;
	width: 30%;
	font-size: 14px;
	border-right: 1px solid #e8e8e8
}

ul.stats-overview li:last-child {
	border-right: 0
}

ul.stats-overview li .name {
	font-size: 12px
}

ul.stats-overview li .value {
	font-size: 14px;
	font-weight: bold;
	display: block
}

ul.stats-overview li:first-child {
	padding-left: 0
}

ul.project_files li {
	margin-bottom: 5px
}

ul.project_files li a i {
	width: 20px
}

.project_detail p {
	margin-bottom: 10px
}

.project_detail p.title {
	font-weight: bold;
	margin-bottom: 0
}

.avatar img {
	border-radius: 50%;
	max-width: 45px
}

.pricing {
	background: #fff
}

.pricing .title {
	background: #1ABB9C;
	height: 110px;
	color: #fff;
	padding: 15px 0 0;
	text-align: center
}

.pricing .title h2 {
	text-transform: capitalize;
	font-size: 18px;
	border-radius: 5px 5px 0 0;
	margin: 0;
	font-weight: 400
}

.pricing .title h1 {
	font-size: 30px;
	margin: 12px
}

.pricing .title span {
	background: rgba(51, 51, 51, 0.28);
	padding: 2px 5px
}

.pricing_features {
	background: #FAFAFA;
	padding: 20px 15px;
	min-height: 230px;
	font-size: 13.5px
}

.pricing_features ul li {
	margin-top: 10px
}

.pricing_footer {
	padding: 10px 15px;
	background-color: #f5f5f5;
	border-top: 1px solid #ddd;
	text-align: center;
	border-bottom-right-radius: 3px;
	border-bottom-left-radius: 3px
}

.pricing_footer p {
	font-size: 13px;
	padding: 10px 0 2px;
	display: block
}

.ui-ribbon-container {
	position: relative
}

.ui-ribbon-container .ui-ribbon-wrapper {
	position: absolute;
	overflow: hidden;
	width: 85px;
	height: 88px;
	top: -3px;
	right: -3px
}

.ui-ribbon-container.ui-ribbon-primary .ui-ribbon {
	background-color: #5b90bf
}

.ui-ribbon-container .ui-ribbon {
	position: relative;
	display: block;
	text-align: center;
	font-size: 15px;
	font-weight: 700;
	color: #fff;
	transform: rotate(45deg);
	padding: 7px 0;
	left: -5px;
	top: 15px;
	width: 120px;
	line-height: 20px;
	background-color: #555;
	box-shadow: 0 0 3px rgba(0, 0, 0, 0.3)
}

.ui-ribbon-container.ui-ribbon-primary .ui-ribbon:after,
.ui-ribbon-container.ui-ribbon-primary .ui-ribbon:before {
	border-top: 2px solid #5b90bf
}

.ui-ribbon-container .ui-ribbon:before {
	left: 0;
	bottom: -1px
}

.ui-ribbon-container .ui-ribbon:before {
	right: 0
}

.ui-ribbon-container .ui-ribbon:after,
.ui-ribbon-container .ui-ribbon:before {
	position: absolute;
	content: " ";
	line-height: 0;
	border-top: 2px solid #555;
	border-left: 2px solid transparent;
	border-right: 2px solid transparent
}

.thumbnail .image {
	height: 120px;
	overflow: hidden
}

.caption {
	padding: 9px 5px;
	background: #F7F7F7
}

.caption p {
	margin-bottom: 5px
}

.thumbnail {
	height: 190px;
	overflow: hidden
}

.view {
	overflow: hidden;
	position: relative;
	text-align: center;
	box-shadow: 1px 1px 2px #e6e6e6;
	cursor: default
}

.view .mask,
.view .content {
	position: absolute;
	width: 100%;
	overflow: hidden;
	top: 0;
	left: 0
}

.view img {
	display: block;
	position: relative
}

.view .tools {
	text-transform: uppercase;
	color: #fff;
	text-align: center;
	position: relative;
	font-size: 17px;
	padding: 3px;
	background: rgba(0, 0, 0, 0.35);
	margin: 43px 0 0 0
}

.mask.no-caption .tools {
	margin: 90px 0 0 0
}

.view .tools a {
	display: inline-block;
	color: #FFF;
	font-size: 18px;
	font-weight: 400;
	padding: 0 4px
}

.view p {
	font-family: Georgia, serif;
	font-style: italic;
	font-size: 12px;
	position: relative;
	color: #fff;
	padding: 10px 20px 20px;
	text-align: center
}

.view a.info {
	display: inline-block;
	text-decoration: none;
	padding: 7px 14px;
	background: #000;
	color: #fff;
	text-transform: uppercase;
	box-shadow: 0 0 1px #000
}

.view-first img {
	transition: all 0.2s linear
}

.view-first .mask {
	opacity: 0;
	background-color: rgba(0, 0, 0, 0.5);
	transition: all 0.4s ease-in-out
}

.view-first .tools {
	transform: translateY(-100px);
	opacity: 0;
	transition: all 0.2s ease-in-out
}

.view-first p {
	transform: translateY(100px);
	opacity: 0;
	transition: all 0.2s linear
}

.view-first:hover img {
	transform: scale(1.1)
}

.view-first:hover .mask {
	opacity: 1
}

.view-first:hover .tools,
.view-first:hover p {
	opacity: 1;
	transform: translateY(0px)
}

.view-first:hover p {
	transition-delay: 0.1s
}


/*!
	* bootstrap-vertical-tabs - v1.2.1
	* https://dbtek.github.io/bootstrap-vertical-tabs
	* 2014-11-07
	* Copyright (c) 2014 İsmail Demirbilek
	* License: MIT
	*/

.tabs-left,
.tabs-right {
	border-bottom: none;
	padding-top: 2px
}

.tabs-left {
	border-right: 1px solid #F7F7F7
}

.tabs-right {
	border-left: 1px solid #F7F7F7
}

.tabs-left > li,
.tabs-right > li {
	float: none;
	margin-bottom: 2px
}

.tabs-left > li {
	margin-right: -1px
}

.tabs-right > li {
	margin-left: -1px
}

.tabs-left > li.active > a,
.tabs-left > li.active > a:hover,
.tabs-left > li.active > a:focus {
	border-bottom-color: #F7F7F7;
	border-right-color: transparent
}

.tabs-right > li.active > a,
.tabs-right > li.active > a:hover,
.tabs-right > li.active > a:focus {
	border-bottom: 1px solid #F7F7F7;
	border-left-color: transparent
}

.tabs-left > li > a {
	border-radius: 4px 0 0 4px;
	margin-right: 0;
	display: block;
	background: #F7F7F7;
	text-overflow: ellipsis;
	overflow: hidden
}

.tabs-right > li > a {
	border-radius: 0 4px 4px 0;
	margin-right: 0;
	background: #F7F7F7;
	text-overflow: ellipsis;
	overflow: hidden
}

.sideways {
	margin-top: 50px;
	border: none;
	position: relative
}

.sideways > li {
	height: 20px;
	width: 120px;
	margin-bottom: 100px
}

.sideways > li > a {
	border-bottom: 1px solid #ddd;
	border-right-color: transparent;
	text-align: center;
	border-radius: 4px 4px 0px 0px
}

.sideways > li.active > a,
.sideways > li.active > a:hover,
.sideways > li.active > a:focus {
	border-bottom-color: transparent;
	border-right-color: #ddd;
	border-left-color: #ddd
}

.sideways.tabs-left {
	left: -50px
}

.sideways.tabs-right {
	right: -50px
}

.sideways.tabs-right > li {
	transform: rotate(90deg)
}

.sideways.tabs-left > li {
	transform: rotate(-90deg)
}

.avatar-view {
	display: block;
	border: 3px solid #fff;
	border-radius: 5px;
	box-shadow: 0 0 5px rgba(0, 0, 0, 0.15);
	cursor: pointer;
	overflow: hidden
}

.avatar-body {
	padding-right: 15px;
	padding-left: 15px
}

.avatar-upload {
	overflow: hidden
}

.avatar-upload label {
	display: block;
	float: left;
	clear: left;
	width: 100px
}

.avatar-upload input {
	display: block;
	margin-left: 110px
}

.avater-alert {
	margin-top: 10px;
	margin-bottom: 10px
}

.avatar-wrapper {
	height: 364px;
	width: 100%;
	margin-top: 15px;
	box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.25);
	background-color: #fcfcfc;
	overflow: hidden
}

.avatar-wrapper img {
	display: block;
	height: auto;
	max-width: 100%
}

.avatar-preview {
	float: left;
	margin-top: 15px;
	margin-right: 15px;
	border: 1px solid #eee;
	border-radius: 4px;
	background-color: #fff;
	overflow: hidden
}

.avatar-preview:hover {
	border-color: #ccf;
	box-shadow: 0 0 5px rgba(0, 0, 0, 0.15)
}

.avatar-preview img {
	width: 100%
}

.preview-lg {
	height: 184px;
	width: 184px;
	margin-top: 15px
}

.preview-md {
	height: 100px;
	width: 100px
}

.preview-sm {
	height: 50px;
	width: 50px
}

@media (min-width: 992px) {
	.avatar-preview {
		float: none
	}
}

.avatar-btns {
	margin-top: 30px;
	margin-bottom: 15px
}

.avatar-btns .btn-group {
	margin-right: 5px
}

.loading {
	display: none;
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center;
	opacity: .75;
	filter: alpha(opacity=75);
	z-index: 20140628
}

.morris-hover {
	position: absolute;
	z-index: 1000
}

.morris-hover.morris-default-style {
	padding: 6px;
	color: #666;
	background: rgba(243, 242, 243, 0.8);
	border: solid 2px rgba(195, 194, 196, 0.8);
	font-family: sans-serif;
	font-size: 12px;
	text-align: center
}

.morris-hover.morris-default-style .morris-hover-row-label {
	font-weight: bold;
	margin: 0.25em 0
}

.morris-hover.morris-default-style .morris-hover-point {
	white-space: nowrap;
	margin: 0.1em 0
}

.price {
	font-size: 40px;
	font-weight: 400;
	color: #26B99A;
	margin: 0
}

.prod_title {
	border-bottom: 1px solid #DFDFDF;
	padding-bottom: 5px;
	margin: 30px 0;
	font-size: 20px;
	font-weight: 400
}

.product-image img {
	width: 90%
}

.prod_color li {
	margin: 0 10px
}

.prod_color li p {
	margin-bottom: 0
}

.prod_size li {
	padding: 0
}

.prod_color .color {
	width: 25px;
	height: 25px;
	border: 2px solid rgba(51, 51, 51, 0.28) !important;
	padding: 2px;
	border-radius: 50px
}

.product_gallery a {
	width: 100px;
	height: 100px;
	float: left;
	margin: 10px;
	border: 1px solid #e5e5e5
}

.product_gallery a img {
	width: 100%;
	margin-top: 15px
}

.product_price {
	margin: 20px 0;
	padding: 5px 10px;
	background-color: #FFFFFF;
	text-align: left;
	border: 2px dashed #E0E0E0
}

.price-tax {
	font-size: 18px
}

.product_social {
	margin: 20px 0
}

.product_social ul li a i {
	font-size: 35px
}

.login {
	background: #F7F7F7
}

.login .fa-paw {
	font-size: 26px
}

a.hiddenanchor {
	display: none
}

.login_wrapper {
	right: 0px;
	margin: 0px auto;
	margin-top: 5%;
	max-width: 350px;
	position: relative
}

.registration_form,
.login_form {
	position: absolute;
	top: 0px;
	width: 100%
}

.registration_form {
	z-index: 21;
	opacity: 0;
	width: 100%
}

.login_form {
	z-index: 22
}

#signup:target ~ .login_wrapper .registration_form,
#signin:target ~ .login_wrapper .login_form {
	z-index: 22;
	animation-name: fadeInLeft;
	animation-delay: .1s
}

#signup:target ~ .login_wrapper .login_form,
#signin:target ~ .login_wrapper .registration_form {
	animation-name: fadeOutLeft
}

.animate {
	-webkit-animation-duration: 0.5s;
	-webkit-animation-timing-function: ease;
	-webkit-animation-fill-mode: both;
	-moz-animation-duration: 0.5s;
	-moz-animation-timing-function: ease;
	-moz-animation-fill-mode: both;
	-o-animation-duration: 0.5s;
	-o-animation-timing-function: ease;
	-o-animation-fill-mode: both;
	-ms-animation-duration: 0.5s;
	-ms-animation-timing-function: ease;
	-ms-animation-fill-mode: both;
	animation-duration: 0.5s;
	animation-timing-function: ease;
	animation-fill-mode: both
}

.login_box {
	padding: 20px;
	margin: auto
}

.left {
	float: left
}

.alignleft {
	float: left;
	margin-right: 15px
}

.alignright {
	float: right;
	margin-left: 15px
}

.clearfix:after,
form:after {
	content: ".";
	display: block;
	height: 0;
	clear: both;
	visibility: hidden
}

.login_content {
	margin: 0 auto;
	padding: 25px 0 0;
	position: relative;
	text-align: center;
	text-shadow: 0 1px 0 #fff;
	min-width: 280px
}

.login_content a,
.login_content .btn-default:hover {
	text-decoration: none
}

.login_content a:hover {
	text-decoration: underline
}

.login_content h1 {
	font: normal 25px Helvetica, Arial, sans-serif;
	letter-spacing: -0.05em;
	line-height: 20px;
	margin: 10px 0 30px
}

.login_content h1:before,
.login_content h1:after {
	content: "";
	height: 1px;
	position: absolute;
	top: 10px;
	width: 27%
}

.login_content h1:after {
	background: #7e7e7e;
	background: linear-gradient(left, #7e7e7e 0%, #fff 100%);
	right: 0
}

.login_content h1:before {
	background: #7e7e7e;
	background: linear-gradient(right, #7e7e7e 0%, #fff 100%);
	left: 0
}

.login_content h1:before,
.login_content h1:after {
	content: "";
	height: 1px;
	position: absolute;
	top: 10px;
	width: 20%
}

.login_content h1:after {
	background: #7e7e7e;
	background: linear-gradient(left, #7e7e7e 0%, #fff 100%);
	right: 0
}

.login_content h1:before {
	background: #7e7e7e;
	background: linear-gradient(right, #7e7e7e 0%, #fff 100%);
	left: 0
}

.login_content form {
	margin: 20px 0;
	position: relative
}

.login_content form input[type="text"],
.login_content form input[type="email"],
.login_content form input[type="password"] {
	border-radius: 3px;
	-ms-box-shadow: 0 1px 0 #fff, 0 -2px 5px rgba(0, 0, 0, 0.08) inset;
	-o-box-shadow: 0 1px 0 #fff, 0 -2px 5px rgba(0, 0, 0, 0.08) inset;
	box-shadow: 0 1px 0 #fff, 0 -2px 5px rgba(0, 0, 0, 0.08) inset;
	border: 1px solid #c8c8c8;
	color: #777;
	margin: 0 0 20px;
	width: 100%
}

.login_content form input[type="text"]:focus,
.login_content form input[type="email"]:focus,
.login_content form input[type="password"]:focus {
	-ms-box-shadow: 0 0 2px #ed1c24 inset;
	-o-box-shadow: 0 0 2px #ed1c24 inset;
	box-shadow: 0 0 2px #A97AAD inset;
	background-color: #fff;
	border: 1px solid #A878AF;
	outline: none
}

#username {
	background-position: 10px 10px !important
}

#password {
	background-position: 10px -53px !important
}

.login_content form div a {
	font-size: 12px;
	margin: 10px 15px 0 0
}

.reset_pass {
	margin-top: 10px !important
}

.login_content div .reset_pass {
	margin-top: 13px !important;
	margin-right: 39px;
	float: right
}

.separator {
	border-top: 1px solid #D8D8D8;
	margin-top: 10px;
	padding-top: 10px
}

.button {
	background: #f7f9fa;
	background: linear-gradient(top, #f7f9fa 0%, #f0f0f0 100%);
	filter: progid: DXImageTransform.Microsoft.gradient( startColorstr='#f7f9fa', endColorstr='#f0f0f0', GradientType=0);
	-ms-box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1) inset;
	-o-box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1) inset;
	box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1) inset;
	border-radius: 0 0 5px 5px;
	border-top: 1px solid #CFD5D9;
	padding: 15px 0
}

.login_content form input[type="submit"],
#content form .submit {
	float: left;
	margin-left: 38px
}

.button a {
	background: url(http://cssdeck.com/uploads/media/items/8/8bcLQqF.png) 0 -112px no-repeat;
	color: #7E7E7E;
	font-size: 17px;
	padding: 2px 0 2px 40px;
	text-decoration: none;
	transition: all 0.3s ease
}

.button a:hover {
	background-position: 0 -135px;
	color: #00aeef
}

header {
	width: 100%
}

#nprogress {
	pointer-events: none
}

#nprogress .bar {
	background: #29d;
	position: fixed;
	z-index: 1031;
	top: 0;
	left: 0;
	width: 100%;
	height: 2px
}

#nprogress .peg {
	display: block;
	position: absolute;
	right: 0px;
	width: 100px;
	height: 100%;
	box-shadow: 0 0 10px #29d, 0 0 5px #29d;
	opacity: 1.0;
	transform: rotate(3deg) translate(0px, -4px)
}

#nprogress .spinner {
	display: block;
	position: fixed;
	z-index: 1031;
	top: 15px;
	right: 15px
}

#nprogress .spinner-icon {
	width: 18px;
	height: 18px;
	box-sizing: border-box;
	border: solid 2px transparent;
	border-top-color: #29d;
	border-left-color: #29d;
	border-radius: 50%;
	animation: nprogress-spinner 400ms linear infinite
}

.nprogress-custom-parent {
	overflow: hidden;
	position: relative
}

.nprogress-custom-parent #nprogress .spinner,
.nprogress-custom-parent #nprogress .bar {
	position: absolute
}

@keyframes nprogress-spinner {
	0% {
		transform: rotate(0deg)
	}
	100% {
		transform: rotate(360deg)
	}
}

.editor-wrapper {
	min-height: 250px;
	background-color: white;
	border-collapse: separate;
	border: 1px solid #ccc;
	padding: 4px;
	box-sizing: content-box;
	box-shadow: rgba(0, 0, 0, 0.07451) 0px 1px 1px 0px inset;
	border-top-right-radius: 3px;
	border-bottom-right-radius: 3px;
	border-bottom-left-radius: 3px;
	border-top-left-radius: 3px;
	overflow: scroll;
	outline: none
}

.voiceBtn {
	width: 20px;
	color: transparent;
	background-color: transparent;
	transform: scale(2, 2);
	-webkit-transform: scale(2, 2);
	-moz-transform: scale(2, 2);
	border: transparent;
	cursor: pointer;
	box-shadow: none;
	-webkit-box-shadow: none
}

div[data-role="editor-toolbar"] {
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none
}

.dropdown-menu a {
	cursor: pointer
}

.select2-container--default .select2-selection--single,
.select2-container--default .select2-selection--multiple {
	background-color: #fff;
	border: 1px solid #ccc;
	border-radius: 0;
	min-height: 38px
}

.select2-container--default .select2-selection--single .select2-selection__rendered {
	color: #73879C;
	padding-top: 5px
}

.select2-container--default .select2-selection--multiple .select2-selection__rendered {
	padding-top: 3px
}

.select2-container--default .select2-selection--single .select2-selection__arrow {
	height: 36px
}

.select2-container--default .select2-selection--multiple .select2-selection__choice,
.select2-container--default .select2-selection--multiple .select2-selection__clear {
	margin-top: 2px;
	border: none;
	border-radius: 0;
	padding: 3px 5px
}

.select2-container--default.select2-container--focus .select2-selection--multiple {
	border: 1px solid #ccc
}

.switchery {
	width: 32px;
	height: 20px
}

.switchery > small {
	width: 20px;
	height: 20px
}

fieldset {
	border: none;
	margin: 0;
	padding: 0
}

.cropper .img-container,
.cropper .img-preview {
	background-color: #f7f7f7;
	width: 100%;
	text-align: center
}

.cropper .img-container {
	min-height: 200px;
	max-height: 516px;
	margin-bottom: 20px
}

@media (min-width: 768px) {
	.cropper .img-container {
		min-height: 516px
	}
}

.cropper .img-container > img {
	max-width: 100%
}

.cropper .docs-preview {
	margin-right: -15px
}

.cropper .img-preview {
	float: left;
	margin-right: 10px;
	margin-bottom: 10px;
	overflow: hidden
}

.cropper .img-preview > img {
	max-width: 100%
}

.cropper .preview-lg {
	width: 263px;
	height: 148px
}

.cropper .preview-md {
	width: 139px;
	height: 78px
}

.cropper .preview-sm {
	width: 69px;
	height: 39px
}

.cropper .preview-xs {
	width: 35px;
	height: 20px;
	margin-right: 0
}

.cropper .docs-data > .input-group {
	margin-bottom: 10px
}

.cropper .docs-data > .input-group > label {
	min-width: 80px
}

.cropper .docs-data > .input-group > span {
	min-width: 50px
}

.cropper .docs-buttons > .btn,
.cropper .docs-buttons > .btn-group,
.cropper .docs-buttons > .form-control {
	margin-right: 5px;
	margin-bottom: 10px
}

.cropper .docs-toggles > .btn,
.cropper .docs-toggles > .btn-group,
.cropper .docs-toggles > .dropdown {
	margin-bottom: 10px
}

.cropper .docs-tooltip {
	display: block;
	margin: -6px -12px;
	padding: 6px 12px
}

.cropper .docs-tooltip > .icon {
	margin: 0 -3px;
	vertical-align: top
}

.cropper .tooltip-inner {
	white-space: normal
}

.cropper .btn-upload .tooltip-inner,
.cropper .btn-toggle .tooltip-inner {
	white-space: nowrap
}

.cropper .btn-toggle {
	padding: 6px
}

.cropper .btn-toggle > .docs-tooltip {
	margin: -6px;
	padding: 6px
}

@media (max-width: 400px) {
	.cropper .btn-group-crop {
		margin-right: -15px !important
	}
	.cropper .btn-group-crop > .btn {
		padding-left: 5px;
		padding-right: 5px
	}
	.cropper .btn-group-crop .docs-tooltip {
		margin-left: -5px;
		margin-right: -5px;
		padding-left: 5px;
		padding-right: 5px
	}
}

.cropper .docs-options .dropdown-menu {
	width: 100%
}

.cropper .docs-options .dropdown-menu > li {
	padding: 3px 20px
}

.cropper .docs-options .dropdown-menu > li:hover {
	background-color: #f7f7f7
}

.cropper .docs-options .dropdown-menu > li > label {
	display: block
}

.cropper .docs-cropped .modal-body {
	text-align: center
}

.cropper .docs-cropped .modal-body > img,
.cropper .docs-cropped .modal-body > canvas {
	max-width: 100%
}

.cropper .docs-diagram .modal-dialog {
	max-width: 352px
}

.cropper .docs-cropped canvas {
	max-width: 100%
}

.form_wizard .stepContainer {
	display: block;
	position: relative;
	margin: 0;
	padding: 0;
	border: 0 solid #CCC;
	overflow-x: hidden
}

.wizard_horizontal ul.wizard_steps {
	display: table;
	list-style: none;
	position: relative;
	width: 100%;
	margin: 0 0 20px
}

.wizard_horizontal ul.wizard_steps li {
	display: table-cell;
	text-align: center
}

.wizard_horizontal ul.wizard_steps li a,
.wizard_horizontal ul.wizard_steps li:hover {
	display: block;
	position: relative;
	-moz-opacity: 1;
	filter: alpha(opacity=100);
	opacity: 1;
	color: #666
}

.wizard_horizontal ul.wizard_steps li a:before {
	content: "";
	position: absolute;
	height: 4px;
	background: #ccc;
	top: 20px;
	width: 100%;
	z-index: 4;
	left: 0
}

.wizard_horizontal ul.wizard_steps li a.disabled .step_no {
	background: #ccc
}

.wizard_horizontal ul.wizard_steps li a .step_no {
	width: 40px;
	height: 40px;
	line-height: 40px;
	border-radius: 100px;
	display: block;
	margin: 0 auto 5px;
	font-size: 16px;
	text-align: center;
	position: relative;
	z-index: 5
}

.wizard_horizontal ul.wizard_steps li a.selected:before,
.step_no {
	background: #34495E;
	color: #fff
}

.wizard_horizontal ul.wizard_steps li a.done:before,
.wizard_horizontal ul.wizard_steps li a.done .step_no {
	background: #1ABB9C;
	color: #fff
}

.wizard_horizontal ul.wizard_steps li:first-child a:before {
	left: 50%
}

.wizard_horizontal ul.wizard_steps li:last-child a:before {
	right: 50%;
	width: 50%;
	left: auto
}

.wizard_verticle .stepContainer {
	width: 80%;
	float: left;
	padding: 0 10px
}

.actionBar {
	width: 100%;
	border-top: 1px solid #ddd;
	padding: 10px 5px;
	text-align: right;
	margin-top: 10px
}

.actionBar .buttonDisabled {
	cursor: not-allowed;
	pointer-events: none;
	opacity: .65;
	filter: alpha(opacity=65);
	box-shadow: none
}

.actionBar a {
	margin: 0 3px
}

.wizard_verticle .wizard_content {
	width: 80%;
	float: left;
	padding-left: 20px
}

.wizard_verticle ul.wizard_steps {
	display: table;
	list-style: none;
	position: relative;
	width: 20%;
	float: left;
	margin: 0 0 20px
}

.wizard_verticle ul.wizard_steps li {
	display: list-item;
	text-align: center
}

.wizard_verticle ul.wizard_steps li a {
	height: 80px
}

.wizard_verticle ul.wizard_steps li a:first-child {
	margin-top: 20px
}

.wizard_verticle ul.wizard_steps li a,
.wizard_verticle ul.wizard_steps li:hover {
	display: block;
	position: relative;
	-moz-opacity: 1;
	filter: alpha(opacity=100);
	opacity: 1;
	color: #666
}

.wizard_verticle ul.wizard_steps li a:before {
	content: "";
	position: absolute;
	height: 100%;
	background: #ccc;
	top: 20px;
	width: 4px;
	z-index: 4;
	left: 49%
}

.wizard_verticle ul.wizard_steps li a.disabled .step_no {
	background: #ccc
}

.wizard_verticle ul.wizard_steps li a .step_no {
	width: 40px;
	height: 40px;
	line-height: 40px;
	border-radius: 100px;
	display: block;
	margin: 0 auto 5px;
	font-size: 16px;
	text-align: center;
	position: relative;
	z-index: 5
}

.wizard_verticle ul.wizard_steps li a.selected:before,
.step_no {
	background: #34495E;
	color: #fff
}

.wizard_verticle ul.wizard_steps li a.done:before,
.wizard_verticle ul.wizard_steps li a.done .step_no {
	background: #1ABB9C;
	color: #fff
}

.wizard_verticle ul.wizard_steps li:first-child a:before {
	left: 49%
}

.wizard_verticle ul.wizard_steps li:last-child a:before {
	left: 49%;
	left: auto;
	width: 0
}

.form_wizard .loader {
	display: none
}

.form_wizard .msgBox {
	display: none
}

.progress {
	border-radius: 0
}

.progress-bar-info {
	background-color: #3498DB
}

.progress-bar-success {
	background-color: #26B99A
}

.progress_summary .progress {
	margin: 5px 0 12px !important
}

.progress_summary .row {
	margin-bottom: 5px
}

.progress_summary .row .col-xs-2 {
	padding: 0
}

.progress_summary .more_info span {
	text-align: right;
	float: right
}

.progress_summary .data span {
	text-align: right;
	float: right
}

.progress_summary p {
	margin-bottom: 3px;
	width: 100%
}

.progress_title .left {
	float: left;
	text-align: left
}

.progress_title .right {
	float: right;
	text-align: right;
	font-weight: 300
}

.progress.progress_sm {
	border-radius: 0;
	margin-bottom: 18px;
	height: 10px !important
}

.progress.progress_sm .progress-bar {
	height: 10px !important
}

.dashboard_graph p {
	margin: 0 0 4px
}

ul.verticle_bars {
	width: 100%
}

ul.verticle_bars li {
	width: 23%;
	height: 200px;
	margin: 0
}

.progress.vertical.progress_wide {
	width: 35px
}

.alert-success {
	color: #ffffff;
	background-color: rgba(38, 185, 154, 0.88);
	border-color: rgba(38, 185, 154, 0.88)
}

.alert-info {
	color: #E9EDEF;
	background-color: rgba(52, 152, 219, 0.88);
	border-color: rgba(52, 152, 219, 0.88)
}

.alert-warning {
	color: #E9EDEF;
	background-color: rgba(243, 156, 18, 0.88);
	border-color: rgba(243, 156, 18, 0.88)
}

.alert-danger,
.alert-error {
	color: #E9EDEF;
	background-color: rgba(231, 76, 60, 0.88);
	border-color: rgba(231, 76, 60, 0.88)
}

.ui-pnotify.dark .ui-pnotify-container {
	color: #E9EDEF;
	background-color: rgba(52, 73, 94, 0.88);
	border-color: rgba(52, 73, 94, 0.88)
}

.custom-notifications {
	position: fixed;
	margin: 15px;
	right: 0;
	float: right;
	width: 400px;
	z-index: 4000;
	bottom: 0
}

ul.notifications {
	float: right;
	display: block;
	margin-bottom: 7px;
	padding: 0;
	width: 100%
}

.notifications li {
	float: right;
	margin: 3px;
	width: 36px;
	box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.3)
}

.notifications li:last-child {
	margin-left: 0
}

.notifications a {
	display: block;
	text-align: center;
	text-decoration: none;
	text-transform: uppercase;
	padding: 9px 8px
}

.tabbed_notifications .text {
	padding: 5px 15px;
	height: 140px;
	border-radius: 7px;
	box-shadow: 6px 6px 6px rgba(0, 0, 0, 0.3)
}

.tabbed_notifications div p {
	display: inline-block
}

.tabbed_notifications h2 {
	font-weight: bold;
	text-transform: uppercase;
	width: 80%;
	float: left;
	height: 20px;
	text-overflow: ellipsis;
	overflow: hidden;
	display: block
}

.tabbed_notifications .close {
	padding: 5px;
	color: #E9EDEF;
	float: right;
	opacity: 1
}

.daterangepicker.dropdown-menu {
	font-size: 13px;
	padding: 0;
	overflow: hidden
}

.daterangepicker.picker_1 {
	background: #34495E;
	color: #ECF0F1
}

.daterangepicker.picker_1 table.table-condensed thead tr:first-child {
	background: #1ABB9C
}

.daterangepicker table.table-condensed thead tr:first-child th {
	line-height: 28px;
	text-align: center
}

.daterangepicker.picker_1 table.table-condensed thead tr {
	background: #213345
}

.daterangepicker table.table-condensed thead tr {
	line-height: 14px
}

.daterangepicker table.table-condensed tbody tr:first-child td {
	padding-top: 10px
}

.daterangepicker table.table-condensed th:first-child,
.daterangepicker table.table-condensed td:first-child {
	padding-left: 12px
}

.daterangepicker table.table-condensed th:last-child,
.daterangepicker table.table-condensed td:last-child {
	padding-right: 12px
}

.table-condensed > thead > tr > th,
.table-condensed > tbody > tr > th,
.table-condensed > tfoot > tr > th,
.table-condensed > thead > tr > td,
.table-condensed > tbody > tr > td,
.table-condensed > tfoot > tr > td {
	padding: 5px 7px;
	text-align: center
}

.daterangepicker table.table-condensed tbody tr:last-child td {
	padding-bottom: 10px
}

.daterangepicker.picker_2 table.table-condensed thead tr:first-child {
	color: inherit
}

.daterangepicker.picker_2 table.table-condensed thead tr {
	color: #1ABB9C
}

.daterangepicker.picker_3 table.table-condensed thead tr:first-child {
	background: #1ABB9C;
	color: #ECF0F1
}

.daterangepicker.picker_4 table.table-condensed tbody td {
	background: #ECF0F1;
	color: #34495E;
	border: 1px solid #fff;
	padding: 4px 7px
}

.daterangepicker.picker_4 table.table-condensed tbody td.active {
	background: #536A7F;
	color: #fff
}

.daterangepicker.picker_4 table.table-condensed thead tr:first-child {
	background: #34495E;
	color: #ECF0F1
}

.xdisplay_input {
	width: 240px;
	overflow: hidden;
	padding: 0
}

.xdisplay {
	background-color: #fff;
	background-clip: padding-box;
	border: 1px solid #ccc;
	margin-bottom: 20px;
	border: 1px solid rgba(0, 0, 0, 0.15);
	border-radius: 4px;
	width: 230px;
	overflow: hidden;
	box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175)
}

.daterangepicker.opensright .ranges,
.daterangepicker.opensright .calendar,
.daterangepicker.openscenter .ranges,
.daterangepicker.openscenter .calendar {
	float: right
}

.daterangepicker table {
	width: 100%;
	margin: 0
}

.daterangepicker td,
.daterangepicker th {
	text-align: center;
	width: 20px;
	height: 20px;
	cursor: pointer;
	white-space: nowrap
}

.daterangepicker td.off {
	color: #999
}

.daterangepicker td.disabled {
	color: #999
}

.daterangepicker td.available:hover,
.daterangepicker th.available:hover {
	background: #eee;
	color: #34495E
}

.daterangepicker td.in-range {
	background: #E4E7EA;
	border-radius: 0
}

.daterangepicker td.available+td.start-date {
	border-radius: 4px 0 0 4px
}

.daterangepicker td.in-range+td.end-date {
	border-radius: 0 4px 4px 0
}

.daterangepicker td.start-date.end-date {
	border-radius: 4px !important
}

.daterangepicker td.active,
.daterangepicker td.active:hover {
	background-color: #536A7F;
	color: #fff
}

.daterangepicker td.week,
.daterangepicker th.week {
	font-size: 80%;
	color: #ccc
}

.daterangepicker select.monthselect,
.daterangepicker select.yearselect {
	font-size: 12px;
	padding: 1px;
	height: auto;
	margin: 0;
	cursor: default;
	height: 30px;
	border: 1px solid #ADB2B5;
	line-height: 30px;
	border-radius: 0px !important
}

.daterangepicker select.monthselect {
	margin-right: 2%;
	width: 56%
}

.daterangepicker select.yearselect {
	width: 40%
}

.daterangepicker select.hourselect,
.daterangepicker select.minuteselect,
.daterangepicker select.ampmselect {
	width: 50px;
	margin-bottom: 0
}

.daterangepicker_start_input {
	float: left
}

.daterangepicker_end_input {
	float: left;
	padding-left: 11px
}

.daterangepicker th.month {
	width: auto
}

.daterangepicker .daterangepicker_start_input label,
.daterangepicker .daterangepicker_end_input label {
	color: #333;
	display: block;
	font-size: 11px;
	font-weight: normal;
	height: 20px;
	line-height: 20px;
	margin-bottom: 2px;
	text-shadow: #fff 1px 1px 0px;
	text-transform: uppercase;
	width: 74px
}

.daterangepicker .ranges input {
	font-size: 11px
}

.daterangepicker .ranges .input-mini {
	background-color: #eee;
	border: 1px solid #ccc;
	border-radius: 4px;
	color: #555;
	display: block;
	font-size: 11px;
	height: 30px;
	line-height: 30px;
	vertical-align: middle;
	margin: 0 0 10px 0;
	padding: 0 6px;
	width: 74px
}

.daterangepicker .ranges .input-mini:hover {
	cursor: pointer
}

.daterangepicker .ranges ul {
	list-style: none;
	margin: 0;
	padding: 0
}

.daterangepicker .ranges li {
	font-size: 13px;
	background: #f5f5f5;
	border: 1px solid #f5f5f5;
	color: #536A7F;
	padding: 3px 12px;
	margin-bottom: 8px;
	border-radius: 5px;
	cursor: pointer
}

.daterangepicker .ranges li.active,
.daterangepicker .ranges li:hover {
	background: #536A7F;
	border: 1px solid #536A7F;
	color: #fff
}

.daterangepicker .calendar {
	display: none;
	max-width: 270px
}

.daterangepicker.show-calendar .calendar {
	display: block
}

.daterangepicker .calendar.single .calendar-date {
	border: none
}

.daterangepicker.single .ranges,
.daterangepicker.single .calendar {
	float: none
}

.daterangepicker .ranges {
	width: 160px;
	text-align: left;
	margin: 4px
}

.daterangepicker .ranges .range_inputs > div {
	float: left
}

.daterangepicker .ranges .range_inputs > div:nth-child(2) {
	padding-left: 11px
}

.daterangepicker.opensleft .ranges,
.daterangepicker.opensleft .calendar {
	float: left;
	margin: 4px
}

.daterangepicker .icon {
	width: 20px;
	height: 20px;
	display: inline-block;
	vertical-align: middle
}

.fc-state-default {
	background: #f5f5f5;
	color: #73879C
}

.fc-state-down,
.fc-state-active {
	color: #333;
	background: #ccc
}

.dropzone {
	min-height: 300px;
	border: 1px solid #e5e5e5
}

/* 06/15/2017 Paul.  8px is too much padding.  Decrease to 6px. */
.table > thead > tr > th,
.table > tbody > tr > th,
.table > tfoot > tr > th,
.table > thead > tr > td,
.table > tbody > tr > td,
.table > tfoot > tr > td
{
	padding: 6px;
	line-height: 1.42857143;
	vertical-align: top;
	border-top: 1px solid #ddd;
}

/* 06/15/2017 Paul.  The process table is a single cell, so we don't need any padding. */
.table > tbody > tr > td[class=" MyProcessCell"]
{
	padding: 0px;
}

/* 12/31/2017 Paul.  Arctic colors. */
.btn-primary, .btn-default
{
	text-shadow: none;
	background-image: none;
	background-repeat: inherit;
	background-position: inherit;
	background-color: #F08276;
	border: none;
	border-radius: 3px;
	padding: 0 20px 0 20px;
	color: white;
	cursor: pointer;
	font-size: 13px;
	font-weight: 500;
	text-transform: uppercase;
	margin: 0;
	height: 30px;
	line-height: 30px;
}
.btn-default
{
	margin: 8px 0px 8px 0px;
}
/* 05/23/2021 Paul.  Move webkit-file-upload-button to Arctic theme so that only Arctic gets the orange button. */
/*
::-webkit-file-upload-button
{
	text-shadow: none;
	background-image: none;
	background-repeat: inherit;
	background-position: inherit;
	background-color: #F08276;
	border: none;
	border-radius: 3px;
	padding: 0 20px 0 20px;
	color: white;
	cursor: pointer;
	font-size: 13px;
	font-weight: 500;
	text-transform: uppercase;
	margin: 0;
	height: 30px;
	line-height: 30px;
}
*/
::-ms-browse
{
	text-shadow: none;
	background-image: none;
	background-repeat: inherit;
	background-position: inherit;
	background-color: #F08276;
	border: none;
	border-radius: 3px;
	padding: 0 20px 0 20px;
	color: white;
	cursor: pointer;
	font-size: 13px;
	font-weight: 500;
	text-transform: uppercase;
	margin: 0;
	height: 30px;
	line-height: 30px;
}
.btn-primary:hover, .btn-primary:focus, .btn-default:hover, .btn-default:focus
{
	background-color: #808f9c;
}
::-webkit-file-upload-button:hover
{
	background-color: #808f9c;
}
::-webkit-file-upload-button:focus
{
	background-color: #808f9c;
}
::-ms-browse:hover
{
	background-color: #808f9c;
}
::-ms-browse:focus
{
	background-color: #808f9c;
}
.x_panel
{
	background-color: white;
}
.form-group
{
	background-color: white;
}
.form-control
{
	border: 1px solid #a4e8d5;
}
.control-label
{
	color: #534c64;
}
.form-group input[type=text].form-control, input[type=password].form-control, .form-group input[type=file].form-control, .form-group select.form-control, .form-group textarea.form-control
{
	background-color: #d7f5ed;
	border: 1px solid #a4e8d5;
	border-radius: 4px;
	line-height: 30px;
	margin: 8px 0px 8px 0px;
	padding: 4px;
}

/* 01/06/2018 Paul.  Add DATA_FORMAT to ListBox support multi-select CSV.  */
.multiple-select
{
	width: 35%;
}
.multiple-select > .ms-choice > span
{
	background-color: #d7f5ed;
	border: 1px solid #a4e8d5;
	border-radius: 4px;
}
.multiple-select > button.ms-choice
{
	background-color: #d7f5ed;
	border: 1px solid #a4e8d5;
	border-radius: 4px;
}
.multiple-select > .ms-drop
{
	background-color: #d7f5ed;
	border: 1px solid #a4e8d5;
	border-radius: 4px;
}
/* 01/07/2018 Paul.  Auto-complete is getting hidden behind form-control. */
.input-group .form-control
{
	z-index: 1;
}
/* 04/28/2019 Paul.  Remove bootstrap setting.  */
@media (min-width: 576px)
{
	.modal-dialog {
		max-width: unset;
	}
}
/* 04/28/2019 Paul.  Latest Bootstrap drops bold. */
label
{
	font-weight: bold;
}
/* 05/04/2019 Paul.  Bootstrap does not wrap buttons. */
.btn-group
{
	display: flex;
	flex-flow: row wrap;
}
`, "",{"version":3,"sources":["webpack://./styles/gentelella/custom.css"],"names":[],"mappings":"AAAA,gBAAgB;;AAEhB,6CAA6C;AAC7C,gCAAgC;AAChC;CACC,mBAAmB;CACnB,YAAY;AACb;;AAEA,yCAAyC;AACzC;CACC,YAAY;CACZ,UAAU;CACV,aAAa;CACb;AACD;;AAEA;CACC,eAAe;CACf;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA,yCAAyC;AACzC;CACC,kBAAkB;CAClB,kBAAkB;CAClB;AACD;;AAEA,yCAAyC;AACzC;CACC,YAAY;AACb;;AAEA;CACC;AACD;;AAEA;CACC,eAAe;CACf;AACD;;AAEA,+DAA+D;AAC/D;;CAEC,yBAAyB;;AAE1B;AACA;CACC,yBAAyB;CACzB,gBAAgB;CAChB;AACD;;AAEA,yCAAyC;AACzC;CACC,cAAc;CACd,kBAAkB;CAClB;AACD;;AAEA,mDAAmD;AACnD;CACC,6BAA6B;CAC7B,gBAAgB;CAChB;AACD;;AAEA,gCAAgC;AAChC;;CAEC;AACD;;AAEA;;CAEC,gBAAgB;CAChB,YAAY;CACZ;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,0BAA0B;CAC1B,kBAAkB;CAClB,sBAAsB;CACtB;AACD;;AAEA,6CAA6C;AAC7C,gCAAgC;AAChC;CACC,UAAU;CACV,kBAAkB;CAClB,MAAM;CACN,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,YAAY;CACZ,aAAa;AACd;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,yBAAyB;CACzB,oBAAoB;CACpB,iBAAiB;CACjB,eAAe;CACf,gBAAgB;CAChB,aAAa;CACb;AACD;;AAEA;CACC;AACD;;AAEA;CACC,UAAU;CACV;AACD;;AAEA;CACC,UAAU;CACV,gBAAgB;CAChB,gBAAgB;CAChB,aAAa;CACb,iBAAiB;CACjB,gBAAgB;CAChB,wCAAwC;CACxC;AACD;;AAEA;CACC,uBAAuB;CACvB,UAAU;CACV;AACD;;CAEC,wCAAwC;CACxC,gCAAgC;CAChC;EACC,eAAe;EACf,iBAAiB;EACjB,YAAY;CACb;;CAEA,wCAAwC;CACxC,gCAAgC;CAChC;EACC,eAAe;EACf,YAAY;EACZ,SAAS;EACT,gBAAgB;CACjB;;AAED;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,UAAU;CACV;AACD;;AAEA;CACC,oBAAoB;CACpB,WAAW;CACX,mBAAmB;CACnB;AACD;;AAEA,0DAA0D;AAC1D,gCAAgC;AAChC;CACC,YAAY;CACZ,kBAAkB;CAClB,eAAe;CACf,kBAAkB;CAClB,YAAY;AACb;;AAEA;CACC,4BAA4B;CAC5B;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,WAAW;CACX,mBAAmB;CACnB,gCAAgC;CAChC,mBAAmB;CACnB,WAAW;CACX;AACD;;AAEA;CACC;EACC;CACD;AACD;;AAEA;CACC,YAAY;CACZ,UAAU;CACV,kBAAkB;CAClB,oBAAoB;CACpB,aAAa;CACb;AACD;;AAEA;CACC,YAAY;CACZ;AACD;;AAEA;CACC;AACD;;AAEA;CACC,oBAAoB;CACpB;AACD;;AAEA,6CAA6C;AAC7C,gCAAgC;AAChC;CACC,YAAY;CACZ,WAAW;CACX,mBAAmB;CACnB,YAAY;CACZ,gBAAgB;CAChB,YAAY;AACb;;AAEA;CACC;;EAEC,WAAW;EACX;CACD;CACA;EACC;CACD;CACA;EACC,WAAW;EACX;CACD;CACA;EACC;CACD;AACD;;AAEA;CACC;EACC,UAAU;EACV;CACD;CACA;;EAEC,SAAS;EACT;CACD;AACD;;AAEA;CACC;EACC;CACD;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,2BAA2B;CAC3B,iCAAiC;CACjC;AACD;;AAEA;CACC,8BAA8B;CAC9B,oCAAoC;CACpC;AACD;;AAEA;CACC,8BAA8B;CAC9B,oCAAoC;CACpC;AACD;;AAEA;CACC,8BAA8B;CAC9B,oCAAoC;CACpC;AACD;;AAEA;CACC,8BAA8B;CAC9B,oCAAoC;CACpC;AACD;;AAEA;CACC,8BAA8B;CAC9B,oCAAoC;CACpC;AACD;;AAEA;CACC,8BAA8B;CAC9B,oCAAoC;CACpC;AACD;;AAEA;CACC,WAAW;CACX;AACD;;AAEA;;;CAGC;AACD;;AAEA;;;;;CAKC;AACD;;AAEA,6CAA6C;AAC7C,0CAA0C;AAC1C;CACC,iBAAiB;CACjB,sEAAsE;CACtE,eAAe;CACf,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA;CACC,WAAW;CACX,YAAY;CACZ;AACD;;AAEA;CACC,UAAU;CACV,WAAW;CACX;AACD;;AAEA;CACC;AACD;;AAEA;CACC,UAAU;CACV,WAAW;CACX;AACD;;EAEE,oCAAoC;EACpC;GACC,aAAa;EACd;;AAEF;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,UAAU;CACV;AACD;;AAEA;CACC;EACC;CACD;AACD;;AAEA;CACC;EACC;CACD;AACD;;AAEA;CACC;EACC;CACD;AACD;;AAEA;CACC;EACC,iBAAiB;EACjB;CACD;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAiDC,kBAAkB;CAClB,eAAe;CACf,WAAW;CACX,mBAAmB;CACnB;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;;;;;;CAMC,gBAAgB;CAChB;AACD;;AAEA,wFAAwF;AACxF,wCAAwC;AACxC;CACC,cAAc;CACd,wBAAwB;AACzB;;AAEA;;;;;;;;;;;;;CAaC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,SAAS;CACT,UAAU;CACV;AACD;;AAEA;CACC,qBAAqB;CACrB,YAAY;CACZ;AACD;;AAEA;CACC;EACC;CACD;AACD;;AAEA;CACC;AACD;;AAEA;CACC,WAAW;CACX;AACD;;AAEA;CACC;AACD;;AAEA;CACC,eAAe;CACf,MAAM;CACN;AACD;;AAEA;CACC,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC,qBAAqB;CACrB;AACD;;AAEA;CACC;AACD;;CAEC,qEAAqE;CACrE;;EAEC,2CAA2C;CAC5C;;AAED;CACC;AACD;;AAEA;CACC,mBAAmB;CACnB,YAAY;CACZ,WAAW;CACX,WAAW;CACX,UAAU;CACV,gBAAgB;CAChB,kBAAkB;CAClB,WAAW;CACX,UAAU;CACV,UAAU;CACV;AACD;;AAEA;CACC,8BAA8B;CAC9B,SAAS;CACT,WAAW;CACX,UAAU;CACV,kBAAkB;CAClB;AACD;;AAEA;;CAEC,cAAc;CACd;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd;AACD;;AAEA,6EAA6E;AAC7E,wCAAwC;AACxC,gCAAgC;AAChC;;CAEC,kBAAkB;CAClB,cAAc;CACd,uBAAuB;CACvB,YAAY;CACZ,gBAAgB;AACjB;;AAEA,qEAAqE;AACrE;;CAEC,2CAA2C;AAC5C;;AAEA,wCAAwC;AACxC,gCAAgC;AAChC;CACC,+BAA+B;AAChC;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,yCAAyC;CACzC,sDAAsD;CACtD;AACD;;AAEA;;CAEC,gBAAgB;CAChB,yBAAyB;CACzB,yBAAyB;CACzB;AACD;;AAEA,wCAAwC;AACxC,gCAAgC;AAChC;CACC,uBAAuB;CACvB,gBAAgB;CAChB,gBAAgB;CAChB,eAAe;CACf,WAAW;CACX,uBAAuB;CACvB,yBAAyB;CACzB,iBAAiB;CACjB,cAAc;CACd,YAAY;CACZ,SAAS;CACT,kBAAkB;AACnB;;AAEA;;CAEC;AACD;;AAEA,wCAAwC;AACxC,gCAAgC;AAChC;CACC,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,kBAAkB;CAClB;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,eAAe;CACf,gDAAgD;CAChD,gCAAgC;CAChC,kBAAkB;CAClB;AACD;;AAEA;CACC,2CAA2C;CAC3C;AACD;;AAEA;CACC,gCAAgC;CAChC,2CAA2C;CAC3C,cAAc;CACd,gDAAgD;CAChD,cAAc;CACd;AACD;;AAEA,yCAAyC;AACzC;CACC,WAAW;CACX,SAAS;CACT,iBAAiB;CACjB;AACD;;AAEA;CACC,oBAAoB;CACpB,SAAS;CACT;AACD;;AAEA;CACC;AACD;;AAEA,0DAA0D;AAC1D,gCAAgC;AAChC;CACC,YAAY;CACZ,eAAe;CACf,YAAY;AACb;;AAEA,yCAAyC;AACzC;CACC,YAAY;CACZ;AACD;;AAEA;CACC,WAAW;CACX;AACD;;AAEA;CACC,YAAY;CACZ,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA,oDAAoD;AACpD;;CAEC,cAAc;AACf;AACA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA,mDAAmD;AACnD;CACC,gBAAgB;CAChB,2BAA2B;CAC3B,cAAc;AACf;;AAEA;CACC;EACC;CACD;AACD;;AAEA,yCAAyC;AACzC;CACC;AACD;;AAEA;CACC,eAAe;CACf,SAAS;CACT,WAAW;CACX;AACD;;AAEA;CACC;EACC;CACD;AACD;;AAEA;CACC;EACC;CACD;AACD;;AAEA;CACC,aAAa;CACb;AACD;;AAEA;CACC,8BAA8B;CAC9B,sBAAsB;CACtB,uBAAuB;CACvB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,0BAA0B;CAC1B,gBAAgB;CAChB,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,iBAAiB;CACjB;AACD;;AAEA;CACC;AACD;;AAEA;;;CAGC;AACD;;AAEA;CACC,WAAW;CACX,cAAc;CACd;AACD;;AAEA;CACC,UAAU;CACV,cAAc;CACd;AACD;;AAEA;CACC,gBAAgB;CAChB,0BAA0B;CAC1B,cAAc;CACd,aAAa;CACb;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CACd,qBAAqB;CACrB,WAAW;CACX;AACD;;AAEA;CACC,UAAU;CACV;AACD;;AAEA;CACC,eAAe;CACf;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC,mBAAmB;CACnB,sBAAsB;CACtB;AACD;;AAEA;CACC,qBAAqB;CACrB,cAAc;CACd,yBAAyB;CACzB,qBAAqB;CACrB,eAAe;CACf;AACD;;AAEA;CACC,uBAAuB;CACvB,aAAa;CACb,iBAAiB;CACjB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB;AACD;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB;AACD;;AAEA;CACC,mBAAmB;CACnB,aAAa;CACb,WAAW;CACX;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,mBAAmB;CACnB,kBAAkB;CAClB,qBAAqB;CACrB,gBAAgB;CAChB,yBAAyB;CACzB,kCAAkC;CAClC,+BAA+B;CAC/B,0BAA0B;CAC1B,UAAU;CACV;AACD;;AAEA;CACC,gCAAgC;CAChC,oBAAoB;CACpB;AACD;;AAEA;CACC,UAAU;CACV;AACD;;AAEA;CACC,iBAAiB;CACjB,WAAW;CACX,cAAc;CACd,uBAAuB;CACvB,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,WAAW;CACX,WAAW;CACX,WAAW;CACX;AACD;;AAEA;CACC,eAAe;CACf;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,qBAAqB;CACrB,iBAAiB;CACjB;AACD;;AAEA;CACC,6BAA6B;CAC7B,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,mBAAmB;CACnB,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,eAAe;CACf;AACD;;AAEA;CACC,yBAAyB;CACzB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,gBAAgB;CAChB;AACD;;AAEA;CACC,SAAS;CACT;AACD;;AAEA;CACC;AACD;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,uBAAuB;CACvB;AACD;;AAEA;;;CAGC,iBAAiB;CACjB;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,gBAAgB;CAChB;AACD;;AAEA;CACC,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,QAAQ;CACR,YAAY;CACZ;AACD;;AAEA;CACC;AACD;;AAEA;CACC,gBAAgB;CAChB,YAAY;CACZ;AACD;;AAEA;CACC,mBAAmB;CACnB,gBAAgB;CAChB,uBAAuB;CACvB,SAAS;CACT;AACD;;AAEA;CACC,iBAAiB;CACjB,eAAe;CACf,WAAW;CACX,WAAW;CACX;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,YAAY;CACZ,cAAc;CACd,kBAAkB;CAClB;AACD;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB;AACD;;AAEA;CACC,YAAY;CACZ,kBAAkB;CAClB,UAAU;CACV,eAAe;CACf;AACD;;AAEA;CACC,eAAe;CACf,+CAA+C;CAC/C,kBAAkB;CAClB,kDAAkD;CAClD;AACD;;AAEA;CACC,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB;AACD;;AAEA;CACC,2BAA2B;CAC3B,2BAA2B;CAC3B;AACD;;AAEA;CACC,qDAAqD;CACrD;AACD;;AAEA;;;CAGC,oCAAoC;CACpC,8BAA8B;CAC9B;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kCAAkC;CAClC;AACD;;AAEA;CACC,oCAAoC;CACpC,8CAA8C;CAC9C;AACD;;AAEA;CACC;AACD;;AAEA;CACC,6CAA6C;CAC7C;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX;AACD;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,YAAY;CACZ,YAAY;CACZ,mBAAmB;CACnB,iBAAiB;CACjB,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,WAAW;CACX,eAAe;CACf;AACD;;AAEA;CACC,UAAU;CACV;AACD;;AAEA;CACC,UAAU;CACV,YAAY;CACZ;AACD;;AAEA;CACC,UAAU;CACV;AACD;;AAEA;CACC,YAAY;CACZ;AACD;;AAEA;;CAEC,qCAAqC;CACrC;AACD;;AAEA;;;;CAIC,YAAY;CACZ,WAAW;CACX,eAAe;CACf;AACD;;AAEA;;;;CAIC;AACD;;AAEA;;;;CAIC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC,mBAAmB;CACnB;AACD;;AAEA;CACC,cAAc;CACd,WAAW;CACX;AACD;;AAEA;CACC,0BAA0B;CAC1B,8BAA8B;CAC9B,iBAAiB;CACjB;AACD;;AAEA;CACC,0BAA0B;CAC1B,2BAA2B;CAC3B;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;EACC,gBAAiB;CACjB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,eAAe;CACf,WAAW;CACX;AACD;;AAEA;CACC;AACD;;AAEA;CACC,yBAAyB;CACzB,gCAAgC;CAChC;AACD;;AAEA;CACC,yBAAyB;CACzB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,YAAY;CACZ,YAAY;CACZ;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC,sBAAsB;CACtB,0BAA0B;CAC1B,uBAAuB;CACvB,gBAAgB;CAChB,aAAa;CACb;AACD;;AAEA;CACC;AACD;;AAEA;CACC,sBAAsB;CACtB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,aAAa;CACb,aAAa;CACb,cAAc;CACd,yBAAyB;CACzB;AACD;;AAEA;CACC,mBAAmB;CACnB,YAAY;CACZ,oBAAoB;CACpB,aAAa;CACb,iBAAiB;CACjB;AACD;;AAEA;CACC,kBAAkB;CAClB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,8BAA8B;CAC9B,sCAAsC;CACtC,WAAW;CACX,kBAAkB;CAClB;AACD;;AAEA;CACC,eAAe;CACf,kBAAkB;CAClB,iBAAiB;CACjB,kBAAkB;CAClB;AACD;;AAEA;CACC,yBAAyB;CACzB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,mBAAmB;CACnB,gBAAgB;CAChB,aAAa;CACb,WAAW;CACX,eAAe;CACf,OAAO;CACP,6BAA6B;CAC7B,UAAU;CACV,kBAAkB;CAClB,iBAAiB;CACjB,SAAS;CACT,aAAa;CACb,yBAAyB;CACzB,yBAAyB;CACzB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,aAAa;CACb,yBAAyB;CACzB,wBAAwB;CACxB,QAAQ;CACR,UAAU;CACV;AACD;;AAEA;CACC;AACD;;AAEA;CACC,eAAe;CACf,mBAAmB;CACnB,iBAAiB;CACjB,gBAAgB;CAChB,kBAAkB;CAClB,UAAU;CACV;AACD;;AAEA;CACC;AACD;;AAEA;CACC,mBAAmB;CACnB,kBAAkB;CAClB,kBAAkB;CAClB,YAAY;CACZ,kBAAkB;CAClB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,mBAAmB;CACnB,6BAA6B;CAC7B,kBAAkB;CAClB;AACD;;AAEA;CACC,mBAAmB;CACnB,gCAAgC;CAChC,kBAAkB;CAClB,mBAAmB;CACnB,kBAAkB;CAClB;AACD;;AAEA;CACC,eAAe;CACf,kBAAkB;CAClB,kBAAkB;CAClB,cAAc;CACd,gBAAgB;CAChB,yBAAyB;CACzB,kBAAkB;CAClB;AACD;;AAEA;CACC,UAAU;CACV,eAAe;CACf;AACD;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,SAAS;CACT,mBAAmB;CACnB,gBAAgB;CAChB,mBAAmB;CACnB,uBAAuB;CACvB;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,UAAU;CACV,qBAAqB;CACrB,mBAAmB;CACnB,gBAAgB;CAChB,yBAAyB;CACzB,kBAAkB;CAClB,kBAAkB;CAClB,YAAY;CACZ,YAAY;CACZ;AACD;;AAEA;CACC,WAAW;CACX,2BAA2B;CAC3B;AACD;;AAEA;CACC,WAAW;CACX;AACD;;AAEA;CACC;AACD;;AAEA;CACC,WAAW;CACX;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,gBAAgB;CAChB;AACD;;AAEA;CACC,kBAAkB;CAClB;AACD;;AAEA;CACC,YAAY;CACZ;AACD;;AAEA;CACC;AACD;;AAEA,6CAA6C;AAC7C,gCAAgC;AAChC;CACC,WAAW;CACX,WAAW;CACX,cAAc;CACd,kBAAkB;CAClB,eAAe;CACf,YAAY;CACZ,mBAAmB;CACnB,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,UAAU;CACV,eAAe;CACf,cAAc;CACd,WAAW;CACX;AACD;;AAEA;CACC;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;CACC,gCAAgC;CAChC,sBAAsB;CACtB,uBAAuB;CACvB,gBAAgB;CAChB,mBAAmB;CACnB;AACD;;AAEA;CACC;EACC,mBAAmB;EACnB,gBAAgB;EAChB;CACD;AACD;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,OAAO;CACP,YAAY;CACZ,8BAA8B;CAC9B;AACD;;AAEA;CACC;EACC;CACD;AACD;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB;AACD;;AAEA;CACC;EACC;CACD;AACD;;AAEA;CACC;EACC;CACD;AACD;;AAEA;CACC;AACD;;AAEA;CACC;EACC;CACD;AACD;;AAEA;CACC;AACD;;AAEA;CACC,gBAAgB;CAChB;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB;AACD;;AAEA;CACC,aAAa;CACb;AACD;;AAEA;CACC,SAAS;CACT;AACD;;AAEA;CACC;AACD;;AAEA;CACC,iBAAiB;CACjB,WAAW;CACX,YAAY;CACZ,sBAAsB;CACtB,kBAAkB;CAClB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,kBAAkB;CAClB,mBAAmB;CACnB;AACD;;AAEA;CACC,SAAS;CACT,kBAAkB;CAClB;AACD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,eAAe;CACf,SAAS;CACT,iBAAiB;CACjB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,WAAW;CACX;AACD;;AAEA;CACC,sBAAsB;CACtB,WAAW;CACX;AACD;;AAEA;CACC,cAAc;CACd,iBAAiB;CACjB,YAAY;CACZ,kBAAkB;CAClB;AACD;;AAEA;CACC,eAAe;CACf;AACD;;AAEA;CACC,WAAW;CACX,eAAe;CACf,qBAAqB;CACrB,iBAAiB;CACjB;AACD;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,qBAAqB;CACrB,wBAAwB;CACxB,kBAAkB;CAClB,mBAAmB;CACnB,eAAe;CACf,mCAAmC;CACnC;AACD;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,mBAAmB;CACnB,yBAAyB;CACzB,0BAA0B;CAC1B,gBAAgB;CAChB,mBAAmB;CACnB,oCAAoC;CACpC,uBAAuB;CACvB,6BAA6B;CAC7B,kBAAkB;CAClB,4BAA4B;CAC5B,gBAAgB;CAChB;AACD;;AAEA;CACC,iCAAiC;CACjC,uBAAuB;CACvB,4BAA4B;CAC5B,6BAA6B;CAC7B,+BAA+B;CAC/B,6BAA6B;CAC7B,yCAAyC;CACzC,+BAA+B;CAC/B,oCAAoC;CACpC,uCAAuC;CACvC,qCAAqC;CACrC,sCAAsC;CACtC,4BAA4B;CAC5B,iCAAiC;CACjC,oCAAoC;CACpC;AACD;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,cAAc;CACd,kBAAkB;CAClB,WAAW;CACX,SAAS;CACT;AACD;;AAEA;CACC,SAAS;CACT,eAAe;CACf,cAAc;CACd,sBAAsB;CACtB;AACD;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB;AACD;;AAEA;;;CAGC,kBAAkB;CAClB,SAAS;CACT,iBAAiB;CACjB,UAAU;CACV;AACD;;AAEA;CACC;AACD;;AAEA;CACC,eAAe;CACf;AACD;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,eAAe;CACf,cAAc;CACd,WAAW;CACX,+BAA+B;CAC/B,cAAc;CACd,WAAW;CACX,8BAA8B;CAC9B;AACD;;AAEA;CACC,WAAW;CACX;AACD;;AAEA;CACC,WAAW;CACX;AACD;;AAEA;CACC;AACD;;AAEA;CACC,eAAe;CACf,YAAY;CACZ,kBAAkB;CAClB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,0BAA0B;CAC1B,iBAAiB;CACjB,mBAAmB;CACnB;AACD;;AAEA;CACC,aAAa;CACb;AACD;;AAEA;CACC,iBAAiB;CACjB,gBAAgB;CAChB,oCAAoC;CACpC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,0CAA0C;CAC1C,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;CAClB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,gCAAgC;CAChC;AACD;;AAEA;CACC,WAAW;CACX,eAAe;CACf,kBAAkB;CAClB;AACD;;AAEA;CACC,0CAA0C;CAC1C,mBAAmB;CACnB,cAAc;CACd,YAAY;CACZ,kBAAkB;CAClB;AACD;;AAEA;CACC,2BAA2B;CAC3B,gBAAgB;CAChB;AACD;;AAEA,wCAAwC;AACxC;;;CAGC,kBAAkB;CAClB;AACD;;AAEA;;CAEC,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,WAAW;CACX,gCAAgC;CAChC,kBAAkB;CAClB;AACD;;AAEA;CACC,SAAS;CACT,WAAW;CACX;AACD;;AAEA;CACC,UAAU;CACV;AACD;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB;AACD;;AAEA;CACC,YAAY;CACZ,cAAc;CACd,eAAe;CACf;AACD;;AAEA;CACC,gBAAgB;CAChB,cAAc;CACd;AACD;;AAEA;CACC;EACC,kBAAkB;EAClB;CACD;AACD;;AAEA;CACC,eAAe;CACf,6BAA6B;CAC7B,oBAAoB;CACpB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,WAAW;CACX,gBAAgB;CAChB,eAAe;CACf,qBAAqB;CACrB;AACD;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB;AACD;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,YAAY;CACZ;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,WAAW;CACX;AACD;;AAEA;CACC,UAAU;CACV,eAAe;CACf,SAAS;CACT,QAAQ;CACR,gBAAgB;CAChB,yBAAyB;CACzB,eAAe;CACf,gBAAgB;CAChB,2BAA2B;CAC3B,aAAa;CACb;AACD;;AAEA;CACC,YAAY;CACZ,mBAAmB;CACnB,WAAW;CACX;AACD;;AAEA;CACC,4BAA4B;CAC5B;AACD;;AAEA;CACC;AACD;;AAEA;CACC,YAAY;CACZ,gBAAgB;CAChB,iBAAiB;CACjB,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;CAClB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,OAAO;CACP,mBAAmB;CACnB,eAAe;CACf,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA;CACC,6BAA6B;CAC7B,cAAc;CACd,yBAAyB;CACzB,WAAW;CACX;AACD;;AAEA;CACC,cAAc;CACd,WAAW;CACX,UAAU;CACV,mBAAmB;CACnB,eAAe;CACf,oBAAoB;CACpB,WAAW;CACX,SAAS;CACT;AACD;;AAEA;CACC,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC,eAAe;CACf;AACD;;AAEA;CACC,eAAe;CACf;AACD;;AAEA;CACC,eAAe;CACf,YAAY;CACZ,WAAW;CACX,iBAAiB;CACjB;AACD;;AAEA;CACC,4BAA4B;CAC5B;AACD;;AAEA;CACC,2BAA2B;CAC3B;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CACd,yBAAyB;CACzB;AACD;;AAEA;CACC,cAAc;CACd,yBAAyB;CACzB;AACD;;AAEA;CACC,gBAAgB;CAChB,cAAc;CACd;AACD;;AAEA;;;CAGC,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;;;CAGC,yBAAyB;CACzB,gCAAgC;CAChC,kBAAkB;CAClB,OAAO;CACP,kCAAkC;CAClC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,iBAAiB;CACjB,WAAW;CACX,8BAA8B;CAC9B,yBAAyB;CACzB,gBAAgB;CAChB,gBAAgB;CAChB,kBAAkB;CAClB,WAAW;CACX,UAAU;CACV,UAAU;CACV;AACD;;AAEA;CACC,WAAW;CACX,cAAc;CACd,SAAS;CACT,QAAQ;CACR,yDAAyD;CACzD,mBAAmB;CACnB,sBAAsB;CACtB,kBAAkB;CAClB,WAAW;CACX;AACD;;AAEA;CACC,OAAO;CACP;AACD;;AAEA;CACC;AACD;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,kBAAkB;CAClB,uBAAuB;CACvB,kBAAkB;CAClB,sBAAsB;CACtB,0BAA0B;CAC1B;AACD;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,SAAS;CACT,UAAU;CACV,eAAe;CACf,iBAAiB;CACjB,WAAW;CACX,yBAAyB;CACzB;AACD;;AAEA;CACC,yBAAyB;CACzB,mBAAmB;CACnB,eAAe;CACf;AACD;;AAEA;CACC,gBAAgB;CAChB,gBAAgB;CAChB,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,mBAAmB;CACnB,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA;;;;CAIC;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;;;;;CAKC;AACD;;AAEA;CACC,cAAc;CACd,yBAAyB;CACzB;AACD;;AAEA;;;;;CAKC,cAAc;CACd,yBAAyB;CACzB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,iBAAiB;CACjB,qBAAqB;CACrB,eAAe;CACf,YAAY;CACZ,gBAAgB;CAChB,gBAAgB;CAChB,kBAAkB;CAClB,WAAW;CACX,sBAAsB;CACtB,yBAAyB;CACzB;AACD;;AAEA;;;CAGC,eAAe;CACf;AACD;;AAEA;CACC,mBAAmB;CACnB,WAAW;CACX;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,YAAY;CACZ,eAAe;CACf;AACD;;AAEA,iDAAiD;AACjD;CACC,mBAAmB;CACnB;AACD;;AAEA;CACC,oBAAoB;CACpB;AACD;;AAEA;CACC,qBAAqB;CACrB,gBAAgB;CAChB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,kBAAkB;CAClB,sBAAsB;CACtB,eAAe;CACf,cAAc;CACd,gDAAgD;CAChD,yBAAyB;CACzB,2DAA2D;CAC3D,2BAA2B;CAC3B,uHAAuH;CACvH,qCAAqC;CACrC,uEAAuE;CACvE,kEAAkE;CAClE,yBAAyB;CACzB,4BAA4B;CAC5B,kBAAkB;CAClB;AACD;;AAEA;CACC,oBAAoB;CACpB;AACD;;AAEA;CACC,eAAe;CACf;AACD;;AAEA;CACC,WAAW;CACX,UAAU;CACV,aAAa;CACb,aAAa;CACb,eAAe;CACf,gBAAgB;CAChB,kBAAkB;CAClB,yBAAyB;CACzB;AACD;;AAEA;CACC,eAAe;CACf,mBAAmB;CACnB;AACD;;AAEA;CACC,cAAc;CACd,kBAAkB;CAClB;AACD;;AAEA;CACC,WAAW;CACX;AACD;;AAEA;CACC;EACC,eAAe;EACf;CACD;CACA;EACC,YAAY;EACZ;CACD;AACD;;AAEA;CACC,sBAAsB;CACtB,gBAAgB;CAChB,kBAAkB;CAClB,YAAY;CACZ;AACD;;AAEA;CACC,uBAAuB;CACvB,0BAA0B;CAC1B,cAAc;CACd,WAAW;CACX,gBAAgB;CAChB,qBAAqB;CACrB,mBAAmB;CACnB,cAAc;CACd,iBAAiB;CACjB,gBAAgB;CAChB,kBAAkB;CAClB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,iBAAiB;CACjB,cAAc;CACd,qBAAqB;CACrB;AACD;;AAEA;CACC,WAAW;CACX,WAAW;CACX,sBAAsB;CACtB,eAAe;CACf,6BAA6B;CAC7B,YAAY;CACZ,uBAAuB;CACvB,WAAW;CACX;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;CACC,WAAW;CACX,WAAW;CACX;AACD;;AAEA;CACC,8BAA8B;CAC9B;AACD;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;CACnB,YAAY;CACZ,mBAAmB;CACnB,kBAAkB;CAClB,kBAAkB;CAClB,UAAU;CACV,WAAW;CACX;AACD;;AAEA;CACC,yBAAyB;CACzB,sBAAsB;CACtB,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,mBAAmB;CACnB;AACD;;AAEA;CACC,+BAA+B;CAC/B,aAAa;CACb;AACD;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;CACnB,SAAS;CACT;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,gCAAgC;CAChC;AACD;;AAEA;CACC,SAAS;CACT,8BAA8B;CAC9B,iBAAiB;CACjB,kBAAkB;CAClB;AACD;;AAEA;CACC,YAAY;CACZ;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,OAAO;CACP;AACD;;AAEA;CACC,cAAc;CACd,YAAY;CACZ,eAAe;CACf;AACD;;AAEA;CACC,cAAc;CACd,gBAAgB;CAChB,WAAW;CACX,mBAAmB;CACnB;AACD;;AAEA;CACC,cAAc;CACd,mBAAmB;CACnB;AACD;;AAEA;CACC,YAAY;CACZ,YAAY;CACZ,QAAQ;CACR,kBAAkB;CAClB,UAAU;CACV,MAAM;CACN,SAAS;CACT,oBAAoB;CACpB,kCAAkC;CAClC,qCAAqC;CACrC;AACD;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf;AACD;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,WAAW;CACX,QAAQ;CACR,cAAc;CACd,WAAW;CACX,YAAY;CACZ,yBAAyB;CACzB,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,mCAAmC;CACnC,kBAAkB;CAClB,kBAAkB;CAClB,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;CACC,sBAAsB;CACtB;AACD;;AAEA;CACC,WAAW;CACX,YAAY;CACZ;AACD;;AAEA;CACC,WAAW;CACX,YAAY;CACZ;AACD;;AAEA;CACC,WAAW;CACX,sBAAsB;CACtB,eAAe;CACf,iBAAiB;CACjB,WAAW;CACX,YAAY;CACZ,cAAc;CACd,sBAAsB;CACtB,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,SAAS;CACT;AACD;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,YAAY;CACZ,aAAa;CACb,eAAe;CACf,kBAAkB;CAClB;AACD;;AAEA;CACC,kBAAkB;CAClB,MAAM;CACN;AACD;;AAEA;CACC,qBAAqB;CACrB,kBAAkB;CAClB,UAAU;CACV;AACD;;AAEA;CACC,YAAY;CACZ,kBAAkB;CAClB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CACd,gBAAgB;CAChB,yBAAyB;CACzB;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC,iBAAiB;CACjB,gCAAgC;CAChC;AACD;;AAEA;CACC,UAAU;CACV;AACD;;AAEA;CACC,UAAU;CACV,WAAW;CACX;AACD;;AAEA;CACC,kDAAkD;CAClD,oBAAoB;CACpB,kBAAkB;CAClB,uHAAuH;CACvH,kEAAkE;CAClE,oBAAoB;CACpB;AACD;;AAEA;CACC,oBAAoB;CACpB;AACD;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,YAAY;CACZ,mBAAmB;CACnB,gBAAgB;CAChB;AACD;;AAEA;CACC,UAAU;CACV;AACD;;AAEA;CACC;AACD;;AAEA;CACC,UAAU;CACV;AACD;;AAEA;CACC;AACD;;AAEA;CACC,eAAe;CACf,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,wCAAwC;CACxC,cAAc;CACd,kBAAkB;CAClB;AACD;;AAEA;CACC,yBAAyB;CACzB;AACD;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,SAAS;CACT;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC,kBAAkB;CAClB;AACD;;AAEA;CACC,kBAAkB;CAClB;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC,eAAe;CACf,WAAW;CACX;AACD;;AAEA;CACC,eAAe;CACf,oBAAoB;CACpB,uBAAuB;CACvB;AACD;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC,aAAa;CACb;AACD;;AAEA;CACC;AACD;;AAEA;CACC,WAAW;CACX,gBAAgB;CAChB,sBAAsB;CACtB,cAAc;CACd,eAAe;CACf;AACD;;AAEA;CACC,UAAU;CACV;AACD;;AAEA;CACC,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,6BAA6B;CAC7B;AACD;;AAEA;CACC,8BAA8B;CAC9B,yBAAyB;CACzB,WAAW;CACX;AACD;;AAEA;CACC,UAAU;CACV;AACD;;AAEA;;CAEC,iCAAiC;CACjC;AACD;;AAEA;;CAEC,YAAY;CACZ,WAAW;CACX,WAAW;CACX,qBAAqB;CACrB,kBAAkB;CAClB,YAAY;CACZ,mBAAmB;CACnB;AACD;;AAEA;CACC,YAAY;CACZ;AACD;;AAEA;CACC,iBAAiB;CACjB;AACD;;AAEA;CACC,gBAAgB;CAChB,SAAS;CACT,eAAe;CACf,mBAAmB;CACnB;AACD;;AAEA;CACC,iBAAiB;CACjB,SAAS;CACT;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,6BAA6B;CAC7B;AACD;;AAEA;CACC;AACD;;AAEA;CACC,mBAAmB;CACnB,SAAS;CACT,cAAc;CACd,oBAAoB;CACpB;AACD;;AAEA;CACC,gCAAgC;CAChC,oBAAoB;CACpB;AACD;;AAEA;CACC,qBAAqB;CACrB,kBAAkB;CAClB,eAAe;CACf,UAAU;CACV,eAAe;CACf;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,iBAAiB;CACjB;AACD;;AAEA;CACC,kBAAkB;CAClB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,mBAAmB;CACnB,aAAa;CACb,WAAW;CACX,iBAAiB;CACjB;AACD;;AAEA;CACC,0BAA0B;CAC1B,eAAe;CACf,0BAA0B;CAC1B,SAAS;CACT;AACD;;AAEA;CACC,eAAe;CACf;AACD;;AAEA;CACC,kCAAkC;CAClC;AACD;;AAEA;CACC,mBAAmB;CACnB,kBAAkB;CAClB,iBAAiB;CACjB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,yBAAyB;CACzB,0BAA0B;CAC1B,kBAAkB;CAClB,+BAA+B;CAC/B;AACD;;AAEA;CACC,eAAe;CACf,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,WAAW;CACX,YAAY;CACZ,SAAS;CACT;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,kBAAkB;CAClB,eAAe;CACf,gBAAgB;CAChB,WAAW;CACX,wBAAwB;CACxB,cAAc;CACd,UAAU;CACV,SAAS;CACT,YAAY;CACZ,iBAAiB;CACjB,sBAAsB;CACtB;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC,OAAO;CACP;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC,kBAAkB;CAClB,YAAY;CACZ,cAAc;CACd,0BAA0B;CAC1B,kCAAkC;CAClC;AACD;;AAEA;CACC,aAAa;CACb;AACD;;AAEA;CACC,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,aAAa;CACb;AACD;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;CAClB,kBAAkB;CAClB,+BAA+B;CAC/B;AACD;;AAEA;;CAEC,kBAAkB;CAClB,WAAW;CACX,gBAAgB;CAChB,MAAM;CACN;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;CACC,yBAAyB;CACzB,WAAW;CACX,kBAAkB;CAClB,kBAAkB;CAClB,eAAe;CACf,YAAY;CACZ,+BAA+B;CAC/B;AACD;;AAEA;CACC;AACD;;AAEA;CACC,qBAAqB;CACrB,WAAW;CACX,eAAe;CACf,gBAAgB;CAChB;AACD;;AAEA;CACC,2BAA2B;CAC3B,kBAAkB;CAClB,eAAe;CACf,kBAAkB;CAClB,WAAW;CACX,uBAAuB;CACvB;AACD;;AAEA;CACC,qBAAqB;CACrB,qBAAqB;CACrB,iBAAiB;CACjB,gBAAgB;CAChB,WAAW;CACX,yBAAyB;CACzB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,UAAU;CACV,oCAAoC;CACpC;AACD;;AAEA;CACC,6BAA6B;CAC7B,UAAU;CACV;AACD;;AAEA;CACC,4BAA4B;CAC5B,UAAU;CACV;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC,UAAU;CACV;AACD;;AAEA;CACC;AACD;;;AAGA;;;;;;EAME;;AAEF;;CAEC,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC,WAAW;CACX;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;;CAGC,4BAA4B;CAC5B;AACD;;AAEA;;;CAGC,gCAAgC;CAChC;AACD;;AAEA;CACC,0BAA0B;CAC1B,eAAe;CACf,cAAc;CACd,mBAAmB;CACnB,uBAAuB;CACvB;AACD;;AAEA;CACC,0BAA0B;CAC1B,eAAe;CACf,mBAAmB;CACnB,uBAAuB;CACvB;AACD;;AAEA;CACC,gBAAgB;CAChB,YAAY;CACZ;AACD;;AAEA;CACC,YAAY;CACZ,YAAY;CACZ;AACD;;AAEA;CACC,6BAA6B;CAC7B,+BAA+B;CAC/B,kBAAkB;CAClB;AACD;;AAEA;;;CAGC,gCAAgC;CAChC,wBAAwB;CACxB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CACd,sBAAsB;CACtB,kBAAkB;CAClB,uCAAuC;CACvC,eAAe;CACf;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CACd,WAAW;CACX,WAAW;CACX;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;CACC,gBAAgB;CAChB;AACD;;AAEA;CACC,aAAa;CACb,WAAW;CACX,gBAAgB;CAChB,6CAA6C;CAC7C,yBAAyB;CACzB;AACD;;AAEA;CACC,cAAc;CACd,YAAY;CACZ;AACD;;AAEA;CACC,WAAW;CACX,gBAAgB;CAChB,kBAAkB;CAClB,sBAAsB;CACtB,kBAAkB;CAClB,sBAAsB;CACtB;AACD;;AAEA;CACC,kBAAkB;CAClB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,aAAa;CACb,YAAY;CACZ;AACD;;AAEA;CACC,aAAa;CACb;AACD;;AAEA;CACC,YAAY;CACZ;AACD;;AAEA;CACC;EACC;CACD;AACD;;AAEA;CACC,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,aAAa;CACb,kBAAkB;CAClB,MAAM;CACN,QAAQ;CACR,SAAS;CACT,OAAO;CACP,gFAA6D;CAC7D,YAAY;CACZ,yBAAyB;CACzB;AACD;;AAEA;CACC,kBAAkB;CAClB;AACD;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,oCAAoC;CACpC,0CAA0C;CAC1C,uBAAuB;CACvB,eAAe;CACf;AACD;;AAEA;CACC,iBAAiB;CACjB;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd;AACD;;AAEA;CACC,gCAAgC;CAChC,mBAAmB;CACnB,cAAc;CACd,eAAe;CACf;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,mDAAmD;CACnD,YAAY;CACZ;AACD;;AAEA;CACC,YAAY;CACZ,aAAa;CACb,WAAW;CACX,YAAY;CACZ;AACD;;AAEA;CACC,WAAW;CACX;AACD;;AAEA;CACC,cAAc;CACd,iBAAiB;CACjB,yBAAyB;CACzB,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,UAAU;CACV,gBAAgB;CAChB,cAAc;CACd,gBAAgB;CAChB;AACD;;AAEA;;CAEC,kBAAkB;CAClB,QAAQ;CACR;AACD;;AAEA;CACC,WAAW;CACX,UAAU;CACV;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC,WAAW;CACX,0BAA0B;CAC1B;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC,gCAAgC;CAChC,uCAAuC;CACvC,iCAAiC;CACjC,6BAA6B;CAC7B,oCAAoC;CACpC,8BAA8B;CAC9B,2BAA2B;CAC3B,kCAAkC;CAClC,4BAA4B;CAC5B,4BAA4B;CAC5B,mCAAmC;CACnC,6BAA6B;CAC7B,wBAAwB;CACxB,+BAA+B;CAC/B;AACD;;AAEA;CACC,aAAa;CACb;AACD;;AAEA;CACC;AACD;;AAEA;CACC,WAAW;CACX;AACD;;AAEA;CACC,YAAY;CACZ;AACD;;AAEA;;CAEC,YAAY;CACZ,cAAc;CACd,SAAS;CACT,WAAW;CACX;AACD;;AAEA;CACC,cAAc;CACd,iBAAiB;CACjB,kBAAkB;CAClB,kBAAkB;CAClB,yBAAyB;CACzB;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,8CAA8C;CAC9C,uBAAuB;CACvB,iBAAiB;CACjB;AACD;;AAEA;;CAEC,WAAW;CACX,WAAW;CACX,kBAAkB;CAClB,SAAS;CACT;AACD;;AAEA;CACC,mBAAmB;CACnB,wDAAwD;CACxD;AACD;;AAEA;CACC,mBAAmB;CACnB,yDAAyD;CACzD;AACD;;AAEA;;CAEC,WAAW;CACX,WAAW;CACX,kBAAkB;CAClB,SAAS;CACT;AACD;;AAEA;CACC,mBAAmB;CACnB,wDAAwD;CACxD;AACD;;AAEA;CACC,mBAAmB;CACnB,yDAAyD;CACzD;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;;;CAGC,kBAAkB;CAClB,kEAAkE;CAClE,iEAAiE;CACjE,8DAA8D;CAC9D,yBAAyB;CACzB,WAAW;CACX,gBAAgB;CAChB;AACD;;AAEA;;;CAGC,qCAAqC;CACrC,oCAAoC;CACpC,iCAAiC;CACjC,sBAAsB;CACtB,yBAAyB;CACzB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,eAAe;CACf;AACD;;AAEA;CACC;AACD;;AAEA;CACC,2BAA2B;CAC3B,kBAAkB;CAClB;AACD;;AAEA;CACC,6BAA6B;CAC7B,gBAAgB;CAChB;AACD;;AAEA;CACC,mBAAmB;CACnB,0DAA0D;CAC1D,oHAAoH;CACpH,kDAAkD;CAClD,iDAAiD;CACjD,8CAA8C;CAC9C,0BAA0B;CAC1B,6BAA6B;CAC7B;AACD;;AAEA;;CAEC,WAAW;CACX;AACD;;AAEA;CACC,wFAAwF;CACxF,cAAc;CACd,eAAe;CACf,uBAAuB;CACvB,qBAAqB;CACrB;AACD;;AAEA;CACC,6BAA6B;CAC7B;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,gBAAgB;CAChB,eAAe;CACf,aAAa;CACb,MAAM;CACN,OAAO;CACP,WAAW;CACX;AACD;;AAEA;CACC,cAAc;CACd,kBAAkB;CAClB,UAAU;CACV,YAAY;CACZ,YAAY;CACZ,uCAAuC;CACvC,YAAY;CACZ;AACD;;AAEA;CACC,cAAc;CACd,eAAe;CACf,aAAa;CACb,SAAS;CACT;AACD;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,sBAAsB;CACtB,6BAA6B;CAC7B,sBAAsB;CACtB,uBAAuB;CACvB,kBAAkB;CAClB;AACD;;AAEA;CACC,gBAAgB;CAChB;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;EACC;CACD;CACA;EACC;CACD;AACD;;AAEA;CACC,iBAAiB;CACjB,uBAAuB;CACvB,yBAAyB;CACzB,sBAAsB;CACtB,YAAY;CACZ,uBAAuB;CACvB,wDAAwD;CACxD,4BAA4B;CAC5B,+BAA+B;CAC/B,8BAA8B;CAC9B,2BAA2B;CAC3B,gBAAgB;CAChB;AACD;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,6BAA6B;CAC7B,sBAAsB;CACtB,8BAA8B;CAC9B,2BAA2B;CAC3B,mBAAmB;CACnB,eAAe;CACf,gBAAgB;CAChB;AACD;;AAEA;CACC,yBAAyB;CACzB,sBAAsB;CACtB,qBAAqB;CACrB;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC,sBAAsB;CACtB,sBAAsB;CACtB,gBAAgB;CAChB;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC,eAAe;CACf,YAAY;CACZ,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,WAAW;CACX;AACD;;AAEA;CACC,WAAW;CACX;AACD;;AAEA;CACC,YAAY;CACZ,SAAS;CACT;AACD;;AAEA;;CAEC,yBAAyB;CACzB,WAAW;CACX;AACD;;AAEA;CACC,iBAAiB;CACjB,iBAAiB;CACjB;AACD;;AAEA;CACC;EACC;CACD;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,YAAY;CACZ;AACD;;AAEA;CACC,YAAY;CACZ;AACD;;AAEA;CACC,WAAW;CACX;AACD;;AAEA;CACC,WAAW;CACX,YAAY;CACZ;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;;CAGC,iBAAiB;CACjB;AACD;;AAEA;;;CAGC;AACD;;AAEA;CACC,cAAc;CACd,kBAAkB;CAClB;AACD;;AAEA;CACC,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,YAAY;CACZ;AACD;;AAEA;CACC;EACC;CACD;CACA;EACC,iBAAiB;EACjB;CACD;CACA;EACC,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB;CACD;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CACd,kBAAkB;CAClB,SAAS;CACT,UAAU;CACV,oBAAoB;CACpB;AACD;;AAEA;CACC,cAAc;CACd,gBAAgB;CAChB,kBAAkB;CAClB,WAAW;CACX;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;;CAEC,cAAc;CACd,kBAAkB;CAClB,eAAe;CACf,0BAA0B;CAC1B,UAAU;CACV;AACD;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,WAAW;CACX,gBAAgB;CAChB,SAAS;CACT,WAAW;CACX,UAAU;CACV;AACD;;AAEA;CACC;AACD;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,oBAAoB;CACpB,cAAc;CACd,kBAAkB;CAClB,eAAe;CACf,kBAAkB;CAClB,kBAAkB;CAClB;AACD;;AAEA;;CAEC,mBAAmB;CACnB;AACD;;AAEA;;CAEC,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,UAAU;CACV,UAAU;CACV;AACD;;AAEA;CACC,UAAU;CACV,WAAW;CACX;AACD;;AAEA;CACC,WAAW;CACX,0BAA0B;CAC1B,iBAAiB;CACjB,iBAAiB;CACjB;AACD;;AAEA;CACC,mBAAmB;CACnB,oBAAoB;CACpB,YAAY;CACZ,yBAAyB;CACzB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,UAAU;CACV,WAAW;CACX;AACD;;AAEA;CACC,cAAc;CACd,gBAAgB;CAChB,kBAAkB;CAClB,UAAU;CACV,WAAW;CACX;AACD;;AAEA;CACC,kBAAkB;CAClB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC,cAAc;CACd,kBAAkB;CAClB,eAAe;CACf,0BAA0B;CAC1B,UAAU;CACV;AACD;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,YAAY;CACZ,gBAAgB;CAChB,SAAS;CACT,UAAU;CACV,UAAU;CACV;AACD;;AAEA;CACC;AACD;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,oBAAoB;CACpB,cAAc;CACd,kBAAkB;CAClB,eAAe;CACf,kBAAkB;CAClB,kBAAkB;CAClB;AACD;;AAEA;;CAEC,mBAAmB;CACnB;AACD;;AAEA;;CAEC,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,SAAS;CACT,UAAU;CACV;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,iBAAiB;CACjB;AACD;;AAEA;CACC,iBAAiB;CACjB;AACD;;AAEA;CACC,kBAAkB;CAClB;AACD;;AAEA;CACC,WAAW;CACX;AACD;;AAEA;CACC,YAAY;CACZ,iBAAiB;CACjB;AACD;;AAEA;CACC,gBAAgB;CAChB,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,UAAU;CACV,aAAa;CACb;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CACd,0CAA0C;CAC1C;AACD;;AAEA;CACC,cAAc;CACd,0CAA0C;CAC1C;AACD;;AAEA;CACC,cAAc;CACd,0CAA0C;CAC1C;AACD;;AAEA;;CAEC,cAAc;CACd,yCAAyC;CACzC;AACD;;AAEA;CACC,cAAc;CACd,wCAAwC;CACxC;AACD;;AAEA;CACC,eAAe;CACf,YAAY;CACZ,QAAQ;CACR,YAAY;CACZ,YAAY;CACZ,aAAa;CACb;AACD;;AAEA;CACC,YAAY;CACZ,cAAc;CACd,kBAAkB;CAClB,UAAU;CACV;AACD;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,WAAW;CACX;AACD;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CACd,kBAAkB;CAClB,qBAAqB;CACrB,yBAAyB;CACzB;AACD;;AAEA;CACC,iBAAiB;CACjB,aAAa;CACb,kBAAkB;CAClB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,iBAAiB;CACjB,yBAAyB;CACzB,UAAU;CACV,WAAW;CACX,YAAY;CACZ,uBAAuB;CACvB,gBAAgB;CAChB;AACD;;AAEA;CACC,YAAY;CACZ,cAAc;CACd,YAAY;CACZ;AACD;;AAEA;CACC,eAAe;CACf,UAAU;CACV;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,iBAAiB;CACjB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;;CAEC;AACD;;AAEA;;;;;;CAMC,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;CACC,mBAAmB;CACnB,cAAc;CACd,sBAAsB;CACtB;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;CACC,YAAY;CACZ,gBAAgB;CAChB;AACD;;AAEA;CACC,sBAAsB;CACtB,4BAA4B;CAC5B,sBAAsB;CACtB,mBAAmB;CACnB,qCAAqC;CACrC,kBAAkB;CAClB,YAAY;CACZ,gBAAgB;CAChB;AACD;;AAEA;;;;CAIC;AACD;;AAEA;CACC,WAAW;CACX;AACD;;AAEA;;CAEC,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,eAAe;CACf;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC,gBAAgB;CAChB;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC,yBAAyB;CACzB;AACD;;AAEA;;CAEC,cAAc;CACd;AACD;;AAEA;;CAEC,eAAe;CACf,YAAY;CACZ,YAAY;CACZ,SAAS;CACT,eAAe;CACf,YAAY;CACZ,yBAAyB;CACzB,iBAAiB;CACjB;AACD;;AAEA;CACC,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;;;CAGC,WAAW;CACX;AACD;;AAEA;CACC;AACD;;AAEA;CACC,WAAW;CACX;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC,WAAW;CACX,cAAc;CACd,eAAe;CACf,mBAAmB;CACnB,YAAY;CACZ,iBAAiB;CACjB,kBAAkB;CAClB,6BAA6B;CAC7B,yBAAyB;CACzB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,sBAAsB;CACtB,sBAAsB;CACtB,kBAAkB;CAClB,WAAW;CACX,cAAc;CACd,eAAe;CACf,YAAY;CACZ,iBAAiB;CACjB,sBAAsB;CACtB,kBAAkB;CAClB,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA;CACC,gBAAgB;CAChB,SAAS;CACT;AACD;;AAEA;CACC,eAAe;CACf,mBAAmB;CACnB,yBAAyB;CACzB,cAAc;CACd,iBAAiB;CACjB,kBAAkB;CAClB,kBAAkB;CAClB;AACD;;AAEA;;CAEC,mBAAmB;CACnB,yBAAyB;CACzB;AACD;;AAEA;CACC,aAAa;CACb;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC,YAAY;CACZ,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC,WAAW;CACX;AACD;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,qBAAqB;CACrB;AACD;;AAEA;CACC,mBAAmB;CACnB;AACD;;AAEA;;CAEC,WAAW;CACX;AACD;;AAEA;CACC,iBAAiB;CACjB;AACD;;AAEA,iEAAiE;AACjE;;;;;;;CAOC,YAAY;CACZ,uBAAuB;CACvB,mBAAmB;CACnB,0BAA0B;AAC3B;;AAEA,wFAAwF;AACxF;;CAEC,YAAY;AACb;;AAEA,qCAAqC;AACrC;;CAEC,iBAAiB;CACjB,sBAAsB;CACtB,0BAA0B;CAC1B,4BAA4B;CAC5B,yBAAyB;CACzB,YAAY;CACZ,kBAAkB;CAClB,sBAAsB;CACtB,YAAY;CACZ,eAAe;CACf,eAAe;CACf,gBAAgB;CAChB,yBAAyB;CACzB,SAAS;CACT,YAAY;CACZ,iBAAiB;AAClB;AACA;;CAEC,uBAAuB;AACxB;AACA,iHAAiH;AACjH;;;;;;;;;;;;;;;;;;;;CAoBC;AACD;;CAEC,iBAAiB;CACjB,sBAAsB;CACtB,0BAA0B;CAC1B,4BAA4B;CAC5B,yBAAyB;CACzB,YAAY;CACZ,kBAAkB;CAClB,sBAAsB;CACtB,YAAY;CACZ,eAAe;CACf,eAAe;CACf,gBAAgB;CAChB,yBAAyB;CACzB,SAAS;CACT,YAAY;CACZ,iBAAiB;AAClB;AACA;;CAEC,yBAAyB;AAC1B;AACA;;CAEC,yBAAyB;AAC1B;AACA;;CAEC,yBAAyB;AAC1B;AACA;;CAEC,yBAAyB;AAC1B;AACA;;CAEC,yBAAyB;AAC1B;AACA;;CAEC,uBAAuB;AACxB;AACA;;CAEC,uBAAuB;AACxB;AACA;;CAEC,yBAAyB;AAC1B;AACA;;CAEC,cAAc;AACf;AACA;;CAEC,yBAAyB;CACzB,yBAAyB;CACzB,kBAAkB;CAClB,iBAAiB;CACjB,uBAAuB;CACvB,YAAY;AACb;;AAEA,4EAA4E;AAC5E;;CAEC,UAAU;AACX;AACA;;CAEC,yBAAyB;CACzB,yBAAyB;CACzB,kBAAkB;AACnB;AACA;;CAEC,yBAAyB;CACzB,yBAAyB;CACzB,kBAAkB;AACnB;AACA;;CAEC,yBAAyB;CACzB,yBAAyB;CACzB,kBAAkB;AACnB;AACA,2EAA2E;AAC3E;;CAEC,UAAU;AACX;AACA,iDAAiD;AACjD;;CAEC;EACC,gBAAgB;CACjB;AACD;AACA,mDAAmD;AACnD;;CAEC,iBAAiB;AAClB;AACA,uDAAuD;AACvD;;CAEC,aAAa;CACb,mBAAmB;AACpB","sourcesContent":["@charset \"UTF-8\";\r\n\r\n/* 04/24/2017 Paul.  Old background #2A3F54 */\r\n/* 12/28/2017 Paul.  Dark menu */\r\n.left_col {\r\n\tbackground: #64707B;\r\n\tcolor: white;\r\n}\r\n\r\n/* 06/29/2017 Paul.  Increase to 100px. */\r\n.nav-sm .container.body .col-md-3.left_col {\r\n\twidth: 100px;\r\n\tpadding: 0;\r\n\tz-index: 9999;\r\n\tposition: absolute\r\n}\r\n\r\n.nav-sm .container.body .col-md-3.left_col.menu_fixed {\r\n\tposition: fixed;\r\n\theight: 100%\r\n}\r\n\r\n.nav-sm .container.body .col-md-3.left_col .mCSB_container,\r\n.nav-sm .container.body .col-md-3.left_col .mCustomScrollBox {\r\n\toverflow: visible\r\n}\r\n\r\n.nav-sm .hidden-small {\r\n\tvisibility: hidden\r\n}\r\n\r\n/* 06/29/2017 Paul.  Increase to 100px. */\r\n.nav-sm .container.body .right_col {\r\n\tpadding: 10px 20px;\r\n\tmargin-left: 100px;\r\n\tz-index: 2\r\n}\r\n\r\n/* 06/29/2017 Paul.  Increase to 100px. */\r\n.nav-sm .navbar.nav_title {\r\n\twidth: 100px;\r\n}\r\n\r\n.nav-sm .navbar.nav_title a span {\r\n\tdisplay: none\r\n}\r\n\r\n.nav-sm .navbar.nav_title a i {\r\n\tfont-size: 27px;\r\n\tmargin: 13px 0 0 3px\r\n}\r\n\r\n/* 12/28/2017 Paul.  Keep Splendid yellow background #FFD14E. */\r\n.site_title\r\n{\r\n\tbackground-color: #FFD14E;\r\n\r\n}\r\n.site_title i {\r\n\tborder: 1px solid #EAEAEA;\r\n\tpadding: 5px 6px;\r\n\tborder-radius: 50%\r\n}\r\n\r\n/* 06/29/2017 Paul.  Increase to 100px. */\r\n.nav-sm .main_container .top_nav {\r\n\tdisplay: block;\r\n\tmargin-left: 100px;\r\n\tz-index: 2\r\n}\r\n\r\n/* 12/28/2017 Paul.  font-size 10px is too small. */\r\n.nav-sm .nav.side-menu li a {\r\n\ttext-align: center !important;\r\n\tfont-weight: 400;\r\n\tpadding: 10px 5px\r\n}\r\n\r\n/* 12/28/2017 Paul.  Dark menu */\r\n.nav-sm .nav.child_menu li.active,\r\n.nav-sm .nav.side-menu li.active-sm {\r\n\tborder-right: 5px solid #cccccc\r\n}\r\n\r\n.nav-sm ul.nav.child_menu ul,\r\n.nav-sm .nav.side-menu li.active-sm ul ul {\r\n\tposition: static;\r\n\twidth: 200px;\r\n\tbackground: none\r\n}\r\n\r\n.nav-sm > .nav.side-menu > li.active-sm > a {\r\n\tcolor: #1ABB9C !important\r\n}\r\n\r\n.nav-sm .nav.side-menu li a i.toggle-up {\r\n\tdisplay: none !important\r\n}\r\n\r\n.nav-sm .nav.side-menu li a i {\r\n\tfont-size: 25px !important;\r\n\ttext-align: center;\r\n\twidth: 100% !important;\r\n\tmargin-bottom: 5px\r\n}\r\n\r\n/* 04/24/2017 Paul.  Old background #3E5367 */\r\n/* 12/28/2017 Paul.  Dark menu */\r\n.nav-sm ul.nav.child_menu {\r\n\tleft: 100%;\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\twidth: 210px;\r\n\tz-index: 4000;\r\n\tbackground: #64707B;\r\n\tcolor: white;\r\n\tdisplay: none;\r\n}\r\n\r\n.nav-sm ul.nav.child_menu li {\r\n\tpadding: 0 10px\r\n}\r\n\r\n.nav-sm ul.nav.child_menu li a {\r\n\ttext-align: left !important\r\n}\r\n\r\n.nav-sm .profile {\r\n\tdisplay: none\r\n}\r\n\r\n.menu_section {\r\n\tmargin-bottom: 35px\r\n}\r\n\r\n.menu_section h3 {\r\n\tpadding-left: 23px;\r\n\tcolor: #fff;\r\n\ttext-transform: uppercase;\r\n\tletter-spacing: .5px;\r\n\tfont-weight: bold;\r\n\tfont-size: 11px;\r\n\tmargin-bottom: 0;\r\n\tmargin-top: 0;\r\n\ttext-shadow: 1px 1px #000\r\n}\r\n\r\n.menu_section > ul {\r\n\tmargin-top: 10px\r\n}\r\n\r\n.profile_pic {\r\n\twidth: 35%;\r\n\tfloat: left\r\n}\r\n\r\n.img-circle.profile_img {\r\n\twidth: 70%;\r\n\tbackground: #fff;\r\n\tmargin-left: 15%;\r\n\tz-index: 1000;\r\n\tposition: inherit;\r\n\tmargin-top: 20px;\r\n\tborder: 1px solid rgba(52, 73, 94, 0.44);\r\n\tpadding: 4px\r\n}\r\n\r\n.profile_info {\r\n\tpadding: 25px 10px 10px;\r\n\twidth: 65%;\r\n\tfloat: left\r\n}\r\n\r\n\t/* 04/24/2017 Paul.  Old color #BAB8B8 */\r\n\t/* 12/28/2017 Paul.  Dark menu */\r\n\t.profile_info span {\r\n\t\tfont-size: 13px;\r\n\t\tline-height: 30px;\r\n\t\tcolor: white;\r\n\t}\r\n\r\n\t/* 04/24/2017 Paul.  Old color #ECF0F1 */\r\n\t/* 12/28/2017 Paul.  Dark menu */\r\n\t.profile_info h2 {\r\n\t\tfont-size: 14px;\r\n\t\tcolor: white;\r\n\t\tmargin: 0;\r\n\t\tfont-weight: 300;\r\n\t}\r\n\r\n.profile.img_2 {\r\n\ttext-align: center\r\n}\r\n\r\n.profile.img_2 .profile_pic {\r\n\twidth: 100%\r\n}\r\n\r\n.profile.img_2 .profile_pic .img-circle.profile_img {\r\n\twidth: 50%;\r\n\tmargin: 10px 0 0\r\n}\r\n\r\n.profile.img_2 .profile_info {\r\n\tpadding: 15px 10px 0;\r\n\twidth: 100%;\r\n\tmargin-bottom: 10px;\r\n\tfloat: left\r\n}\r\n\r\n/* 04/24/2017 Paul.  Old color #C4CFDA, font-size: 10px; */\r\n/* 12/28/2017 Paul.  Dark menu */\r\n.main_menu span.fa {\r\n\tfloat: right;\r\n\ttext-align: center;\r\n\tmargin-top: 5px;\r\n\tmin-width: inherit;\r\n\tcolor: white;\r\n}\r\n\r\n.active a span.fa {\r\n\ttext-align: right !important;\r\n\tmargin-right: 4px\r\n}\r\n\r\n.nav-sm .menu_section {\r\n\tmargin: 0\r\n}\r\n\r\n.nav-sm span.fa,\r\n.nav-sm .menu_section h3 {\r\n\tdisplay: none\r\n}\r\n\r\n.nav-sm li li span.fa {\r\n\tdisplay: inline-block\r\n}\r\n\r\n.nav_menu {\r\n\tfloat: left;\r\n\tbackground: #EDEDED;\r\n\tborder-bottom: 1px solid #D9DEE4;\r\n\tmargin-bottom: 10px;\r\n\twidth: 100%;\r\n\tposition: relative\r\n}\r\n\r\n@media (min-width: 480px) {\r\n\t.nav_menu {\r\n\t\tposition: static\r\n\t}\r\n}\r\n\r\n.nav-md .container.body .col-md-3.left_col {\r\n\twidth: 230px;\r\n\tpadding: 0;\r\n\tposition: absolute;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\tz-index: 9999\r\n}\r\n\r\n.nav-md .container.body .col-md-3.left_col.menu_fixed {\r\n\theight: 100%;\r\n\tposition: fixed\r\n}\r\n\r\nbody .container.body .right_col {\r\n\tbackground: #F7F7F7\r\n}\r\n\r\n.nav-md .container.body .right_col {\r\n\tpadding: 10px 20px 0;\r\n\tmargin-left: 230px\r\n}\r\n\r\n/* 04/24/2017 Paul.  Old background #2A3F54 */\r\n/* 12/28/2017 Paul.  Dark menu */\r\n.nav_title {\r\n\twidth: 230px;\r\n\tfloat: left;\r\n\tbackground: #64707B;\r\n\tcolor: white;\r\n\tborder-radius: 0;\r\n\theight: 57px;\r\n}\r\n\r\n@media (max-width: 991px) {\r\n\t.nav-md .container.body .right_col,\r\n\t.nav-md .container.body .top_nav {\r\n\t\twidth: 100%;\r\n\t\tmargin: 0\r\n\t}\r\n\t.nav-md .container.body .col-md-3.left_col {\r\n\t\tdisplay: none\r\n\t}\r\n\t.nav-md .container.body .right_col {\r\n\t\twidth: 100%;\r\n\t\tpadding-right: 0\r\n\t}\r\n\t.right_col {\r\n\t\tpadding: 10px !important\r\n\t}\r\n}\r\n\r\n@media (max-width: 1200px) {\r\n\t.x_title h2 {\r\n\t\twidth: 62%;\r\n\t\tfont-size: 17px\r\n\t}\r\n\t.tile,\r\n\t.graph {\r\n\t\tzoom: 85%;\r\n\t\theight: inherit\r\n\t}\r\n}\r\n\r\n@media (max-width: 1270px) and (min-width: 192px) {\r\n\t.x_title h2 small {\r\n\t\tdisplay: none\r\n\t}\r\n}\r\n\r\n.left_col .mCSB_scrollTools {\r\n\twidth: 6px\r\n}\r\n\r\n.left_col .mCSB_dragger {\r\n\tmax-height: 400px !important\r\n}\r\n\r\n.blue {\r\n\tcolor: #3498DB\r\n}\r\n\r\n.purple {\r\n\tcolor: #9B59B6\r\n}\r\n\r\n.green {\r\n\tcolor: #1ABB9C\r\n}\r\n\r\n.aero {\r\n\tcolor: #9CC2CB\r\n}\r\n\r\n.red {\r\n\tcolor: #E74C3C\r\n}\r\n\r\n.dark {\r\n\tcolor: #34495E\r\n}\r\n\r\n.border-blue {\r\n\tborder-color: #3498DB !important\r\n}\r\n\r\n.border-purple {\r\n\tborder-color: #9B59B6 !important\r\n}\r\n\r\n.border-green {\r\n\tborder-color: #1ABB9C !important\r\n}\r\n\r\n.border-aero {\r\n\tborder-color: #9CC2CB !important\r\n}\r\n\r\n.border-red {\r\n\tborder-color: #E74C3C !important\r\n}\r\n\r\n.border-dark {\r\n\tborder-color: #34495E !important\r\n}\r\n\r\n.bg-white {\r\n\tbackground: #fff !important;\r\n\tborder: 1px solid #fff !important;\r\n\tcolor: #73879C\r\n}\r\n\r\n.bg-green {\r\n\tbackground: #1ABB9C !important;\r\n\tborder: 1px solid #1ABB9C !important;\r\n\tcolor: #fff\r\n}\r\n\r\n.bg-red {\r\n\tbackground: #E74C3C !important;\r\n\tborder: 1px solid #E74C3C !important;\r\n\tcolor: #fff\r\n}\r\n\r\n.bg-blue {\r\n\tbackground: #3498DB !important;\r\n\tborder: 1px solid #3498DB !important;\r\n\tcolor: #fff\r\n}\r\n\r\n.bg-orange {\r\n\tbackground: #F39C12 !important;\r\n\tborder: 1px solid #F39C12 !important;\r\n\tcolor: #fff\r\n}\r\n\r\n.bg-purple {\r\n\tbackground: #9B59B6 !important;\r\n\tborder: 1px solid #9B59B6 !important;\r\n\tcolor: #fff\r\n}\r\n\r\n.bg-blue-sky {\r\n\tbackground: #50C1CF !important;\r\n\tborder: 1px solid #50C1CF !important;\r\n\tcolor: #fff\r\n}\r\n\r\n.container {\r\n\twidth: 100%;\r\n\tpadding: 0\r\n}\r\n\r\n.navbar-nav > li > a,\r\n.navbar-brand,\r\n.navbar-nav > li > a {\r\n\tcolor: #fff !important\r\n}\r\n\r\n.top_nav .nav > li > a:focus,\r\n.top_nav .nav > li > a:hover,\r\n.top_nav .nav .open > a,\r\n.top_nav .nav .open > a:focus,\r\n.top_nav .nav .open > a:hover {\r\n\tbackground: #D9DEE4\r\n}\r\n\r\n/* 04/24/2017 Paul.  Old background #2A3F54 */\r\n/* 12/14/2019 Paul.  Old color: #73879C; */\r\nbody {\r\n\tbackground: white;\r\n\tfont-family: \"Helvetica Neue\", Roboto, Arial, \"Droid Sans\", sans-serif;\r\n\tfont-size: 13px;\r\n\tfont-weight: 400;\r\n\tline-height: 1.471;\r\n}\r\n\r\n.main_container .top_nav {\r\n\tdisplay: block;\r\n\tmargin-left: 230px\r\n}\r\n\r\n.no-padding {\r\n\tpadding: 0 !important\r\n}\r\n\r\n.page-title {\r\n\twidth: 100%;\r\n\theight: 65px;\r\n\tpadding: 10px 0\r\n}\r\n\r\n.page-title .title_left {\r\n\twidth: 45%;\r\n\tfloat: left;\r\n\tdisplay: block\r\n}\r\n\r\n.page-title .title_left h3 {\r\n\tmargin: 9px 0\r\n}\r\n\r\n.page-title .title_right {\r\n\twidth: 55%;\r\n\tfloat: left;\r\n\tdisplay: block\r\n}\r\n\r\n\t\t/* 04/25/2017 Paul.  Remove margin */\r\n\t\t.page-title .title_right .pull-right {\r\n\t\t\tmargin: 0px 0;\r\n\t\t}\r\n\r\n.fixed_height_320 {\r\n\theight: 320px\r\n}\r\n\r\n.fixed_height_390 {\r\n\theight: 390px\r\n}\r\n\r\n.fixed_height_200 {\r\n\theight: 200px\r\n}\r\n\r\n.overflow_hidden {\r\n\toverflow: hidden\r\n}\r\n\r\n.progress-bar-dark {\r\n\tbackground-color: #34495E !important\r\n}\r\n\r\n.progress-bar-gray {\r\n\tbackground-color: #BDC3C7 !important\r\n}\r\n\r\ntable.no-margin .progress {\r\n\tmargin-bottom: 0\r\n}\r\n\r\n.main_content {\r\n\tpadding: 10px 20px\r\n}\r\n\r\n.col-md-55 {\r\n\twidth: 50%;\r\n\tmargin-bottom: 10px\r\n}\r\n\r\n@media (min-width: 768px) {\r\n\t.col-md-55 {\r\n\t\twidth: 20%\r\n\t}\r\n}\r\n\r\n@media (min-width: 992px) {\r\n\t.col-md-55 {\r\n\t\twidth: 20%\r\n\t}\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n\t.col-md-55 {\r\n\t\twidth: 20%\r\n\t}\r\n}\r\n\r\n@media (min-width: 192px) and (max-width: 1270px) {\r\n\ttable.tile_info span.right {\r\n\t\tmargin-right: 7px;\r\n\t\tfloat: left\r\n\t}\r\n}\r\n\r\n.center-margin {\r\n\tmargin: 0 auto;\r\n\tfloat: none !important\r\n}\r\n\r\n.col-md-55,\r\n.col-xs-1,\r\n.col-sm-1,\r\n.col-md-1,\r\n.col-lg-1,\r\n.col-xs-2,\r\n.col-sm-2,\r\n.col-md-2,\r\n.col-lg-2,\r\n.col-xs-3,\r\n.col-sm-3,\r\n.col-md-3,\r\n.col-lg-3,\r\n.col-xs-4,\r\n.col-sm-4,\r\n.col-md-4,\r\n.col-lg-4,\r\n.col-xs-5,\r\n.col-sm-5,\r\n.col-md-5,\r\n.col-lg-5,\r\n.col-xs-6,\r\n.col-sm-6,\r\n.col-md-6,\r\n.col-lg-6,\r\n.col-xs-7,\r\n.col-sm-7,\r\n.col-md-7,\r\n.col-lg-7,\r\n.col-xs-8,\r\n.col-sm-8,\r\n.col-md-8,\r\n.col-lg-8,\r\n.col-xs-9,\r\n.col-sm-9,\r\n.col-md-9,\r\n.col-lg-9,\r\n.col-xs-10,\r\n.col-sm-10,\r\n.col-md-10,\r\n.col-lg-10,\r\n.col-xs-11,\r\n.col-sm-11,\r\n.col-md-11,\r\n.col-lg-11,\r\n.col-xs-12,\r\n.col-sm-12,\r\n.col-md-12,\r\n.col-lg-12 {\r\n\tposition: relative;\r\n\tmin-height: 1px;\r\n\tfloat: left;\r\n\tpadding-right: 10px;\r\n\tpadding-left: 10px\r\n}\r\n\r\n.row {\r\n\tmargin-right: -10px;\r\n\tmargin-left: -10px\r\n}\r\n\r\n.grid_slider .col-md-6 {\r\n\tpadding: 0 40px\r\n}\r\n\r\nh1,\r\n.h1,\r\nh2,\r\n.h2,\r\nh3,\r\n.h3 {\r\n\tmargin-top: 10px;\r\n\tmargin-bottom: 10px\r\n}\r\n\r\n/* 11/02/2020 Paul.  Change gentelella color to SplendidCRM color.  Restore underline. */\r\n/* 02/22/2021 Paul.  Remove underline. */\r\na {\r\n\tcolor: #444444;\r\n\ttext-decoration: inherit;\r\n}\r\n\r\na,\r\na:visited,\r\na:focus,\r\na:active,\r\n:visited,\r\n:focus,\r\n:active,\r\n.btn:focus,\r\n.btn:active:focus,\r\n.btn.active:focus,\r\n.btn.focus,\r\n.btn:active.focus,\r\n.btn.active.focus {\r\n\toutline: 0\r\n}\r\n\r\na:hover,\r\na:focus {\r\n\ttext-decoration: none\r\n}\r\n\r\n.navbar {\r\n\tmargin-bottom: 0\r\n}\r\n\r\n.navbar-header {\r\n\tbackground: #34495E\r\n}\r\n\r\n.navbar-right {\r\n\tmargin-right: 0\r\n}\r\n\r\n.top_nav .navbar-right {\r\n\tmargin: 0;\r\n\twidth: 70%;\r\n\tfloat: right\r\n}\r\n\r\n.top_nav .navbar-right li {\r\n\tdisplay: inline-block;\r\n\tfloat: right;\r\n\tposition: static\r\n}\r\n\r\n@media (min-width: 480px) {\r\n\t.top_nav .navbar-right li {\r\n\t\tposition: relative\r\n\t}\r\n}\r\n\r\n.top_nav .dropdown-menu li {\r\n\twidth: 100%\r\n}\r\n\r\n.top_nav .dropdown-menu li a {\r\n\twidth: 100%;\r\n\tpadding: 12px 20px\r\n}\r\n\r\n.top_nav li a i {\r\n\tfont-size: 15px\r\n}\r\n\r\n.navbar-static-top {\r\n\tposition: fixed;\r\n\ttop: 0;\r\n\twidth: 100%\r\n}\r\n\r\n.sidebar-header {\r\n\tborder-bottom: 0;\r\n\tmargin-top: 46px\r\n}\r\n\r\n.sidebar-header:first-of-type {\r\n\tmargin-top: 0\r\n}\r\n\r\n.nav.side-menu > li {\r\n\tposition: relative;\r\n\tdisplay: block;\r\n\tcursor: pointer\r\n}\r\n\r\n.nav.side-menu > li > a {\r\n\tmargin-bottom: 6px\r\n}\r\n\r\n.nav.side-menu > li > a:hover {\r\n\tcolor: #F2F5F7 !important\r\n}\r\n\r\n.nav.side-menu > li > a:hover,\r\n.nav > li > a:focus {\r\n\ttext-decoration: none;\r\n\tbackground: transparent\r\n}\r\n\r\n.nav.child_menu {\r\n\tdisplay: none\r\n}\r\n\r\n\t/* 04/24/2017 Paul.  Old background color rgba(255, 255, 255, 0.06) */\r\n\t.nav.child_menu li:hover,\r\n\t.nav.child_menu li.active {\r\n\t\tbackground-color: rgba(255, 255, 255, 0.26);\r\n\t}\r\n\r\n.nav.child_menu li {\r\n\tpadding-left: 36px\r\n}\r\n\r\n.nav-md ul.nav.child_menu li:before {\r\n\tbackground: #425668;\r\n\tbottom: auto;\r\n\tcontent: \"\";\r\n\theight: 8px;\r\n\tleft: 23px;\r\n\tmargin-top: 15px;\r\n\tposition: absolute;\r\n\tright: auto;\r\n\twidth: 8px;\r\n\tz-index: 1;\r\n\tborder-radius: 50%\r\n}\r\n\r\n.nav-md ul.nav.child_menu li:after {\r\n\tborder-left: 1px solid #425668;\r\n\tbottom: 0;\r\n\tcontent: \"\";\r\n\tleft: 27px;\r\n\tposition: absolute;\r\n\ttop: 0\r\n}\r\n\r\n.nav.side-menu > li > a,\r\n.nav.child_menu > li > a {\r\n\tcolor: #E7E7E7;\r\n\tfont-weight: 500\r\n}\r\n\r\n.nav.child_menu li li:hover,\r\n.nav.child_menu li li.active {\r\n\tbackground: none\r\n}\r\n\r\n.nav.child_menu li li a:hover,\r\n.nav.child_menu li li a.active {\r\n\tcolor: #fff\r\n}\r\n\r\n.nav > li > a {\r\n\tposition: relative;\r\n\tdisplay: block;\r\n\tpadding: 13px 15px 12px\r\n}\r\n\r\n/* 04/18/2017 Paul.  We want to allow clicking on name to navigate to list. */\r\n/* 04/24/2017 Paul.  Old color #E7E7E7 */\r\n/* 12/28/2017 Paul.  Dark menu */\r\n.nav > li > div\r\n{\r\n\tposition: relative;\r\n\tdisplay: block;\r\n\tpadding: 13px 15px 12px;\r\n\tcolor: white;\r\n\tfont-weight: 500;\r\n}\r\n\r\n/* 04/24/2017 Paul.  New background color rgba(255, 255, 255, 0.26) */\r\n.nav > li > div:hover\r\n{\r\n\tbackground-color: rgba(255, 255, 255, 0.26);\r\n}\r\n\r\n/* 04/24/2017 Paul.  Old color #1ABB9C */\r\n/* 12/28/2017 Paul.  Dark menu */\r\n.nav.side-menu > li.current-page, .nav.side-menu > li.active {\r\n\tborder-right: 5px solid #cccccc;\r\n}\r\n\r\n.nav li.current-page {\r\n\tbackground: rgba(255, 255, 255, 0.05)\r\n}\r\n\r\n.nav li li li.current-page {\r\n\tbackground: none\r\n}\r\n\r\n.nav li li.current-page a {\r\n\tcolor: #fff\r\n}\r\n\r\n.nav.side-menu > li.active > a {\r\n\ttext-shadow: rgba(0, 0, 0, 0.25) 0 -1px 0;\r\n\tbackground: linear-gradient(#334556, #2C4257), #2A3F54;\r\n\tbox-shadow: rgba(0, 0, 0, 0.25) 0 1px 0, inset rgba(255, 255, 255, 0.16) 0 1px 0\r\n}\r\n\r\n.navbar-brand,\r\n.navbar-nav > li > a {\r\n\tfont-weight: 500;\r\n\tcolor: #ECF0F1 !important;\r\n\tmargin-left: 0 !important;\r\n\tline-height: 32px\r\n}\r\n\r\n/* 04/24/2017 Paul.  Old color #ECF0F1 */\r\n/* 12/28/2017 Paul.  Dark menu */\r\n.site_title {\r\n\ttext-overflow: ellipsis;\r\n\toverflow: hidden;\r\n\tfont-weight: 400;\r\n\tfont-size: 22px;\r\n\twidth: 100%;\r\n\tcolor: white !important;\r\n\tmargin-left: 0 !important;\r\n\tline-height: 59px;\r\n\tdisplay: block;\r\n\theight: 55px;\r\n\tmargin: 0;\r\n\tpadding-left: 10px;\r\n}\r\n\r\n.site_title:hover,\r\n.site_title:focus {\r\n\ttext-decoration: none\r\n}\r\n\r\n/* 04/24/2017 Paul.  Old color #515356 */\r\n/* 12/28/2017 Paul.  Dark menu */\r\n.nav.navbar-nav > li > a {\r\n\tcolor: #5e6974 !important;\r\n}\r\n\r\n.nav.top_menu > li > a {\r\n\tposition: relative;\r\n\tdisplay: block;\r\n\tpadding: 10px 15px;\r\n\tcolor: #34495E !important\r\n}\r\n\r\n.nav > li > a:hover,\r\n.nav > li > a:focus {\r\n\tbackground-color: transparent\r\n}\r\n\r\n.top_search {\r\n\tpadding: 0\r\n}\r\n\r\n.top_search .form-control {\r\n\tborder-right: 0;\r\n\tbox-shadow: inset 0 1px 0px rgba(0, 0, 0, 0.075);\r\n\tborder-radius: 25px 0px 0px 25px;\r\n\tpadding-left: 20px;\r\n\tborder: 1px solid rgba(221, 226, 232, 0.49)\r\n}\r\n\r\n.top_search .form-control:focus {\r\n\tborder: 1px solid rgba(221, 226, 232, 0.49);\r\n\tborder-right: 0\r\n}\r\n\r\n.top_search .input-group-btn button {\r\n\tborder-radius: 0px 25px 25px 0px;\r\n\tborder: 1px solid rgba(221, 226, 232, 0.49);\r\n\tborder-left: 0;\r\n\tbox-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\r\n\tcolor: #93A2B2;\r\n\tmargin-bottom: 0 !important\r\n}\r\n\r\n/* 06/29/2017 Paul.  Increase to 100px. */\r\n.toggle {\r\n\tfloat: left;\r\n\tmargin: 0;\r\n\tpadding-top: 16px;\r\n\twidth: 100px\r\n}\r\n\r\n.toggle a {\r\n\tpadding: 15px 15px 0;\r\n\tmargin: 0;\r\n\tcursor: pointer\r\n}\r\n\r\n.toggle a i {\r\n\tfont-size: 26px\r\n}\r\n\r\n/* 04/24/2017 Paul.  Old color rgba(255, 255, 255, 0.75) */\r\n/* 12/28/2017 Paul.  Dark menu */\r\n.nav.child_menu > li > a {\r\n\tcolor: white;\r\n\tfont-size: 12px;\r\n\tpadding: 9px;\r\n}\r\n\r\n/* 06/29/2017 Paul.  Increase to 100px. */\r\n.panel_toolbox {\r\n\tfloat: right;\r\n\tmin-width: 100px\r\n}\r\n\r\n.panel_toolbox > li {\r\n\tfloat: left;\r\n\tcursor: pointer\r\n}\r\n\r\n.panel_toolbox > li > a {\r\n\tpadding: 5px;\r\n\tcolor: #C5C7CB;\r\n\tfont-size: 14px\r\n}\r\n\r\n.panel_toolbox > li > a:hover {\r\n\tbackground: #F5F7FA\r\n}\r\n\r\n/* 04/14/2017 Paul.  We want to use in sub panels. */\r\n.subpanel_toolbox\r\n{\r\n\tcolor: #C5C7CB;\r\n}\r\n.line_30 {\r\n\tline-height: 30px\r\n}\r\n\r\n.main_menu_side {\r\n\tpadding: 0\r\n}\r\n\r\n.bs-docs-sidebar .nav > li > a {\r\n\tdisplay: block;\r\n\tpadding: 4px 6px\r\n}\r\n\r\n/* 04/25/2017 Paul.  Reduce top and bottom to 10. */\r\nfooter {\r\n\tbackground: #fff;\r\n\tpadding: 5px 20px 20px 20px;\r\n\tdisplay: block;\r\n}\r\n\r\n@media (min-width: 768px) {\r\n\tfooter {\r\n\t\tmargin-left: 230px\r\n\t}\r\n}\r\n\r\n/* 06/29/2017 Paul.  Increase to 100px. */\r\n.nav-sm footer {\r\n\tmargin-left: 100px\r\n}\r\n\r\n.footer_fixed footer {\r\n\tposition: fixed;\r\n\tleft: 0px;\r\n\tbottom: 0px;\r\n\twidth: 100%\r\n}\r\n\r\n@media (min-width: 768px) {\r\n\t.footer_fixed footer {\r\n\t\tmargin-left: 0\r\n\t}\r\n}\r\n\r\n@media (min-width: 768px) {\r\n\t.footer_fixed .nav-sm footer {\r\n\t\tmargin-left: 0\r\n\t}\r\n}\r\n\r\n.tile-stats.sparkline {\r\n\tpadding: 10px;\r\n\ttext-align: center\r\n}\r\n\r\n.jqstooltip {\r\n\tbackground: #34495E !important;\r\n\twidth: 30px !important;\r\n\theight: 22px !important;\r\n\ttext-decoration: none\r\n}\r\n\r\n.tooltip {\r\n\tdisplay: block !important\r\n}\r\n\r\n.tiles {\r\n\tborder-top: 1px solid #ccc;\r\n\tmargin-top: 15px;\r\n\tpadding-top: 5px;\r\n\tmargin-bottom: 0\r\n}\r\n\r\n.tile {\r\n\toverflow: hidden\r\n}\r\n\r\n.top_tiles {\r\n\tmargin-bottom: 0\r\n}\r\n\r\n.top_tiles .tile h2 {\r\n\tfont-size: 30px;\r\n\tline-height: 30px;\r\n\tmargin: 3px 0 7px;\r\n\tfont-weight: bold\r\n}\r\n\r\narticle.media {\r\n\twidth: 100%\r\n}\r\n\r\n*,\r\n*:before,\r\n*:after {\r\n\tbox-sizing: border-box\r\n}\r\n\r\n#integration-list {\r\n\twidth: 100%;\r\n\tmargin: 0 auto;\r\n\tdisplay: table\r\n}\r\n\r\n#integration-list ul {\r\n\tpadding: 0;\r\n\tmargin: 20px 0;\r\n\tcolor: #555\r\n}\r\n\r\n#integration-list ul > li {\r\n\tlist-style: none;\r\n\tborder-top: 1px solid #ddd;\r\n\tdisplay: block;\r\n\tpadding: 15px;\r\n\toverflow: hidden\r\n}\r\n\r\n#integration-list ul:last-child {\r\n\tborder-bottom: 1px solid #ddd\r\n}\r\n\r\n#integration-list ul > li:hover {\r\n\tbackground: #efefef\r\n}\r\n\r\n.expand {\r\n\tdisplay: block;\r\n\ttext-decoration: none;\r\n\tcolor: #555;\r\n\tcursor: pointer\r\n}\r\n\r\n.expand h2 {\r\n\twidth: 85%;\r\n\tfloat: left\r\n}\r\n\r\nh2 {\r\n\tfont-size: 18px;\r\n\tfont-weight: 400\r\n}\r\n\r\n#left,\r\n#right {\r\n\tdisplay: table\r\n}\r\n\r\n#sup {\r\n\tdisplay: table-cell;\r\n\tvertical-align: middle;\r\n\twidth: 80%\r\n}\r\n\r\n.detail a {\r\n\ttext-decoration: none;\r\n\tcolor: #C0392B;\r\n\tborder: 1px solid #C0392B;\r\n\tpadding: 6px 10px 5px;\r\n\tfont-size: 13px;\r\n\tmargin-right: 7px\r\n}\r\n\r\n.detail {\r\n\tmargin: 10px 0 10px 0px;\r\n\tdisplay: none;\r\n\tline-height: 22px;\r\n\theight: 150px\r\n}\r\n\r\n.detail span {\r\n\tmargin: 0\r\n}\r\n\r\n.right-arrow {\r\n\twidth: 10px;\r\n\tfloat: right;\r\n\tfont-weight: bold;\r\n\tfont-size: 20px\r\n}\r\n\r\n.accordion .panel {\r\n\tmargin-bottom: 5px;\r\n\tborder-radius: 0;\r\n\tborder-bottom: 1px solid #efefef\r\n}\r\n\r\n.accordion .panel-heading {\r\n\tbackground: #F2F5F7;\r\n\tpadding: 13px;\r\n\twidth: 100%;\r\n\tdisplay: block\r\n}\r\n\r\n.accordion .panel:hover {\r\n\tbackground: #F2F5F7\r\n}\r\n\r\n.x_panel {\r\n\tposition: relative;\r\n\twidth: 100%;\r\n\tmargin-bottom: 10px;\r\n\tpadding: 10px 17px;\r\n\tdisplay: inline-block;\r\n\tbackground: #fff;\r\n\tborder: 1px solid #E6E9ED;\r\n\t-webkit-column-break-inside: avoid;\r\n\t-moz-column-break-inside: avoid;\r\n\tcolumn-break-inside: avoid;\r\n\topacity: 1;\r\n\ttransition: all .2s ease\r\n}\r\n\r\n.x_title {\r\n\tborder-bottom: 2px solid #E6E9ED;\r\n\tpadding: 1px 5px 6px;\r\n\tmargin-bottom: 10px\r\n}\r\n\r\n.x_title .filter {\r\n\twidth: 40%;\r\n\tfloat: right\r\n}\r\n\r\n.x_title h2 {\r\n\tmargin: 5px 0 6px;\r\n\tfloat: left;\r\n\tdisplay: block;\r\n\ttext-overflow: ellipsis;\r\n\toverflow: hidden;\r\n\twhite-space: nowrap\r\n}\r\n\r\n.x_title h2 small {\r\n\tmargin-left: 10px\r\n}\r\n\r\n.x_title span {\r\n\tcolor: #BDBDBD\r\n}\r\n\r\n.x_content {\r\n\tpadding: 0 5px 6px;\r\n\tposition: relative;\r\n\twidth: 100%;\r\n\tfloat: left;\r\n\tclear: both;\r\n\tmargin-top: 5px\r\n}\r\n\r\n.x_content h4 {\r\n\tfont-size: 16px;\r\n\tfont-weight: 500\r\n}\r\n\r\nlegend {\r\n\tpadding-bottom: 7px\r\n}\r\n\r\n.demo-placeholder {\r\n\theight: 280px\r\n}\r\n\r\n.profile_details:nth-child(3n) {\r\n\tclear: both\r\n}\r\n\r\n.profile_details .profile_view {\r\n\tdisplay: inline-block;\r\n\tpadding: 10px 0 0;\r\n\tbackground: #fff\r\n}\r\n\r\n.profile_details .profile_view .divider {\r\n\tborder-top: 1px solid #e5e5e5;\r\n\tpadding-top: 5px;\r\n\tmargin-top: 5px\r\n}\r\n\r\n.profile_details .profile_view .ratings {\r\n\tmargin-bottom: 0\r\n}\r\n\r\n.profile_details .profile_view .bottom {\r\n\tbackground: #F2F5F7;\r\n\tpadding: 9px 0;\r\n\tborder-top: 1px solid #E6E9ED\r\n}\r\n\r\n.profile_details .profile_view .left {\r\n\tmargin-top: 20px\r\n}\r\n\r\n.profile_details .profile_view .left p {\r\n\tmargin-bottom: 3px\r\n}\r\n\r\n.profile_details .profile_view .right {\r\n\tmargin-top: 0px;\r\n\tpadding: 10px\r\n}\r\n\r\n.profile_details .profile_view .img-circle {\r\n\tborder: 1px solid #E6E9ED;\r\n\tpadding: 2px\r\n}\r\n\r\n.profile_details .profile_view h2 {\r\n\tmargin: 5px 0\r\n}\r\n\r\n.profile_details .profile_view .ratings {\r\n\ttext-align: left;\r\n\tfont-size: 16px\r\n}\r\n\r\n.profile_details .profile_view .brief {\r\n\tmargin: 0;\r\n\tfont-weight: 300\r\n}\r\n\r\n.profile_details .profile_left {\r\n\tbackground: white\r\n}\r\n\r\n.pagination.pagination-split li {\r\n\tdisplay: inline-block;\r\n\tmargin-right: 3px\r\n}\r\n\r\n.pagination.pagination-split li a {\r\n\tborder-radius: 4px;\r\n\tcolor: #768399;\r\n\t-moz-border-radius: 4px;\r\n\t-webkit-border-radius: 4px\r\n}\r\n\r\ntable.tile h3,\r\ntable.tile h4,\r\ntable.tile span {\r\n\tfont-weight: bold;\r\n\tvertical-align: middle !important\r\n}\r\n\r\ntable.tile th,\r\ntable.tile td {\r\n\ttext-align: center\r\n}\r\n\r\ntable.tile th {\r\n\tborder-bottom: 1px solid #E6ECEE\r\n}\r\n\r\ntable.tile td {\r\n\tpadding: 5px 0\r\n}\r\n\r\ntable.tile td ul {\r\n\ttext-align: left;\r\n\tpadding-left: 0\r\n}\r\n\r\ntable.tile td ul li {\r\n\tlist-style: none;\r\n\twidth: 100%\r\n}\r\n\r\ntable.tile td ul li a {\r\n\twidth: 100%\r\n}\r\n\r\ntable.tile td ul li a big {\r\n\tright: 0;\r\n\tfloat: right;\r\n\tmargin-right: 13px\r\n}\r\n\r\ntable.tile_info {\r\n\twidth: 100%\r\n}\r\n\r\ntable.tile_info td {\r\n\ttext-align: left;\r\n\tpadding: 1px;\r\n\tfont-size: 15px\r\n}\r\n\r\ntable.tile_info td p {\r\n\twhite-space: nowrap;\r\n\toverflow: hidden;\r\n\ttext-overflow: ellipsis;\r\n\tmargin: 0;\r\n\tline-height: 28px\r\n}\r\n\r\ntable.tile_info td i {\r\n\tmargin-right: 8px;\r\n\tfont-size: 17px;\r\n\tfloat: left;\r\n\twidth: 18px;\r\n\tline-height: 28px\r\n}\r\n\r\ntable.tile_info td:first-child {\r\n\twidth: 83%\r\n}\r\n\r\ntd span {\r\n\tline-height: 28px\r\n}\r\n\r\n.sidebar-widget {\r\n\toverflow: hidden\r\n}\r\n\r\n.error-number {\r\n\tfont-size: 90px;\r\n\tline-height: 90px;\r\n\tmargin: 20px 0\r\n}\r\n\r\n.col-middle {\r\n\tmargin-top: 5%\r\n}\r\n\r\n.mid_center {\r\n\twidth: 370px;\r\n\tmargin: 0 auto;\r\n\ttext-align: center;\r\n\tpadding: 10px 20px\r\n}\r\n\r\nh3.degrees {\r\n\tfont-size: 22px;\r\n\tfont-weight: 400;\r\n\ttext-align: center\r\n}\r\n\r\n.degrees:after {\r\n\tcontent: \"o\";\r\n\tposition: relative;\r\n\ttop: -12px;\r\n\tfont-size: 13px;\r\n\tfont-weight: 300\r\n}\r\n\r\n.daily-weather .day {\r\n\tfont-size: 14px;\r\n\tborder-top: 2px solid rgba(115, 135, 156, 0.36);\r\n\ttext-align: center;\r\n\tborder-bottom: 2px solid rgba(115, 135, 156, 0.36);\r\n\tpadding: 5px 0\r\n}\r\n\r\n.weather-days .col-sm-2 {\r\n\toverflow: hidden;\r\n\twidth: 16.66666667%\r\n}\r\n\r\n.weather .row {\r\n\tmargin-bottom: 0\r\n}\r\n\r\n.bulk-actions {\r\n\tdisplay: none\r\n}\r\n\r\ntable.countries_list {\r\n\twidth: 100%\r\n}\r\n\r\ntable.countries_list td {\r\n\tpadding: 0 10px;\r\n\tline-height: 30px;\r\n\tborder-top: 1px solid #eeeeee\r\n}\r\n\r\n.dataTables_paginate a {\r\n\tpadding: 6px 9px !important;\r\n\tbackground: #ddd !important;\r\n\tborder-color: #ddd !important\r\n}\r\n\r\n.paging_full_numbers a.paginate_active {\r\n\tbackground-color: rgba(38, 185, 154, 0.59) !important;\r\n\tborder-color: rgba(38, 185, 154, 0.59) !important\r\n}\r\n\r\nbutton.DTTT_button,\r\ndiv.DTTT_button,\r\na.DTTT_button {\r\n\tborder: 1px solid #E7E7E7 !important;\r\n\tbackground: #E7E7E7 !important;\r\n\tbox-shadow: none !important\r\n}\r\n\r\ntable.jambo_table {\r\n\tborder: 1px solid rgba(221, 221, 221, 0.78)\r\n}\r\n\r\ntable.jambo_table thead {\r\n\tbackground: rgba(52, 73, 94, 0.94);\r\n\tcolor: #ECF0F1\r\n}\r\n\r\ntable.jambo_table tbody tr:hover td {\r\n\tbackground: rgba(38, 185, 154, 0.07);\r\n\tborder-top: 1px solid rgba(38, 185, 154, 0.11);\r\n\tborder-bottom: 1px solid rgba(38, 185, 154, 0.11)\r\n}\r\n\r\ntable.jambo_table tbody tr.selected {\r\n\tbackground: rgba(38, 185, 154, 0.16)\r\n}\r\n\r\ntable.jambo_table tbody tr.selected td {\r\n\tborder-top: 1px solid rgba(38, 185, 154, 0.4);\r\n\tborder-bottom: 1px solid rgba(38, 185, 154, 0.4)\r\n}\r\n\r\n.dataTables_paginate a {\r\n\tbackground: #ff0000\r\n}\r\n\r\n.dataTables_wrapper {\r\n\tposition: relative;\r\n\tclear: both;\r\n\tzoom: 1\r\n}\r\n\r\n.dataTables_processing {\r\n\tposition: absolute;\r\n\ttop: 50%;\r\n\tleft: 50%;\r\n\twidth: 250px;\r\n\theight: 30px;\r\n\tmargin-left: -125px;\r\n\tmargin-top: -15px;\r\n\tpadding: 14px 0 2px 0;\r\n\tborder: 1px solid #ddd;\r\n\ttext-align: center;\r\n\tcolor: #999;\r\n\tfont-size: 14px;\r\n\tbackground-color: white\r\n}\r\n\r\n.dataTables_length {\r\n\twidth: 40%;\r\n\tfloat: left\r\n}\r\n\r\n.dataTables_filter {\r\n\twidth: 50%;\r\n\tfloat: right;\r\n\ttext-align: right\r\n}\r\n\r\n.dataTables_info {\r\n\twidth: 60%;\r\n\tfloat: left\r\n}\r\n\r\n.dataTables_paginate {\r\n\tfloat: right;\r\n\ttext-align: right\r\n}\r\n\r\ntable.dataTable th.focus,\r\ntable.dataTable td.focus {\r\n\toutline: 2px solid #1ABB9C !important;\r\n\toutline-offset: -1px\r\n}\r\n\r\n.paginate_disabled_previous,\r\n.paginate_enabled_previous,\r\n.paginate_disabled_next,\r\n.paginate_enabled_next {\r\n\theight: 19px;\r\n\tfloat: left;\r\n\tcursor: pointer;\r\n\tcolor: #111 !important\r\n}\r\n\r\n.paginate_disabled_previous:hover,\r\n.paginate_enabled_previous:hover,\r\n.paginate_disabled_next:hover,\r\n.paginate_enabled_next:hover {\r\n\ttext-decoration: none !important\r\n}\r\n\r\n.paginate_disabled_previous:active,\r\n.paginate_enabled_previous:active,\r\n.paginate_disabled_next:active,\r\n.paginate_enabled_next:active {\r\n\toutline: none\r\n}\r\n\r\n.paginate_disabled_previous,\r\n.paginate_disabled_next {\r\n\tcolor: #666 !important\r\n}\r\n\r\n.paginate_disabled_previous,\r\n.paginate_enabled_previous {\r\n\tpadding-left: 23px\r\n}\r\n\r\n.paginate_disabled_next,\r\n.paginate_enabled_next {\r\n\tpadding-right: 23px;\r\n\tmargin-left: 10px\r\n}\r\n\r\ntable.display {\r\n\tmargin: 0 auto;\r\n\tclear: both;\r\n\twidth: 100%\r\n}\r\n\r\ntable.display thead th {\r\n\tpadding: 8px 18px 8px 10px;\r\n\tborder-bottom: 1px solid black;\r\n\tfont-weight: bold;\r\n\tcursor: pointer\r\n}\r\n\r\ntable.display tfoot th {\r\n\tpadding: 3px 18px 3px 10px;\r\n\tborder-top: 1px solid black;\r\n\tfont-weight: bold\r\n}\r\n\r\ntable.display tr.heading2 td {\r\n\tborder-bottom: 1px solid #aaa\r\n}\r\n\r\ntable.display td {\r\n\tpadding: 3px 10px\r\n}\r\n\r\ntable.display td.center {\r\n\ttext-align: center\r\n}\r\n\r\ntable.display thead th:active,\r\ntable.display thead td:active {\r\n\toutline: none\r\n}\r\n\r\n.dataTables_scroll {\r\n\tclear: both\r\n}\r\n\r\n.dataTables_scrollBody {\r\n\t*margin-top: -1px;\r\n\t-webkit-overflow-scrolling: touch\r\n}\r\n\r\n.top .dataTables_info {\r\n\tfloat: none\r\n}\r\n\r\n.clear {\r\n\tclear: both\r\n}\r\n\r\n.dataTables_empty {\r\n\ttext-align: center\r\n}\r\n\r\ntfoot input {\r\n\tmargin: 0.5em 0;\r\n\twidth: 100%;\r\n\tcolor: #444\r\n}\r\n\r\ntfoot input.search_init {\r\n\tcolor: #999\r\n}\r\n\r\ntd.group {\r\n\tbackground-color: #d1cfd0;\r\n\tborder-bottom: 2px solid #A19B9E;\r\n\tborder-top: 2px solid #A19B9E\r\n}\r\n\r\ntd.details {\r\n\tbackground-color: #d1cfd0;\r\n\tborder: 2px solid #A19B9E\r\n}\r\n\r\n.example_alt_pagination div.dataTables_info {\r\n\twidth: 40%\r\n}\r\n\r\n.paging_full_numbers {\r\n\twidth: 400px;\r\n\theight: 22px;\r\n\tline-height: 22px\r\n}\r\n\r\n.paging_full_numbers a:active {\r\n\toutline: none\r\n}\r\n\r\n.paging_full_numbers a:hover {\r\n\ttext-decoration: none\r\n}\r\n\r\n.paging_full_numbers a.paginate_button,\r\n.paging_full_numbers a.paginate_active {\r\n\tborder: 1px solid #aaa;\r\n\t-webkit-border-radius: 5px;\r\n\t-moz-border-radius: 5px;\r\n\tpadding: 2px 5px;\r\n\tmargin: 0 3px;\r\n\tcursor: pointer\r\n}\r\n\r\n.paging_full_numbers a.paginate_button {\r\n\tbackground-color: #ddd\r\n}\r\n\r\n.paging_full_numbers a.paginate_button:hover {\r\n\tbackground-color: #ccc;\r\n\ttext-decoration: none !important\r\n}\r\n\r\n.paging_full_numbers a.paginate_active {\r\n\tbackground-color: #99B3FF\r\n}\r\n\r\ntable.display tr.even.row_selected td {\r\n\tbackground-color: #B0BED9\r\n}\r\n\r\ntable.display tr.odd.row_selected td {\r\n\tbackground-color: #9FAFD1\r\n}\r\n\r\ndiv.box {\r\n\theight: 100px;\r\n\tpadding: 10px;\r\n\toverflow: auto;\r\n\tborder: 1px solid #8080FF;\r\n\tbackground-color: #E5E5FF\r\n}\r\n\r\nul.msg_list li {\r\n\tbackground: #f7f7f7;\r\n\tpadding: 5px;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\tmargin: 6px 6px 0;\r\n\twidth: 96% !important\r\n}\r\n\r\nul.msg_list li:last-child {\r\n\tmargin-bottom: 6px;\r\n\tpadding: 10px\r\n}\r\n\r\nul.msg_list li a {\r\n\tpadding: 3px 5px !important\r\n}\r\n\r\nul.msg_list li a .image img {\r\n\tborder-radius: 2px 2px 2px 2px;\r\n\t-webkit-border-radius: 2px 2px 2px 2px;\r\n\tfloat: left;\r\n\tmargin-right: 10px;\r\n\twidth: 11%\r\n}\r\n\r\nul.msg_list li a .time {\r\n\tfont-size: 11px;\r\n\tfont-style: italic;\r\n\tfont-weight: bold;\r\n\tposition: absolute;\r\n\tright: 35px\r\n}\r\n\r\nul.msg_list li a .message {\r\n\tdisplay: block !important;\r\n\tfont-size: 11px\r\n}\r\n\r\n.dropdown-menu.msg_list span {\r\n\twhite-space: normal\r\n}\r\n\r\n.dropdown-menu {\r\n\tborder: medium none;\r\n\tbox-shadow: none;\r\n\tdisplay: none;\r\n\tfloat: left;\r\n\tfont-size: 12px;\r\n\tleft: 0;\r\n\tlist-style: none outside none;\r\n\tpadding: 0;\r\n\tposition: absolute;\r\n\ttext-shadow: none;\r\n\ttop: 100%;\r\n\tz-index: 9998;\r\n\tborder: 1px solid #D9DEE4;\r\n\tborder-top-left-radius: 0;\r\n\tborder-top-right-radius: 0\r\n}\r\n\r\n.dropdown-menu > li > a {\r\n\tcolor: #5A738E\r\n}\r\n\r\n.navbar-nav .open .dropdown-menu {\r\n\tposition: absolute;\r\n\tbackground: #fff;\r\n\tmargin-top: 0;\r\n\tborder: 1px solid #D9DEE4;\r\n\t-webkit-box-shadow: none;\r\n\tright: 0;\r\n\tleft: auto;\r\n\twidth: 220px\r\n}\r\n\r\n.navbar-nav .open .dropdown-menu.msg_list {\r\n\twidth: 300px\r\n}\r\n\r\n.info-number .badge {\r\n\tfont-size: 10px;\r\n\tfont-weight: normal;\r\n\tline-height: 13px;\r\n\tpadding: 2px 6px;\r\n\tposition: absolute;\r\n\tright: 2px;\r\n\ttop: 8px\r\n}\r\n\r\nul.to_do {\r\n\tpadding: 0\r\n}\r\n\r\nul.to_do li {\r\n\tbackground: #f3f3f3;\r\n\tborder-radius: 3px;\r\n\tposition: relative;\r\n\tpadding: 7px;\r\n\tmargin-bottom: 5px;\r\n\tlist-style: none\r\n}\r\n\r\nul.to_do p {\r\n\tmargin: 0\r\n}\r\n\r\n.dashboard-widget {\r\n\tbackground: #f6f6f6;\r\n\tborder-top: 5px solid #79C3DF;\r\n\tborder-radius: 3px;\r\n\tpadding: 5px 10px 10px\r\n}\r\n\r\n.dashboard-widget .dashboard-widget-title {\r\n\tfont-weight: normal;\r\n\tborder-bottom: 1px solid #c1cdcd;\r\n\tmargin: 0 0 10px 0;\r\n\tpadding-bottom: 5px;\r\n\tpadding-left: 40px;\r\n\tline-height: 30px\r\n}\r\n\r\n.dashboard-widget .dashboard-widget-title i {\r\n\tfont-size: 100%;\r\n\tmargin-left: -35px;\r\n\tmargin-right: 10px;\r\n\tcolor: #33a1c9;\r\n\tpadding: 3px 6px;\r\n\tborder: 1px solid #abd9ea;\r\n\tborder-radius: 5px;\r\n\tbackground: #fff\r\n}\r\n\r\nul.quick-list {\r\n\twidth: 45%;\r\n\tpadding-left: 0;\r\n\tdisplay: inline-block\r\n}\r\n\r\nul.quick-list li {\r\n\tpadding-left: 10px;\r\n\tlist-style: none;\r\n\tmargin: 0;\r\n\tpadding-bottom: 6px;\r\n\tpadding-top: 4px;\r\n\twhite-space: nowrap;\r\n\ttext-overflow: ellipsis;\r\n\toverflow: hidden\r\n}\r\n\r\nul.quick-list li i {\r\n\tpadding-right: 10px;\r\n\tcolor: #757679\r\n}\r\n\r\n.dashboard-widget-content {\r\n\tpadding-top: 9px\r\n}\r\n\r\n.dashboard-widget-content .sidebar-widget {\r\n\twidth: 50%;\r\n\tdisplay: inline-block;\r\n\tvertical-align: top;\r\n\tbackground: #fff;\r\n\tborder: 1px solid #abd9ea;\r\n\tborder-radius: 5px;\r\n\ttext-align: center;\r\n\tfloat: right;\r\n\tpadding: 2px;\r\n\tmargin-top: 10px\r\n}\r\n\r\n.widget_summary {\r\n\twidth: 100%;\r\n\tdisplay: -ms-inline-flexbox;\r\n\tdisplay: inline-flex\r\n}\r\n\r\n.widget_summary .w_left {\r\n\tfloat: left;\r\n\ttext-align: left\r\n}\r\n\r\n.widget_summary .w_center {\r\n\tfloat: left\r\n}\r\n\r\n.widget_summary .w_right {\r\n\tfloat: left;\r\n\ttext-align: right\r\n}\r\n\r\n.widget_summary .w_right span {\r\n\tfont-size: 20px\r\n}\r\n\r\n.w_20 {\r\n\twidth: 20%\r\n}\r\n\r\n.w_25 {\r\n\twidth: 25%\r\n}\r\n\r\n.w_55 {\r\n\twidth: 55%\r\n}\r\n\r\nh5.graph_title {\r\n\ttext-align: left;\r\n\tmargin-left: 10px\r\n}\r\n\r\nh5.graph_title i {\r\n\tmargin-right: 10px;\r\n\tfont-size: 17px\r\n}\r\n\r\nspan.right {\r\n\tfloat: right;\r\n\tfont-size: 14px !important\r\n}\r\n\r\n.tile_info a {\r\n\ttext-overflow: ellipsis\r\n}\r\n\r\n/* 04/24/2017 Paul.  Old background #2A3F54 */\r\n/* 12/28/2017 Paul.  Dark menu */\r\n.sidebar-footer {\r\n\tbottom: 0px;\r\n\tclear: both;\r\n\tdisplay: block;\r\n\tpadding: 5px 0 0 0;\r\n\tposition: fixed;\r\n\twidth: 230px;\r\n\tbackground: #64707B;\r\n\tcolor: white;\r\n}\r\n\r\n.sidebar-footer a {\r\n\tpadding: 7px 0 3px;\r\n\ttext-align: center;\r\n\twidth: 25%;\r\n\tfont-size: 17px;\r\n\tdisplay: block;\r\n\tfloat: left;\r\n\tbackground: #172D44\r\n}\r\n\r\n.sidebar-footer a:hover {\r\n\tbackground: #425567\r\n}\r\n\r\n.tile_count {\r\n\tmargin-bottom: 20px;\r\n\tmargin-top: 20px\r\n}\r\n\r\n.tile_count .tile_stats_count {\r\n\tborder-bottom: 1px solid #D9DEE4;\r\n\tpadding: 0 10px 0 20px;\r\n\ttext-overflow: ellipsis;\r\n\toverflow: hidden;\r\n\twhite-space: nowrap;\r\n\tposition: relative\r\n}\r\n\r\n@media (min-width: 992px) {\r\n\t.tile_count .tile_stats_count {\r\n\t\tmargin-bottom: 10px;\r\n\t\tborder-bottom: 0;\r\n\t\tpadding-bottom: 10px\r\n\t}\r\n}\r\n\r\n.tile_count .tile_stats_count:before {\r\n\tcontent: \"\";\r\n\tposition: absolute;\r\n\tleft: 0;\r\n\theight: 65px;\r\n\tborder-left: 2px solid #ADB2B5;\r\n\tmargin-top: 10px\r\n}\r\n\r\n@media (min-width: 992px) {\r\n\t.tile_count .tile_stats_count:first-child:before {\r\n\t\tborder-left: 0\r\n\t}\r\n}\r\n\r\n.tile_count .tile_stats_count .count {\r\n\tfont-size: 30px;\r\n\tline-height: 47px;\r\n\tfont-weight: 600\r\n}\r\n\r\n@media (min-width: 768px) {\r\n\t.tile_count .tile_stats_count .count {\r\n\t\tfont-size: 40px\r\n\t}\r\n}\r\n\r\n@media (min-width: 992px) and (max-width: 1100px) {\r\n\t.tile_count .tile_stats_count .count {\r\n\t\tfont-size: 30px\r\n\t}\r\n}\r\n\r\n.tile_count .tile_stats_count span {\r\n\tfont-size: 12px\r\n}\r\n\r\n@media (min-width: 768px) {\r\n\t.tile_count .tile_stats_count span {\r\n\t\tfont-size: 13px\r\n\t}\r\n}\r\n\r\n.tile_count .tile_stats_count .count_bottom i {\r\n\twidth: 12px\r\n}\r\n\r\n.dashboard_graph {\r\n\tbackground: #fff;\r\n\tpadding: 7px 10px\r\n}\r\n\r\n.dashboard_graph .col-md-9,\r\n.dashboard_graph .col-md-3 {\r\n\tpadding: 0\r\n}\r\n\r\na.user-profile {\r\n\tcolor: #5E6974 !important\r\n}\r\n\r\n.user-profile img {\r\n\twidth: 29px;\r\n\theight: 29px;\r\n\tborder-radius: 50%;\r\n\tmargin-right: 10px\r\n}\r\n\r\nul.top_profiles {\r\n\theight: 330px;\r\n\twidth: 100%\r\n}\r\n\r\nul.top_profiles li {\r\n\tmargin: 0;\r\n\tpadding: 3px 5px\r\n}\r\n\r\nul.top_profiles li:nth-child(odd) {\r\n\tbackground-color: #eee\r\n}\r\n\r\n.media .profile_thumb {\r\n\tborder: 1px solid;\r\n\twidth: 50px;\r\n\theight: 50px;\r\n\tmargin: 5px 10px 5px 0;\r\n\tborder-radius: 50%;\r\n\tpadding: 9px 12px\r\n}\r\n\r\n.media .profile_thumb i {\r\n\tfont-size: 30px\r\n}\r\n\r\n.media .date {\r\n\tbackground: #ccc;\r\n\twidth: 52px;\r\n\tmargin-right: 10px;\r\n\tborder-radius: 10px;\r\n\tpadding: 5px\r\n}\r\n\r\n.media .date .month {\r\n\tmargin: 0;\r\n\ttext-align: center;\r\n\tcolor: #fff\r\n}\r\n\r\n.media .date .day {\r\n\ttext-align: center;\r\n\tcolor: #fff;\r\n\tfont-size: 27px;\r\n\tmargin: 0;\r\n\tline-height: 27px;\r\n\tfont-weight: bold\r\n}\r\n\r\n.event .media-body a.title {\r\n\tfont-weight: bold\r\n}\r\n\r\n.event .media-body p {\r\n\tmargin-bottom: 0\r\n}\r\n\r\nh4.graph_title {\r\n\tmargin: 7px;\r\n\ttext-align: center\r\n}\r\n\r\n.fontawesome-icon-list .fa-hover a:hover {\r\n\tbackground-color: #ddd;\r\n\tcolor: #fff;\r\n\ttext-decoration: none\r\n}\r\n\r\n.fontawesome-icon-list .fa-hover a {\r\n\tdisplay: block;\r\n\tline-height: 32px;\r\n\theight: 32px;\r\n\tpadding-left: 10px;\r\n\tborder-radius: 4px\r\n}\r\n\r\n.fontawesome-icon-list .fa-hover a:hover .fa {\r\n\tfont-size: 28px;\r\n\tvertical-align: -6px\r\n}\r\n\r\n.fontawesome-icon-list .fa-hover a .fa {\r\n\twidth: 32px;\r\n\tfont-size: 16px;\r\n\tdisplay: inline-block;\r\n\ttext-align: right;\r\n\tmargin-right: 10px\r\n}\r\n\r\n.main_menu .fa {\r\n\twidth: 26px;\r\n\topacity: .99;\r\n\tdisplay: inline-block;\r\n\tfont-family: FontAwesome;\r\n\tfont-style: normal;\r\n\tfont-weight: normal;\r\n\tfont-size: 18px;\r\n\t-webkit-font-smoothing: antialiased;\r\n\t-moz-osx-font-smoothing: grayscale\r\n}\r\n\r\n.tile-stats {\r\n\tposition: relative;\r\n\tdisplay: block;\r\n\tmargin-bottom: 12px;\r\n\tborder: 1px solid #E4E4E4;\r\n\t-webkit-border-radius: 5px;\r\n\toverflow: hidden;\r\n\tpadding-bottom: 5px;\r\n\t-webkit-background-clip: padding-box;\r\n\t-moz-border-radius: 5px;\r\n\t-moz-background-clip: padding;\r\n\tborder-radius: 5px;\r\n\tbackground-clip: padding-box;\r\n\tbackground: #FFF;\r\n\ttransition: all 300ms ease-in-out\r\n}\r\n\r\n.tile-stats:hover .icon i {\r\n\tanimation-name: tansformAnimation;\r\n\tanimation-duration: .5s;\r\n\tanimation-iteration-count: 1;\r\n\tcolor: rgba(58, 58, 58, 0.41);\r\n\tanimation-timing-function: ease;\r\n\tanimation-fill-mode: forwards;\r\n\t-webkit-animation-name: tansformAnimation;\r\n\t-webkit-animation-duration: .5s;\r\n\t-webkit-animation-iteration-count: 1;\r\n\t-webkit-animation-timing-function: ease;\r\n\t-webkit-animation-fill-mode: forwards;\r\n\t-moz-animation-name: tansformAnimation;\r\n\t-moz-animation-duration: .5s;\r\n\t-moz-animation-iteration-count: 1;\r\n\t-moz-animation-timing-function: ease;\r\n\t-moz-animation-fill-mode: forwards\r\n}\r\n\r\n.tile-stats .icon {\r\n\twidth: 20px;\r\n\theight: 20px;\r\n\tcolor: #BAB8B8;\r\n\tposition: absolute;\r\n\tright: 53px;\r\n\ttop: 22px;\r\n\tz-index: 1\r\n}\r\n\r\n.tile-stats .icon i {\r\n\tmargin: 0;\r\n\tfont-size: 60px;\r\n\tline-height: 0;\r\n\tvertical-align: bottom;\r\n\tpadding: 0\r\n}\r\n\r\n.tile-stats .count {\r\n\tfont-size: 38px;\r\n\tfont-weight: bold;\r\n\tline-height: 1.65857\r\n}\r\n\r\n.tile-stats .count,\r\n.tile-stats h3,\r\n.tile-stats p {\r\n\tposition: relative;\r\n\tmargin: 0;\r\n\tmargin-left: 10px;\r\n\tz-index: 5;\r\n\tpadding: 0\r\n}\r\n\r\n.tile-stats h3 {\r\n\tcolor: #BAB8B8\r\n}\r\n\r\n.tile-stats p {\r\n\tmargin-top: 5px;\r\n\tfont-size: 12px\r\n}\r\n\r\n.tile-stats > .dash-box-footer {\r\n\tposition: relative;\r\n\ttext-align: center;\r\n\tmargin-top: 5px;\r\n\tpadding: 3px 0;\r\n\tcolor: #fff;\r\n\tcolor: rgba(255, 255, 255, 0.8);\r\n\tdisplay: block;\r\n\tz-index: 10;\r\n\tbackground: rgba(0, 0, 0, 0.1);\r\n\ttext-decoration: none\r\n}\r\n\r\n.tile-stats > .dash-box-footer:hover {\r\n\tcolor: #fff;\r\n\tbackground: rgba(0, 0, 0, 0.15)\r\n}\r\n\r\n.tile-stats > .dash-box-footer:hover {\r\n\tcolor: #fff;\r\n\tbackground: rgba(0, 0, 0, 0.15)\r\n}\r\n\r\ntable.tile_info {\r\n\tpadding: 10px 15px\r\n}\r\n\r\ntable.tile_info span.right {\r\n\tmargin-right: 0;\r\n\tfloat: right;\r\n\tposition: absolute;\r\n\tright: 4%\r\n}\r\n\r\n.tile:hover {\r\n\ttext-decoration: none\r\n}\r\n\r\n.tile_header {\r\n\tborder-bottom: transparent;\r\n\tpadding: 7px 15px;\r\n\tmargin-bottom: 15px;\r\n\tbackground: #E7E7E7\r\n}\r\n\r\n.tile_head h4 {\r\n\tmargin-top: 0;\r\n\tmargin-bottom: 5px\r\n}\r\n\r\n.tiles-bottom {\r\n\tpadding: 5px 10px;\r\n\tmargin-top: 10px;\r\n\tbackground: rgba(194, 194, 194, 0.3);\r\n\ttext-align: left\r\n}\r\n\r\na.star {\r\n\tcolor: #428bca !important\r\n}\r\n\r\n.mail_content {\r\n\tbackground: none repeat scroll 0 0 #FFFFFF;\r\n\tborder-radius: 4px;\r\n\tmargin-top: 20px;\r\n\tmin-height: 500px;\r\n\tpadding: 10px 11px;\r\n\twidth: 100%\r\n}\r\n\r\n.list-btn-mail {\r\n\tmargin-bottom: 15px\r\n}\r\n\r\n.list-btn-mail.active {\r\n\tborder-bottom: 1px solid #39B3D7;\r\n\tpadding: 0 0 14px\r\n}\r\n\r\n.list-btn-mail > i {\r\n\tfloat: left;\r\n\tfont-size: 18px;\r\n\tfont-style: normal;\r\n\twidth: 33px\r\n}\r\n\r\n.list-btn-mail > .cn {\r\n\tbackground: none repeat scroll 0 0 #39B3D7;\r\n\tborder-radius: 12px;\r\n\tcolor: #FFFFFF;\r\n\tfloat: right;\r\n\tfont-style: normal;\r\n\tpadding: 0 5px\r\n}\r\n\r\n.button-mail {\r\n\tmargin: 0 0 15px !important;\r\n\ttext-align: left;\r\n\twidth: 100%\r\n}\r\n\r\n/* 05/31/2017 Paul.  margin-right to 0 */\r\n.buttons,\r\nbutton,\r\n.btn {\r\n\tmargin-bottom: 5px;\r\n\tmargin-right: 0px\r\n}\r\n\r\n.btn-group-vertical .btn,\r\n.btn-group .btn {\r\n\tmargin-bottom: 0;\r\n\tmargin-right: 0\r\n}\r\n\r\n.mail_list_column {\r\n\tborder-left: 1px solid #DBDBDB\r\n}\r\n\r\n.mail_view {\r\n\tborder-left: 1px solid #DBDBDB\r\n}\r\n\r\n.mail_list {\r\n\twidth: 100%;\r\n\tborder-bottom: 1px solid #DBDBDB;\r\n\tmargin-bottom: 2px;\r\n\tdisplay: inline-block\r\n}\r\n\r\n.mail_list .left {\r\n\twidth: 5%;\r\n\tfloat: left;\r\n\tmargin-right: 3%\r\n}\r\n\r\n.mail_list .right {\r\n\twidth: 90%;\r\n\tfloat: left\r\n}\r\n\r\n.mail_list h3 {\r\n\tfont-size: 15px;\r\n\tfont-weight: bold;\r\n\tmargin: 0px 0 6px\r\n}\r\n\r\n.mail_list h3 small {\r\n\tfloat: right;\r\n\tcolor: #ADABAB;\r\n\tfont-size: 11px;\r\n\tline-height: 20px\r\n}\r\n\r\n.mail_list .badge {\r\n\tpadding: 3px 6px;\r\n\tfont-size: 8px;\r\n\tbackground: #BAB7B7\r\n}\r\n\r\n@media (max-width: 767px) {\r\n\t.mail_list {\r\n\t\tmargin-bottom: 5px;\r\n\t\tdisplay: inline-block\r\n\t}\r\n}\r\n\r\n.mail_heading h4 {\r\n\tfont-size: 18px;\r\n\tborder-bottom: 1px solid #ddd;\r\n\tpadding-bottom: 10px;\r\n\tmargin-top: 20px\r\n}\r\n\r\n.attachment {\r\n\tmargin-top: 30px\r\n}\r\n\r\n.attachment ul {\r\n\twidth: 100%;\r\n\tlist-style: none;\r\n\tpadding-left: 0;\r\n\tdisplay: inline-block;\r\n\tmargin-bottom: 30px\r\n}\r\n\r\n.attachment ul li {\r\n\tfloat: left;\r\n\twidth: 150px;\r\n\tmargin-right: 10px;\r\n\tmargin-bottom: 10px\r\n}\r\n\r\n.attachment ul li img {\r\n\theight: 150px;\r\n\tborder: 1px solid #ddd;\r\n\tpadding: 5px;\r\n\tmargin-bottom: 10px\r\n}\r\n\r\n.attachment ul li span {\r\n\tfloat: right\r\n}\r\n\r\n.attachment .file-name {\r\n\tfloat: left\r\n}\r\n\r\n.attachment .links {\r\n\twidth: 100%;\r\n\tdisplay: inline-block\r\n}\r\n\r\n.compose {\r\n\tpadding: 0;\r\n\tposition: fixed;\r\n\tbottom: 0;\r\n\tright: 0;\r\n\tbackground: #fff;\r\n\tborder: 1px solid #D9DEE4;\r\n\tborder-right: 0;\r\n\tborder-bottom: 0;\r\n\tborder-top-left-radius: 5px;\r\n\tz-index: 9999;\r\n\tdisplay: none\r\n}\r\n\r\n.compose .compose-header {\r\n\tpadding: 5px;\r\n\tbackground: #169F85;\r\n\tcolor: #fff;\r\n\tborder-top-left-radius: 5px\r\n}\r\n\r\n.compose .compose-header .close {\r\n\ttext-shadow: 0 1px 0 #ffffff;\r\n\tline-height: .8\r\n}\r\n\r\n.compose .compose-body .editor.btn-toolbar {\r\n\tmargin: 0\r\n}\r\n\r\n.compose .compose-body .editor-wrapper {\r\n\theight: 100%;\r\n\tmin-height: 50px;\r\n\tmax-height: 180px;\r\n\tborder-radius: 0;\r\n\tborder-left: none;\r\n\tborder-right: none;\r\n\toverflow: auto\r\n}\r\n\r\n.compose .compose-footer {\r\n\tpadding: 10px\r\n}\r\n\r\n.editor.btn-toolbar {\r\n\tzoom: 1;\r\n\tbackground: #F7F7F7;\r\n\tmargin: 5px 2px;\r\n\tpadding: 3px 0;\r\n\tborder: 1px solid #EFEFEF\r\n}\r\n\r\n.input-group {\r\n\tmargin-bottom: 10px\r\n}\r\n\r\n.ln_solid {\r\n\tborder-top: 1px solid #e5e5e5;\r\n\tcolor: #ffffff;\r\n\tbackground-color: #ffffff;\r\n\theight: 1px;\r\n\tmargin: 20px 0\r\n}\r\n\r\nspan.section {\r\n\tdisplay: block;\r\n\twidth: 100%;\r\n\tpadding: 0;\r\n\tmargin-bottom: 20px;\r\n\tfont-size: 21px;\r\n\tline-height: inherit;\r\n\tcolor: #333;\r\n\tborder: 0;\r\n\tborder-bottom: 1px solid #e5e5e5\r\n}\r\n\r\n.form-control {\r\n\tborder-radius: 0;\r\n\twidth: 100%\r\n}\r\n\r\n.form-horizontal .control-label {\r\n\tpadding-top: 8px\r\n}\r\n\r\n.form-control:focus {\r\n\tborder-color: #CCD0D7;\r\n\tbox-shadow: none !important\r\n}\r\n\r\nlegend {\r\n\tfont-size: 18px;\r\n\tcolor: inherit\r\n}\r\n\r\n.form-horizontal .form-group {\r\n\tmargin-right: 0;\r\n\tmargin-left: 0\r\n}\r\n\r\n.form-control-feedback {\r\n\tmargin-top: 8px;\r\n\theight: 23px;\r\n\tcolor: #bbb;\r\n\tline-height: 24px;\r\n\tfont-size: 15px\r\n}\r\n\r\n.form-control-feedback.left {\r\n\tborder-right: 1px solid #ccc;\r\n\tleft: 13px\r\n}\r\n\r\n.form-control-feedback.right {\r\n\tborder-left: 1px solid #ccc;\r\n\tright: 13px\r\n}\r\n\r\n.form-control.has-feedback-left {\r\n\tpadding-left: 45px\r\n}\r\n\r\n.form-control.has-feedback-right {\r\n\tpadding-right: 45px\r\n}\r\n\r\n.form-group {\r\n\tmargin-bottom: 10px\r\n}\r\n\r\n.validate {\r\n\tmargin-top: 10px\r\n}\r\n\r\n.invalid-form-error-message {\r\n\tmargin-top: 10px;\r\n\tpadding: 5px\r\n}\r\n\r\n.invalid-form-error-message.filled {\r\n\tborder-left: 2px solid #E74C3C\r\n}\r\n\r\np.parsley-success {\r\n\tcolor: #468847;\r\n\tbackground-color: #DFF0D8;\r\n\tborder: 1px solid #D6E9C6\r\n}\r\n\r\np.parsley-error {\r\n\tcolor: #B94A48;\r\n\tbackground-color: #F2DEDE;\r\n\tborder: 1px solid #EED3D7\r\n}\r\n\r\nul.parsley-errors-list {\r\n\tlist-style: none;\r\n\tcolor: #E74C3C;\r\n\tpadding-left: 0\r\n}\r\n\r\ninput.parsley-error,\r\ntextarea.parsley-error,\r\nselect.parsley-error {\r\n\tbackground: #FAEDEC;\r\n\tborder: 1px solid #E85445\r\n}\r\n\r\n.btn-group .parsley-errors-list {\r\n\tdisplay: none\r\n}\r\n\r\n.bad input,\r\n.bad select,\r\n.bad textarea {\r\n\tborder: 1px solid #CE5454;\r\n\tbox-shadow: 0 0 4px -2px #CE5454;\r\n\tposition: relative;\r\n\tleft: 0;\r\n\t-moz-animation: .7s 1 shake linear;\r\n\t-webkit-animation: 0.7s 1 shake linear\r\n}\r\n\r\n.item input,\r\n.item textarea {\r\n\ttransition: 0.42s\r\n}\r\n\r\n.item .alert {\r\n\tfloat: left;\r\n\tmargin: 0 0 0 20px;\r\n\tpadding: 3px 10px;\r\n\tcolor: #FFF;\r\n\tborder-radius: 3px 4px 4px 3px;\r\n\tbackground-color: #CE5454;\r\n\tmax-width: 170px;\r\n\twhite-space: pre;\r\n\tposition: relative;\r\n\tleft: -15px;\r\n\topacity: 0;\r\n\tz-index: 1;\r\n\ttransition: 0.15s ease-out\r\n}\r\n\r\n.item .alert::after {\r\n\tcontent: '';\r\n\tdisplay: block;\r\n\theight: 0;\r\n\twidth: 0;\r\n\tborder-color: transparent #CE5454 transparent transparent;\r\n\tborder-style: solid;\r\n\tborder-width: 11px 7px;\r\n\tposition: absolute;\r\n\tleft: -13px;\r\n\ttop: 1px\r\n}\r\n\r\n.item.bad .alert {\r\n\tleft: 0;\r\n\topacity: 1\r\n}\r\n\r\n.inl-bl {\r\n\tdisplay: inline-block\r\n}\r\n\r\n.well .markup {\r\n\tbackground: #fff;\r\n\tcolor: #777;\r\n\tposition: relative;\r\n\tpadding: 45px 15px 15px;\r\n\tmargin: 15px 0 0 0;\r\n\tbackground-color: #fff;\r\n\tborder-radius: 0 0 4px 4px;\r\n\tbox-shadow: none\r\n}\r\n\r\n.well .markup::after {\r\n\tcontent: \"Example\";\r\n\tposition: absolute;\r\n\ttop: 15px;\r\n\tleft: 15px;\r\n\tfont-size: 12px;\r\n\tfont-weight: bold;\r\n\tcolor: #bbb;\r\n\ttext-transform: uppercase;\r\n\tletter-spacing: 1px\r\n}\r\n\r\n.autocomplete-suggestions {\r\n\tborder: 1px solid #e4e4e4;\r\n\tbackground: #F4F4F4;\r\n\tcursor: default;\r\n\toverflow: auto\r\n}\r\n\r\n.autocomplete-suggestion {\r\n\tpadding: 2px 5px;\r\n\tfont-size: 1.2em;\r\n\twhite-space: nowrap;\r\n\toverflow: hidden\r\n}\r\n\r\n.autocomplete-selected {\r\n\tbackground: #f0f0f0\r\n}\r\n\r\n.autocomplete-suggestions strong {\r\n\tfont-weight: normal;\r\n\tcolor: #3399ff;\r\n\tfont-weight: bolder\r\n}\r\n\r\n.btn {\r\n\tborder-radius: 3px\r\n}\r\n\r\na.btn-success,\r\na.btn-primary,\r\na.btn-warning,\r\na.btn-danger {\r\n\tcolor: #fff\r\n}\r\n\r\n.btn-success {\r\n\tbackground: #26B99A;\r\n\tborder: 1px solid #169F85\r\n}\r\n\r\n.btn-success:hover,\r\n.btn-success:focus,\r\n.btn-success:active,\r\n.btn-success.active,\r\n.open .dropdown-toggle.btn-success {\r\n\tbackground: #169F85\r\n}\r\n\r\n.btn-dark {\r\n\tcolor: #E9EDEF;\r\n\tbackground-color: #4B5F71;\r\n\tborder-color: #364B5F\r\n}\r\n\r\n.btn-dark:hover,\r\n.btn-dark:focus,\r\n.btn-dark:active,\r\n.btn-dark.active,\r\n.open .dropdown-toggle.btn-dark {\r\n\tcolor: #FFFFFF;\r\n\tbackground-color: #394D5F;\r\n\tborder-color: #394D5F\r\n}\r\n\r\n.btn-round {\r\n\tborder-radius: 30px\r\n}\r\n\r\n.btn.btn-app {\r\n\tposition: relative;\r\n\tpadding: 15px 5px;\r\n\tmargin: 0 0 10px 10px;\r\n\tmin-width: 80px;\r\n\theight: 60px;\r\n\tbox-shadow: none;\r\n\tborder-radius: 0;\r\n\ttext-align: center;\r\n\tcolor: #666;\r\n\tborder: 1px solid #ddd;\r\n\tbackground-color: #fafafa;\r\n\tfont-size: 12px\r\n}\r\n\r\n.btn.btn-app > .fa,\r\n.btn.btn-app > .glyphicon,\r\n.btn.btn-app > .ion {\r\n\tfont-size: 20px;\r\n\tdisplay: block\r\n}\r\n\r\n.btn.btn-app:hover {\r\n\tbackground: #f4f4f4;\r\n\tcolor: #444;\r\n\tborder-color: #aaa\r\n}\r\n\r\n.btn.btn-app:active,\r\n.btn.btn-app:focus {\r\n\tbox-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125)\r\n}\r\n\r\n.btn.btn-app > .badge {\r\n\tposition: absolute;\r\n\ttop: -3px;\r\n\tright: -10px;\r\n\tfont-size: 10px;\r\n\tfont-weight: 400\r\n}\r\n\r\n/* 02/16/2020 Paul.  padding: 10px is terrible. */\r\ntextarea {\r\n\tvertical-align: top;\r\n\twidth: 200px\r\n}\r\n\r\ntextarea:focus {\r\n\toutline-style: solid;\r\n\toutline-width: 2px\r\n}\r\n\r\n.btn_ {\r\n\tdisplay: inline-block;\r\n\tpadding: 3px 9px;\r\n\tmargin-bottom: 0;\r\n\tfont-size: 14px;\r\n\tline-height: 20px;\r\n\ttext-align: center;\r\n\tvertical-align: middle;\r\n\tcursor: pointer;\r\n\tcolor: #333333;\r\n\ttext-shadow: 0 1px 1px rgba(255, 255, 255, 0.75);\r\n\tbackground-color: #f5f5f5;\r\n\tbackground-image: linear-gradient(to bottom, #fff, #e6e6e6);\r\n\tbackground-repeat: repeat-x;\r\n\tfilter: progid: DXImageTransform.Microsoft.gradient(startColorstr='#ffffffff', endColorstr='#ffe6e6e6', GradientType=0);\r\n\tborder-color: #e6e6e6 #e6e6e6 #bfbfbf;\r\n\tborder-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);\r\n\tfilter: progid: DXImageTransform.Microsoft.gradient(enabled=false);\r\n\tborder: 1px solid #cccccc;\r\n\tborder-bottom-color: #b3b3b3;\r\n\tborder-radius: 4px;\r\n\tbox-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2), 0 1px 2px rgba(0, 0, 0, 0.05)\r\n}\r\n\r\n.bs-glyphicons {\r\n\tmargin: 0 -10px 20px;\r\n\toverflow: hidden\r\n}\r\n\r\n.bs-glyphicons-list {\r\n\tpadding-left: 0;\r\n\tlist-style: none\r\n}\r\n\r\n.bs-glyphicons li {\r\n\tfloat: left;\r\n\twidth: 25%;\r\n\theight: 115px;\r\n\tpadding: 10px;\r\n\tfont-size: 10px;\r\n\tline-height: 1.4;\r\n\ttext-align: center;\r\n\tbackground-color: #f9f9f9;\r\n\tborder: 1px solid #fff\r\n}\r\n\r\n.bs-glyphicons .glyphicon {\r\n\tmargin-top: 5px;\r\n\tmargin-bottom: 10px;\r\n\tfont-size: 24px\r\n}\r\n\r\n.bs-glyphicons .glyphicon-class {\r\n\tdisplay: block;\r\n\ttext-align: center;\r\n\tword-wrap: break-word\r\n}\r\n\r\n.bs-glyphicons li:hover {\r\n\tcolor: #fff;\r\n\tbackground-color: #1ABB9C\r\n}\r\n\r\n@media (min-width: 768px) {\r\n\t.bs-glyphicons {\r\n\t\tmargin-right: 0;\r\n\t\tmargin-left: 0\r\n\t}\r\n\t.bs-glyphicons li {\r\n\t\twidth: 12.5%;\r\n\t\tfont-size: 12px\r\n\t}\r\n}\r\n\r\n.tagsinput {\r\n\tborder: 1px solid #CCC;\r\n\tbackground: #FFF;\r\n\tpadding: 6px 6px 0;\r\n\twidth: 300px;\r\n\toverflow-y: auto\r\n}\r\n\r\nspan.tag {\r\n\t-moz-border-radius: 2px;\r\n\t-webkit-border-radius: 2px;\r\n\tdisplay: block;\r\n\tfloat: left;\r\n\tpadding: 5px 9px;\r\n\ttext-decoration: none;\r\n\tbackground: #1ABB9C;\r\n\tcolor: #F1F6F7;\r\n\tmargin-right: 5px;\r\n\tfont-weight: 500;\r\n\tmargin-bottom: 5px;\r\n\tfont-family: helvetica\r\n}\r\n\r\nspan.tag a {\r\n\tcolor: #F1F6F7 !important\r\n}\r\n\r\n.tagsinput span.tag a {\r\n\tfont-weight: bold;\r\n\tcolor: #82ad2b;\r\n\ttext-decoration: none;\r\n\tfont-size: 11px\r\n}\r\n\r\n.tagsinput input {\r\n\twidth: 80px;\r\n\tmargin: 0px;\r\n\tfont-family: helvetica;\r\n\tfont-size: 13px;\r\n\tborder: 1px solid transparent;\r\n\tpadding: 3px;\r\n\tbackground: transparent;\r\n\tcolor: #000;\r\n\toutline: 0px\r\n}\r\n\r\n.tagsinput div {\r\n\tdisplay: block;\r\n\tfloat: left\r\n}\r\n\r\n.tags_clear {\r\n\tclear: both;\r\n\twidth: 100%;\r\n\theight: 0px\r\n}\r\n\r\n.not_valid {\r\n\tbackground: #FBD8DB !important;\r\n\tcolor: #90111A !important\r\n}\r\n\r\nul.bar_tabs {\r\n\toverflow: visible;\r\n\tbackground: #F5F7FA;\r\n\theight: 25px;\r\n\tmargin: 21px 0 14px;\r\n\tpadding-left: 14px;\r\n\tposition: relative;\r\n\tz-index: 1;\r\n\twidth: 100%;\r\n\tborder-bottom: 1px solid #E6E9ED\r\n}\r\n\r\nul.bar_tabs > li {\r\n\tborder: 1px solid #E6E9ED;\r\n\tcolor: #333 !important;\r\n\tmargin-top: -17px;\r\n\tmargin-left: 8px;\r\n\tbackground: #fff;\r\n\tborder-bottom: none;\r\n\tborder-radius: 4px 4px 0 0\r\n}\r\n\r\nul.bar_tabs > li.active {\r\n\tborder-right: 6px solid #D3D6DA;\r\n\tborder-top: 0;\r\n\tmargin-top: -15px\r\n}\r\n\r\nul.bar_tabs > li a {\r\n\tpadding: 10px 17px;\r\n\tbackground: #F5F7FA;\r\n\tmargin: 0;\r\n\tborder-top-right-radius: 0\r\n}\r\n\r\nul.bar_tabs > li a:hover {\r\n\tborder: 1px solid transparent\r\n}\r\n\r\nul.bar_tabs > li.active a {\r\n\tborder-bottom: none\r\n}\r\n\r\nul.bar_tabs.right {\r\n\tpadding-right: 14px\r\n}\r\n\r\nul.bar_tabs.right li {\r\n\tfloat: right\r\n}\r\n\r\na:focus {\r\n\toutline: none\r\n}\r\n\r\nul.timeline li {\r\n\tposition: relative;\r\n\tborder-bottom: 1px solid #e8e8e8;\r\n\tclear: both\r\n}\r\n\r\n.timeline .block {\r\n\tmargin: 0;\r\n\tborder-left: 3px solid #e8e8e8;\r\n\toverflow: visible;\r\n\tpadding: 10px 15px;\r\n\tmargin-left: 105px\r\n}\r\n\r\n.timeline.widget {\r\n\tmin-width: 0;\r\n\tmax-width: inherit\r\n}\r\n\r\n.timeline.widget .block {\r\n\tmargin-left: 5px\r\n}\r\n\r\n.timeline .tags {\r\n\tposition: absolute;\r\n\ttop: 15px;\r\n\tleft: 0;\r\n\twidth: 84px\r\n}\r\n\r\n.timeline .tag {\r\n\tdisplay: block;\r\n\theight: 30px;\r\n\tfont-size: 13px;\r\n\tpadding: 8px\r\n}\r\n\r\n.timeline .tag span {\r\n\tdisplay: block;\r\n\toverflow: hidden;\r\n\twidth: 100%;\r\n\twhite-space: nowrap;\r\n\ttext-overflow: ellipsis\r\n}\r\n\r\n.tag {\r\n\tline-height: 1;\r\n\tbackground: #1ABB9C;\r\n\tcolor: #fff !important\r\n}\r\n\r\n.tag:after {\r\n\tcontent: \" \";\r\n\theight: 30px;\r\n\twidth: 0;\r\n\tposition: absolute;\r\n\tleft: 100%;\r\n\ttop: 0;\r\n\tmargin: 0;\r\n\tpointer-events: none;\r\n\tborder-top: 14px solid transparent;\r\n\tborder-bottom: 14px solid transparent;\r\n\tborder-left: 11px solid #1ABB9C\r\n}\r\n\r\n.timeline h2.title {\r\n\tposition: relative;\r\n\tfont-size: 16px;\r\n\tmargin: 0\r\n}\r\n\r\n.timeline h2.title:before {\r\n\tcontent: \"\";\r\n\tposition: absolute;\r\n\tleft: -23px;\r\n\ttop: 3px;\r\n\tdisplay: block;\r\n\twidth: 14px;\r\n\theight: 14px;\r\n\tborder: 3px solid #d2d3d2;\r\n\tborder-radius: 14px;\r\n\tbackground: #f9f9f9\r\n}\r\n\r\n.timeline .byline {\r\n\tpadding: .25em 0\r\n}\r\n\r\n.byline {\r\n\t-webkit-font-smoothing: antialiased;\r\n\tfont-style: italic;\r\n\tfont-size: .9375em;\r\n\tline-height: 1.3;\r\n\tcolor: #aab6aa\r\n}\r\n\r\nul.social li {\r\n\tborder: 0\r\n}\r\n\r\n.social-sidebar,\r\n.social-body {\r\n\tfloat: right\r\n}\r\n\r\n.social-sidebar {\r\n\tbackground: #EDEDED;\r\n\twidth: 22%\r\n}\r\n\r\n.social-body {\r\n\tborder: 1px solid #ccc;\r\n\twidth: 78%\r\n}\r\n\r\n.thumb img {\r\n\twidth: 50px;\r\n\theight: 50px;\r\n\tborder-radius: 50%\r\n}\r\n\r\n.chat .thumb img {\r\n\twidth: 27px;\r\n\theight: 27px;\r\n\tborder-radius: 50%\r\n}\r\n\r\n.chat .status {\r\n\tfloat: left;\r\n\tmargin: 16px 0 0 -16px;\r\n\tfont-size: 14px;\r\n\tfont-weight: bold;\r\n\twidth: 12px;\r\n\theight: 12px;\r\n\tdisplay: block;\r\n\tborder: 2px solid #FFF;\r\n\tz-index: 12312;\r\n\tborder-radius: 50%\r\n}\r\n\r\n.chat .status.online {\r\n\tbackground: #1ABB9C\r\n}\r\n\r\n.chat .status.away {\r\n\tbackground: #F39C12\r\n}\r\n\r\n.chat .status.offline {\r\n\tbackground: #ccc\r\n}\r\n\r\n.chat .media-body {\r\n\tpadding-top: 5px\r\n}\r\n\r\n.dashboard_graph .x_title {\r\n\tpadding: 5px 5px 7px\r\n}\r\n\r\n.dashboard_graph .x_title h3 {\r\n\tmargin: 0;\r\n\tfont-weight: normal\r\n}\r\n\r\n.chart {\r\n\tposition: relative;\r\n\tdisplay: inline-block;\r\n\twidth: 110px;\r\n\theight: 110px;\r\n\tmargin-top: 5px;\r\n\tmargin-bottom: 5px;\r\n\ttext-align: center\r\n}\r\n\r\n.chart canvas {\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\tleft: 0\r\n}\r\n\r\n.percent {\r\n\tdisplay: inline-block;\r\n\tline-height: 110px;\r\n\tz-index: 2;\r\n\tfont-size: 18px\r\n}\r\n\r\n.percent:after {\r\n\tcontent: '%';\r\n\tmargin-left: 0.1em;\r\n\tfont-size: .8em\r\n}\r\n\r\n.angular {\r\n\tmargin-top: 100px\r\n}\r\n\r\n.angular .chart {\r\n\tmargin-top: 0\r\n}\r\n\r\n.widget {\r\n\tmin-width: 250px;\r\n\tmax-width: 310px\r\n}\r\n\r\n.widget_tally_box .btn-group button {\r\n\ttext-align: center\r\n}\r\n\r\n.widget_tally_box .btn-group button {\r\n\tcolor: inherit;\r\n\tfont-weight: 500;\r\n\tbackground-color: #f5f5f5;\r\n\tborder: 1px solid #e7e7e7\r\n}\r\n\r\nul.widget_tally,\r\nul.widget_tally li {\r\n\twidth: 100%\r\n}\r\n\r\nul.widget_tally li {\r\n\tpadding: 2px 10px;\r\n\tborder-bottom: 1px solid #ECECEC;\r\n\tpadding-bottom: 4px\r\n}\r\n\r\nul.widget_tally .month {\r\n\twidth: 70%;\r\n\tfloat: left\r\n}\r\n\r\nul.widget_tally .count {\r\n\twidth: 30%;\r\n\tfloat: left;\r\n\ttext-align: right\r\n}\r\n\r\n.pie_bg {\r\n\tborder-bottom: 1px solid rgba(101, 204, 182, 0.16);\r\n\tpadding-bottom: 15px;\r\n\tborder-radius: 4px;\r\n\tfilter: progid: DXImageTransform.Microsoft.gradient(startColorstr='#ffffffff', endColorstr='#ffe6e6e6', GradientType=0);\r\n\tfilter: progid: DXImageTransform.Microsoft.gradient(enabled=false);\r\n\tpadding-bottom: 10px;\r\n\tbox-shadow: 0 4px 6px -6px #222\r\n}\r\n\r\n.widget_tally_box .flex {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex\r\n}\r\n\r\nul.widget_profile_box {\r\n\twidth: 100%;\r\n\theight: 42px;\r\n\tpadding: 3px;\r\n\tbackground: #ececec;\r\n\tmargin-top: 40px;\r\n\tmargin-left: 1px\r\n}\r\n\r\nul.widget_profile_box li:first-child {\r\n\twidth: 25%;\r\n\tfloat: left\r\n}\r\n\r\nul.widget_profile_box li:first-child a {\r\n\tfloat: left\r\n}\r\n\r\nul.widget_profile_box li:last-child {\r\n\twidth: 25%;\r\n\tfloat: right\r\n}\r\n\r\nul.widget_profile_box li:last-child a {\r\n\tfloat: right\r\n}\r\n\r\nul.widget_profile_box li a {\r\n\tfont-size: 22px;\r\n\ttext-align: center;\r\n\twidth: 35px;\r\n\theight: 35px;\r\n\tborder: 1px solid rgba(52, 73, 94, 0.44);\r\n\tdisplay: block;\r\n\tborder-radius: 50%;\r\n\tpadding: 0px\r\n}\r\n\r\nul.widget_profile_box li a:hover {\r\n\tcolor: #1ABB9C !important;\r\n\tborder: 1px solid #26b99a\r\n}\r\n\r\nul.widget_profile_box li .profile_img {\r\n\twidth: 85px;\r\n\theight: 85px;\r\n\tmargin: 0;\r\n\tmargin-top: -28px\r\n}\r\n\r\n.widget_tally_box p,\r\n.widget_tally_box span {\r\n\ttext-align: center\r\n}\r\n\r\n.widget_tally_box .name {\r\n\ttext-align: center;\r\n\tmargin: 25px\r\n}\r\n\r\n.widget_tally_box .name_title {\r\n\ttext-align: center;\r\n\tmargin: 5px\r\n}\r\n\r\n.widget_tally_box ul.legend {\r\n\tmargin: 0\r\n}\r\n\r\n.widget_tally_box ul.legend p,\r\n.widget_tally_box ul.legend span {\r\n\ttext-align: left\r\n}\r\n\r\n.widget_tally_box ul.legend li .icon {\r\n\tfont-size: 20px;\r\n\tfloat: left;\r\n\twidth: 14px\r\n}\r\n\r\n.widget_tally_box ul.legend li .name {\r\n\tfont-size: 14px;\r\n\tmargin: 5px 0 0 14px;\r\n\ttext-overflow: ellipsis;\r\n\tfloat: left\r\n}\r\n\r\n.widget_tally_box ul.legend p {\r\n\tdisplay: inline-block;\r\n\tmargin: 0\r\n}\r\n\r\n.widget_tally_box ul.verticle_bars li {\r\n\theight: 140px;\r\n\twidth: 23%\r\n}\r\n\r\n.widget .verticle_bars li .progress.vertical.progress_wide {\r\n\twidth: 65%\r\n}\r\n\r\nul.count2 {\r\n\twidth: 100%;\r\n\tmargin-left: 1px;\r\n\tborder: 1px solid #ddd;\r\n\tborder-left: 0;\r\n\tborder-right: 0;\r\n\tpadding: 10px 0\r\n}\r\n\r\nul.count2 li {\r\n\twidth: 30%;\r\n\ttext-align: center\r\n}\r\n\r\nul.count2 li h3 {\r\n\tfont-weight: 400;\r\n\tmargin: 0\r\n}\r\n\r\nul.count2 li span {\r\n\tfont-weight: 300\r\n}\r\n\r\n.divider {\r\n\tborder-bottom: 1px solid #ddd;\r\n\tmargin: 10px\r\n}\r\n\r\n.divider-dashed {\r\n\tborder-top: 1px dashed #e7eaec;\r\n\tbackground-color: #ffffff;\r\n\theight: 1px;\r\n\tmargin: 10px 0\r\n}\r\n\r\nul.messages {\r\n\tpadding: 0;\r\n\tlist-style: none\r\n}\r\n\r\nul.messages li,\r\n.tasks li {\r\n\tborder-bottom: 1px dotted #e6e6e6;\r\n\tpadding: 8px 0\r\n}\r\n\r\nul.messages li img.avatar,\r\nimg.avatar {\r\n\theight: 32px;\r\n\twidth: 32px;\r\n\tfloat: left;\r\n\tdisplay: inline-block;\r\n\tborder-radius: 2px;\r\n\tpadding: 2px;\r\n\tbackground: #f7f7f7;\r\n\tborder: 1px solid #e6e6e6\r\n}\r\n\r\nul.messages li .message_date {\r\n\tfloat: right;\r\n\ttext-align: right\r\n}\r\n\r\nul.messages li .message_wrapper {\r\n\tmargin-left: 50px;\r\n\tmargin-right: 40px\r\n}\r\n\r\nul.messages li .message_wrapper h4.heading {\r\n\tfont-weight: 600;\r\n\tmargin: 0;\r\n\tcursor: pointer;\r\n\tmargin-bottom: 10px;\r\n\tline-height: 100%\r\n}\r\n\r\nul.messages li .message_wrapper blockquote {\r\n\tpadding: 0px 10px;\r\n\tmargin: 0;\r\n\tborder-left: 5px solid #eee\r\n}\r\n\r\nul.user_data li {\r\n\tmargin-bottom: 6px\r\n}\r\n\r\nul.user_data li p {\r\n\tmargin-bottom: 0\r\n}\r\n\r\nul.user_data li .progress {\r\n\twidth: 90%\r\n}\r\n\r\n.project_progress .progress {\r\n\tmargin-bottom: 3px !important;\r\n\tmargin-top: 5px\r\n}\r\n\r\n.projects .list-inline {\r\n\tmargin: 0\r\n}\r\n\r\n.profile_title {\r\n\tbackground: #F5F7FA;\r\n\tborder: 0;\r\n\tpadding: 7px 0;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex\r\n}\r\n\r\nul.stats-overview {\r\n\tborder-bottom: 1px solid #e8e8e8;\r\n\tpadding-bottom: 10px;\r\n\tmargin-bottom: 10px\r\n}\r\n\r\nul.stats-overview li {\r\n\tdisplay: inline-block;\r\n\ttext-align: center;\r\n\tpadding: 0 15px;\r\n\twidth: 30%;\r\n\tfont-size: 14px;\r\n\tborder-right: 1px solid #e8e8e8\r\n}\r\n\r\nul.stats-overview li:last-child {\r\n\tborder-right: 0\r\n}\r\n\r\nul.stats-overview li .name {\r\n\tfont-size: 12px\r\n}\r\n\r\nul.stats-overview li .value {\r\n\tfont-size: 14px;\r\n\tfont-weight: bold;\r\n\tdisplay: block\r\n}\r\n\r\nul.stats-overview li:first-child {\r\n\tpadding-left: 0\r\n}\r\n\r\nul.project_files li {\r\n\tmargin-bottom: 5px\r\n}\r\n\r\nul.project_files li a i {\r\n\twidth: 20px\r\n}\r\n\r\n.project_detail p {\r\n\tmargin-bottom: 10px\r\n}\r\n\r\n.project_detail p.title {\r\n\tfont-weight: bold;\r\n\tmargin-bottom: 0\r\n}\r\n\r\n.avatar img {\r\n\tborder-radius: 50%;\r\n\tmax-width: 45px\r\n}\r\n\r\n.pricing {\r\n\tbackground: #fff\r\n}\r\n\r\n.pricing .title {\r\n\tbackground: #1ABB9C;\r\n\theight: 110px;\r\n\tcolor: #fff;\r\n\tpadding: 15px 0 0;\r\n\ttext-align: center\r\n}\r\n\r\n.pricing .title h2 {\r\n\ttext-transform: capitalize;\r\n\tfont-size: 18px;\r\n\tborder-radius: 5px 5px 0 0;\r\n\tmargin: 0;\r\n\tfont-weight: 400\r\n}\r\n\r\n.pricing .title h1 {\r\n\tfont-size: 30px;\r\n\tmargin: 12px\r\n}\r\n\r\n.pricing .title span {\r\n\tbackground: rgba(51, 51, 51, 0.28);\r\n\tpadding: 2px 5px\r\n}\r\n\r\n.pricing_features {\r\n\tbackground: #FAFAFA;\r\n\tpadding: 20px 15px;\r\n\tmin-height: 230px;\r\n\tfont-size: 13.5px\r\n}\r\n\r\n.pricing_features ul li {\r\n\tmargin-top: 10px\r\n}\r\n\r\n.pricing_footer {\r\n\tpadding: 10px 15px;\r\n\tbackground-color: #f5f5f5;\r\n\tborder-top: 1px solid #ddd;\r\n\ttext-align: center;\r\n\tborder-bottom-right-radius: 3px;\r\n\tborder-bottom-left-radius: 3px\r\n}\r\n\r\n.pricing_footer p {\r\n\tfont-size: 13px;\r\n\tpadding: 10px 0 2px;\r\n\tdisplay: block\r\n}\r\n\r\n.ui-ribbon-container {\r\n\tposition: relative\r\n}\r\n\r\n.ui-ribbon-container .ui-ribbon-wrapper {\r\n\tposition: absolute;\r\n\toverflow: hidden;\r\n\twidth: 85px;\r\n\theight: 88px;\r\n\ttop: -3px;\r\n\tright: -3px\r\n}\r\n\r\n.ui-ribbon-container.ui-ribbon-primary .ui-ribbon {\r\n\tbackground-color: #5b90bf\r\n}\r\n\r\n.ui-ribbon-container .ui-ribbon {\r\n\tposition: relative;\r\n\tdisplay: block;\r\n\ttext-align: center;\r\n\tfont-size: 15px;\r\n\tfont-weight: 700;\r\n\tcolor: #fff;\r\n\ttransform: rotate(45deg);\r\n\tpadding: 7px 0;\r\n\tleft: -5px;\r\n\ttop: 15px;\r\n\twidth: 120px;\r\n\tline-height: 20px;\r\n\tbackground-color: #555;\r\n\tbox-shadow: 0 0 3px rgba(0, 0, 0, 0.3)\r\n}\r\n\r\n.ui-ribbon-container.ui-ribbon-primary .ui-ribbon:after,\r\n.ui-ribbon-container.ui-ribbon-primary .ui-ribbon:before {\r\n\tborder-top: 2px solid #5b90bf\r\n}\r\n\r\n.ui-ribbon-container .ui-ribbon:before {\r\n\tleft: 0;\r\n\tbottom: -1px\r\n}\r\n\r\n.ui-ribbon-container .ui-ribbon:before {\r\n\tright: 0\r\n}\r\n\r\n.ui-ribbon-container .ui-ribbon:after,\r\n.ui-ribbon-container .ui-ribbon:before {\r\n\tposition: absolute;\r\n\tcontent: \" \";\r\n\tline-height: 0;\r\n\tborder-top: 2px solid #555;\r\n\tborder-left: 2px solid transparent;\r\n\tborder-right: 2px solid transparent\r\n}\r\n\r\n.thumbnail .image {\r\n\theight: 120px;\r\n\toverflow: hidden\r\n}\r\n\r\n.caption {\r\n\tpadding: 9px 5px;\r\n\tbackground: #F7F7F7\r\n}\r\n\r\n.caption p {\r\n\tmargin-bottom: 5px\r\n}\r\n\r\n.thumbnail {\r\n\theight: 190px;\r\n\toverflow: hidden\r\n}\r\n\r\n.view {\r\n\toverflow: hidden;\r\n\tposition: relative;\r\n\ttext-align: center;\r\n\tbox-shadow: 1px 1px 2px #e6e6e6;\r\n\tcursor: default\r\n}\r\n\r\n.view .mask,\r\n.view .content {\r\n\tposition: absolute;\r\n\twidth: 100%;\r\n\toverflow: hidden;\r\n\ttop: 0;\r\n\tleft: 0\r\n}\r\n\r\n.view img {\r\n\tdisplay: block;\r\n\tposition: relative\r\n}\r\n\r\n.view .tools {\r\n\ttext-transform: uppercase;\r\n\tcolor: #fff;\r\n\ttext-align: center;\r\n\tposition: relative;\r\n\tfont-size: 17px;\r\n\tpadding: 3px;\r\n\tbackground: rgba(0, 0, 0, 0.35);\r\n\tmargin: 43px 0 0 0\r\n}\r\n\r\n.mask.no-caption .tools {\r\n\tmargin: 90px 0 0 0\r\n}\r\n\r\n.view .tools a {\r\n\tdisplay: inline-block;\r\n\tcolor: #FFF;\r\n\tfont-size: 18px;\r\n\tfont-weight: 400;\r\n\tpadding: 0 4px\r\n}\r\n\r\n.view p {\r\n\tfont-family: Georgia, serif;\r\n\tfont-style: italic;\r\n\tfont-size: 12px;\r\n\tposition: relative;\r\n\tcolor: #fff;\r\n\tpadding: 10px 20px 20px;\r\n\ttext-align: center\r\n}\r\n\r\n.view a.info {\r\n\tdisplay: inline-block;\r\n\ttext-decoration: none;\r\n\tpadding: 7px 14px;\r\n\tbackground: #000;\r\n\tcolor: #fff;\r\n\ttext-transform: uppercase;\r\n\tbox-shadow: 0 0 1px #000\r\n}\r\n\r\n.view-first img {\r\n\ttransition: all 0.2s linear\r\n}\r\n\r\n.view-first .mask {\r\n\topacity: 0;\r\n\tbackground-color: rgba(0, 0, 0, 0.5);\r\n\ttransition: all 0.4s ease-in-out\r\n}\r\n\r\n.view-first .tools {\r\n\ttransform: translateY(-100px);\r\n\topacity: 0;\r\n\ttransition: all 0.2s ease-in-out\r\n}\r\n\r\n.view-first p {\r\n\ttransform: translateY(100px);\r\n\topacity: 0;\r\n\ttransition: all 0.2s linear\r\n}\r\n\r\n.view-first:hover img {\r\n\ttransform: scale(1.1)\r\n}\r\n\r\n.view-first:hover .mask {\r\n\topacity: 1\r\n}\r\n\r\n.view-first:hover .tools,\r\n.view-first:hover p {\r\n\topacity: 1;\r\n\ttransform: translateY(0px)\r\n}\r\n\r\n.view-first:hover p {\r\n\ttransition-delay: 0.1s\r\n}\r\n\r\n\r\n/*!\r\n\t* bootstrap-vertical-tabs - v1.2.1\r\n\t* https://dbtek.github.io/bootstrap-vertical-tabs\r\n\t* 2014-11-07\r\n\t* Copyright (c) 2014 İsmail Demirbilek\r\n\t* License: MIT\r\n\t*/\r\n\r\n.tabs-left,\r\n.tabs-right {\r\n\tborder-bottom: none;\r\n\tpadding-top: 2px\r\n}\r\n\r\n.tabs-left {\r\n\tborder-right: 1px solid #F7F7F7\r\n}\r\n\r\n.tabs-right {\r\n\tborder-left: 1px solid #F7F7F7\r\n}\r\n\r\n.tabs-left > li,\r\n.tabs-right > li {\r\n\tfloat: none;\r\n\tmargin-bottom: 2px\r\n}\r\n\r\n.tabs-left > li {\r\n\tmargin-right: -1px\r\n}\r\n\r\n.tabs-right > li {\r\n\tmargin-left: -1px\r\n}\r\n\r\n.tabs-left > li.active > a,\r\n.tabs-left > li.active > a:hover,\r\n.tabs-left > li.active > a:focus {\r\n\tborder-bottom-color: #F7F7F7;\r\n\tborder-right-color: transparent\r\n}\r\n\r\n.tabs-right > li.active > a,\r\n.tabs-right > li.active > a:hover,\r\n.tabs-right > li.active > a:focus {\r\n\tborder-bottom: 1px solid #F7F7F7;\r\n\tborder-left-color: transparent\r\n}\r\n\r\n.tabs-left > li > a {\r\n\tborder-radius: 4px 0 0 4px;\r\n\tmargin-right: 0;\r\n\tdisplay: block;\r\n\tbackground: #F7F7F7;\r\n\ttext-overflow: ellipsis;\r\n\toverflow: hidden\r\n}\r\n\r\n.tabs-right > li > a {\r\n\tborder-radius: 0 4px 4px 0;\r\n\tmargin-right: 0;\r\n\tbackground: #F7F7F7;\r\n\ttext-overflow: ellipsis;\r\n\toverflow: hidden\r\n}\r\n\r\n.sideways {\r\n\tmargin-top: 50px;\r\n\tborder: none;\r\n\tposition: relative\r\n}\r\n\r\n.sideways > li {\r\n\theight: 20px;\r\n\twidth: 120px;\r\n\tmargin-bottom: 100px\r\n}\r\n\r\n.sideways > li > a {\r\n\tborder-bottom: 1px solid #ddd;\r\n\tborder-right-color: transparent;\r\n\ttext-align: center;\r\n\tborder-radius: 4px 4px 0px 0px\r\n}\r\n\r\n.sideways > li.active > a,\r\n.sideways > li.active > a:hover,\r\n.sideways > li.active > a:focus {\r\n\tborder-bottom-color: transparent;\r\n\tborder-right-color: #ddd;\r\n\tborder-left-color: #ddd\r\n}\r\n\r\n.sideways.tabs-left {\r\n\tleft: -50px\r\n}\r\n\r\n.sideways.tabs-right {\r\n\tright: -50px\r\n}\r\n\r\n.sideways.tabs-right > li {\r\n\ttransform: rotate(90deg)\r\n}\r\n\r\n.sideways.tabs-left > li {\r\n\ttransform: rotate(-90deg)\r\n}\r\n\r\n.avatar-view {\r\n\tdisplay: block;\r\n\tborder: 3px solid #fff;\r\n\tborder-radius: 5px;\r\n\tbox-shadow: 0 0 5px rgba(0, 0, 0, 0.15);\r\n\tcursor: pointer;\r\n\toverflow: hidden\r\n}\r\n\r\n.avatar-body {\r\n\tpadding-right: 15px;\r\n\tpadding-left: 15px\r\n}\r\n\r\n.avatar-upload {\r\n\toverflow: hidden\r\n}\r\n\r\n.avatar-upload label {\r\n\tdisplay: block;\r\n\tfloat: left;\r\n\tclear: left;\r\n\twidth: 100px\r\n}\r\n\r\n.avatar-upload input {\r\n\tdisplay: block;\r\n\tmargin-left: 110px\r\n}\r\n\r\n.avater-alert {\r\n\tmargin-top: 10px;\r\n\tmargin-bottom: 10px\r\n}\r\n\r\n.avatar-wrapper {\r\n\theight: 364px;\r\n\twidth: 100%;\r\n\tmargin-top: 15px;\r\n\tbox-shadow: inset 0 0 5px rgba(0, 0, 0, 0.25);\r\n\tbackground-color: #fcfcfc;\r\n\toverflow: hidden\r\n}\r\n\r\n.avatar-wrapper img {\r\n\tdisplay: block;\r\n\theight: auto;\r\n\tmax-width: 100%\r\n}\r\n\r\n.avatar-preview {\r\n\tfloat: left;\r\n\tmargin-top: 15px;\r\n\tmargin-right: 15px;\r\n\tborder: 1px solid #eee;\r\n\tborder-radius: 4px;\r\n\tbackground-color: #fff;\r\n\toverflow: hidden\r\n}\r\n\r\n.avatar-preview:hover {\r\n\tborder-color: #ccf;\r\n\tbox-shadow: 0 0 5px rgba(0, 0, 0, 0.15)\r\n}\r\n\r\n.avatar-preview img {\r\n\twidth: 100%\r\n}\r\n\r\n.preview-lg {\r\n\theight: 184px;\r\n\twidth: 184px;\r\n\tmargin-top: 15px\r\n}\r\n\r\n.preview-md {\r\n\theight: 100px;\r\n\twidth: 100px\r\n}\r\n\r\n.preview-sm {\r\n\theight: 50px;\r\n\twidth: 50px\r\n}\r\n\r\n@media (min-width: 992px) {\r\n\t.avatar-preview {\r\n\t\tfloat: none\r\n\t}\r\n}\r\n\r\n.avatar-btns {\r\n\tmargin-top: 30px;\r\n\tmargin-bottom: 15px\r\n}\r\n\r\n.avatar-btns .btn-group {\r\n\tmargin-right: 5px\r\n}\r\n\r\n.loading {\r\n\tdisplay: none;\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\tright: 0;\r\n\tbottom: 0;\r\n\tleft: 0;\r\n\tbackground: #fff url(\"./loading.gif\") no-repeat center center;\r\n\topacity: .75;\r\n\tfilter: alpha(opacity=75);\r\n\tz-index: 20140628\r\n}\r\n\r\n.morris-hover {\r\n\tposition: absolute;\r\n\tz-index: 1000\r\n}\r\n\r\n.morris-hover.morris-default-style {\r\n\tpadding: 6px;\r\n\tcolor: #666;\r\n\tbackground: rgba(243, 242, 243, 0.8);\r\n\tborder: solid 2px rgba(195, 194, 196, 0.8);\r\n\tfont-family: sans-serif;\r\n\tfont-size: 12px;\r\n\ttext-align: center\r\n}\r\n\r\n.morris-hover.morris-default-style .morris-hover-row-label {\r\n\tfont-weight: bold;\r\n\tmargin: 0.25em 0\r\n}\r\n\r\n.morris-hover.morris-default-style .morris-hover-point {\r\n\twhite-space: nowrap;\r\n\tmargin: 0.1em 0\r\n}\r\n\r\n.price {\r\n\tfont-size: 40px;\r\n\tfont-weight: 400;\r\n\tcolor: #26B99A;\r\n\tmargin: 0\r\n}\r\n\r\n.prod_title {\r\n\tborder-bottom: 1px solid #DFDFDF;\r\n\tpadding-bottom: 5px;\r\n\tmargin: 30px 0;\r\n\tfont-size: 20px;\r\n\tfont-weight: 400\r\n}\r\n\r\n.product-image img {\r\n\twidth: 90%\r\n}\r\n\r\n.prod_color li {\r\n\tmargin: 0 10px\r\n}\r\n\r\n.prod_color li p {\r\n\tmargin-bottom: 0\r\n}\r\n\r\n.prod_size li {\r\n\tpadding: 0\r\n}\r\n\r\n.prod_color .color {\r\n\twidth: 25px;\r\n\theight: 25px;\r\n\tborder: 2px solid rgba(51, 51, 51, 0.28) !important;\r\n\tpadding: 2px;\r\n\tborder-radius: 50px\r\n}\r\n\r\n.product_gallery a {\r\n\twidth: 100px;\r\n\theight: 100px;\r\n\tfloat: left;\r\n\tmargin: 10px;\r\n\tborder: 1px solid #e5e5e5\r\n}\r\n\r\n.product_gallery a img {\r\n\twidth: 100%;\r\n\tmargin-top: 15px\r\n}\r\n\r\n.product_price {\r\n\tmargin: 20px 0;\r\n\tpadding: 5px 10px;\r\n\tbackground-color: #FFFFFF;\r\n\ttext-align: left;\r\n\tborder: 2px dashed #E0E0E0\r\n}\r\n\r\n.price-tax {\r\n\tfont-size: 18px\r\n}\r\n\r\n.product_social {\r\n\tmargin: 20px 0\r\n}\r\n\r\n.product_social ul li a i {\r\n\tfont-size: 35px\r\n}\r\n\r\n.login {\r\n\tbackground: #F7F7F7\r\n}\r\n\r\n.login .fa-paw {\r\n\tfont-size: 26px\r\n}\r\n\r\na.hiddenanchor {\r\n\tdisplay: none\r\n}\r\n\r\n.login_wrapper {\r\n\tright: 0px;\r\n\tmargin: 0px auto;\r\n\tmargin-top: 5%;\r\n\tmax-width: 350px;\r\n\tposition: relative\r\n}\r\n\r\n.registration_form,\r\n.login_form {\r\n\tposition: absolute;\r\n\ttop: 0px;\r\n\twidth: 100%\r\n}\r\n\r\n.registration_form {\r\n\tz-index: 21;\r\n\topacity: 0;\r\n\twidth: 100%\r\n}\r\n\r\n.login_form {\r\n\tz-index: 22\r\n}\r\n\r\n#signup:target ~ .login_wrapper .registration_form,\r\n#signin:target ~ .login_wrapper .login_form {\r\n\tz-index: 22;\r\n\tanimation-name: fadeInLeft;\r\n\tanimation-delay: .1s\r\n}\r\n\r\n#signup:target ~ .login_wrapper .login_form,\r\n#signin:target ~ .login_wrapper .registration_form {\r\n\tanimation-name: fadeOutLeft\r\n}\r\n\r\n.animate {\r\n\t-webkit-animation-duration: 0.5s;\r\n\t-webkit-animation-timing-function: ease;\r\n\t-webkit-animation-fill-mode: both;\r\n\t-moz-animation-duration: 0.5s;\r\n\t-moz-animation-timing-function: ease;\r\n\t-moz-animation-fill-mode: both;\r\n\t-o-animation-duration: 0.5s;\r\n\t-o-animation-timing-function: ease;\r\n\t-o-animation-fill-mode: both;\r\n\t-ms-animation-duration: 0.5s;\r\n\t-ms-animation-timing-function: ease;\r\n\t-ms-animation-fill-mode: both;\r\n\tanimation-duration: 0.5s;\r\n\tanimation-timing-function: ease;\r\n\tanimation-fill-mode: both\r\n}\r\n\r\n.login_box {\r\n\tpadding: 20px;\r\n\tmargin: auto\r\n}\r\n\r\n.left {\r\n\tfloat: left\r\n}\r\n\r\n.alignleft {\r\n\tfloat: left;\r\n\tmargin-right: 15px\r\n}\r\n\r\n.alignright {\r\n\tfloat: right;\r\n\tmargin-left: 15px\r\n}\r\n\r\n.clearfix:after,\r\nform:after {\r\n\tcontent: \".\";\r\n\tdisplay: block;\r\n\theight: 0;\r\n\tclear: both;\r\n\tvisibility: hidden\r\n}\r\n\r\n.login_content {\r\n\tmargin: 0 auto;\r\n\tpadding: 25px 0 0;\r\n\tposition: relative;\r\n\ttext-align: center;\r\n\ttext-shadow: 0 1px 0 #fff;\r\n\tmin-width: 280px\r\n}\r\n\r\n.login_content a,\r\n.login_content .btn-default:hover {\r\n\ttext-decoration: none\r\n}\r\n\r\n.login_content a:hover {\r\n\ttext-decoration: underline\r\n}\r\n\r\n.login_content h1 {\r\n\tfont: normal 25px Helvetica, Arial, sans-serif;\r\n\tletter-spacing: -0.05em;\r\n\tline-height: 20px;\r\n\tmargin: 10px 0 30px\r\n}\r\n\r\n.login_content h1:before,\r\n.login_content h1:after {\r\n\tcontent: \"\";\r\n\theight: 1px;\r\n\tposition: absolute;\r\n\ttop: 10px;\r\n\twidth: 27%\r\n}\r\n\r\n.login_content h1:after {\r\n\tbackground: #7e7e7e;\r\n\tbackground: linear-gradient(left, #7e7e7e 0%, #fff 100%);\r\n\tright: 0\r\n}\r\n\r\n.login_content h1:before {\r\n\tbackground: #7e7e7e;\r\n\tbackground: linear-gradient(right, #7e7e7e 0%, #fff 100%);\r\n\tleft: 0\r\n}\r\n\r\n.login_content h1:before,\r\n.login_content h1:after {\r\n\tcontent: \"\";\r\n\theight: 1px;\r\n\tposition: absolute;\r\n\ttop: 10px;\r\n\twidth: 20%\r\n}\r\n\r\n.login_content h1:after {\r\n\tbackground: #7e7e7e;\r\n\tbackground: linear-gradient(left, #7e7e7e 0%, #fff 100%);\r\n\tright: 0\r\n}\r\n\r\n.login_content h1:before {\r\n\tbackground: #7e7e7e;\r\n\tbackground: linear-gradient(right, #7e7e7e 0%, #fff 100%);\r\n\tleft: 0\r\n}\r\n\r\n.login_content form {\r\n\tmargin: 20px 0;\r\n\tposition: relative\r\n}\r\n\r\n.login_content form input[type=\"text\"],\r\n.login_content form input[type=\"email\"],\r\n.login_content form input[type=\"password\"] {\r\n\tborder-radius: 3px;\r\n\t-ms-box-shadow: 0 1px 0 #fff, 0 -2px 5px rgba(0, 0, 0, 0.08) inset;\r\n\t-o-box-shadow: 0 1px 0 #fff, 0 -2px 5px rgba(0, 0, 0, 0.08) inset;\r\n\tbox-shadow: 0 1px 0 #fff, 0 -2px 5px rgba(0, 0, 0, 0.08) inset;\r\n\tborder: 1px solid #c8c8c8;\r\n\tcolor: #777;\r\n\tmargin: 0 0 20px;\r\n\twidth: 100%\r\n}\r\n\r\n.login_content form input[type=\"text\"]:focus,\r\n.login_content form input[type=\"email\"]:focus,\r\n.login_content form input[type=\"password\"]:focus {\r\n\t-ms-box-shadow: 0 0 2px #ed1c24 inset;\r\n\t-o-box-shadow: 0 0 2px #ed1c24 inset;\r\n\tbox-shadow: 0 0 2px #A97AAD inset;\r\n\tbackground-color: #fff;\r\n\tborder: 1px solid #A878AF;\r\n\toutline: none\r\n}\r\n\r\n#username {\r\n\tbackground-position: 10px 10px !important\r\n}\r\n\r\n#password {\r\n\tbackground-position: 10px -53px !important\r\n}\r\n\r\n.login_content form div a {\r\n\tfont-size: 12px;\r\n\tmargin: 10px 15px 0 0\r\n}\r\n\r\n.reset_pass {\r\n\tmargin-top: 10px !important\r\n}\r\n\r\n.login_content div .reset_pass {\r\n\tmargin-top: 13px !important;\r\n\tmargin-right: 39px;\r\n\tfloat: right\r\n}\r\n\r\n.separator {\r\n\tborder-top: 1px solid #D8D8D8;\r\n\tmargin-top: 10px;\r\n\tpadding-top: 10px\r\n}\r\n\r\n.button {\r\n\tbackground: #f7f9fa;\r\n\tbackground: linear-gradient(top, #f7f9fa 0%, #f0f0f0 100%);\r\n\tfilter: progid: DXImageTransform.Microsoft.gradient( startColorstr='#f7f9fa', endColorstr='#f0f0f0', GradientType=0);\r\n\t-ms-box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1) inset;\r\n\t-o-box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1) inset;\r\n\tbox-shadow: 0 1px 2px rgba(0, 0, 0, 0.1) inset;\r\n\tborder-radius: 0 0 5px 5px;\r\n\tborder-top: 1px solid #CFD5D9;\r\n\tpadding: 15px 0\r\n}\r\n\r\n.login_content form input[type=\"submit\"],\r\n#content form .submit {\r\n\tfloat: left;\r\n\tmargin-left: 38px\r\n}\r\n\r\n.button a {\r\n\tbackground: url(http://cssdeck.com/uploads/media/items/8/8bcLQqF.png) 0 -112px no-repeat;\r\n\tcolor: #7E7E7E;\r\n\tfont-size: 17px;\r\n\tpadding: 2px 0 2px 40px;\r\n\ttext-decoration: none;\r\n\ttransition: all 0.3s ease\r\n}\r\n\r\n.button a:hover {\r\n\tbackground-position: 0 -135px;\r\n\tcolor: #00aeef\r\n}\r\n\r\nheader {\r\n\twidth: 100%\r\n}\r\n\r\n#nprogress {\r\n\tpointer-events: none\r\n}\r\n\r\n#nprogress .bar {\r\n\tbackground: #29d;\r\n\tposition: fixed;\r\n\tz-index: 1031;\r\n\ttop: 0;\r\n\tleft: 0;\r\n\twidth: 100%;\r\n\theight: 2px\r\n}\r\n\r\n#nprogress .peg {\r\n\tdisplay: block;\r\n\tposition: absolute;\r\n\tright: 0px;\r\n\twidth: 100px;\r\n\theight: 100%;\r\n\tbox-shadow: 0 0 10px #29d, 0 0 5px #29d;\r\n\topacity: 1.0;\r\n\ttransform: rotate(3deg) translate(0px, -4px)\r\n}\r\n\r\n#nprogress .spinner {\r\n\tdisplay: block;\r\n\tposition: fixed;\r\n\tz-index: 1031;\r\n\ttop: 15px;\r\n\tright: 15px\r\n}\r\n\r\n#nprogress .spinner-icon {\r\n\twidth: 18px;\r\n\theight: 18px;\r\n\tbox-sizing: border-box;\r\n\tborder: solid 2px transparent;\r\n\tborder-top-color: #29d;\r\n\tborder-left-color: #29d;\r\n\tborder-radius: 50%;\r\n\tanimation: nprogress-spinner 400ms linear infinite\r\n}\r\n\r\n.nprogress-custom-parent {\r\n\toverflow: hidden;\r\n\tposition: relative\r\n}\r\n\r\n.nprogress-custom-parent #nprogress .spinner,\r\n.nprogress-custom-parent #nprogress .bar {\r\n\tposition: absolute\r\n}\r\n\r\n@keyframes nprogress-spinner {\r\n\t0% {\r\n\t\ttransform: rotate(0deg)\r\n\t}\r\n\t100% {\r\n\t\ttransform: rotate(360deg)\r\n\t}\r\n}\r\n\r\n.editor-wrapper {\r\n\tmin-height: 250px;\r\n\tbackground-color: white;\r\n\tborder-collapse: separate;\r\n\tborder: 1px solid #ccc;\r\n\tpadding: 4px;\r\n\tbox-sizing: content-box;\r\n\tbox-shadow: rgba(0, 0, 0, 0.07451) 0px 1px 1px 0px inset;\r\n\tborder-top-right-radius: 3px;\r\n\tborder-bottom-right-radius: 3px;\r\n\tborder-bottom-left-radius: 3px;\r\n\tborder-top-left-radius: 3px;\r\n\toverflow: scroll;\r\n\toutline: none\r\n}\r\n\r\n.voiceBtn {\r\n\twidth: 20px;\r\n\tcolor: transparent;\r\n\tbackground-color: transparent;\r\n\ttransform: scale(2, 2);\r\n\t-webkit-transform: scale(2, 2);\r\n\t-moz-transform: scale(2, 2);\r\n\tborder: transparent;\r\n\tcursor: pointer;\r\n\tbox-shadow: none;\r\n\t-webkit-box-shadow: none\r\n}\r\n\r\ndiv[data-role=\"editor-toolbar\"] {\r\n\t-webkit-user-select: none;\r\n\t-moz-user-select: none;\r\n\t-ms-user-select: none;\r\n\tuser-select: none\r\n}\r\n\r\n.dropdown-menu a {\r\n\tcursor: pointer\r\n}\r\n\r\n.select2-container--default .select2-selection--single,\r\n.select2-container--default .select2-selection--multiple {\r\n\tbackground-color: #fff;\r\n\tborder: 1px solid #ccc;\r\n\tborder-radius: 0;\r\n\tmin-height: 38px\r\n}\r\n\r\n.select2-container--default .select2-selection--single .select2-selection__rendered {\r\n\tcolor: #73879C;\r\n\tpadding-top: 5px\r\n}\r\n\r\n.select2-container--default .select2-selection--multiple .select2-selection__rendered {\r\n\tpadding-top: 3px\r\n}\r\n\r\n.select2-container--default .select2-selection--single .select2-selection__arrow {\r\n\theight: 36px\r\n}\r\n\r\n.select2-container--default .select2-selection--multiple .select2-selection__choice,\r\n.select2-container--default .select2-selection--multiple .select2-selection__clear {\r\n\tmargin-top: 2px;\r\n\tborder: none;\r\n\tborder-radius: 0;\r\n\tpadding: 3px 5px\r\n}\r\n\r\n.select2-container--default.select2-container--focus .select2-selection--multiple {\r\n\tborder: 1px solid #ccc\r\n}\r\n\r\n.switchery {\r\n\twidth: 32px;\r\n\theight: 20px\r\n}\r\n\r\n.switchery > small {\r\n\twidth: 20px;\r\n\theight: 20px\r\n}\r\n\r\nfieldset {\r\n\tborder: none;\r\n\tmargin: 0;\r\n\tpadding: 0\r\n}\r\n\r\n.cropper .img-container,\r\n.cropper .img-preview {\r\n\tbackground-color: #f7f7f7;\r\n\twidth: 100%;\r\n\ttext-align: center\r\n}\r\n\r\n.cropper .img-container {\r\n\tmin-height: 200px;\r\n\tmax-height: 516px;\r\n\tmargin-bottom: 20px\r\n}\r\n\r\n@media (min-width: 768px) {\r\n\t.cropper .img-container {\r\n\t\tmin-height: 516px\r\n\t}\r\n}\r\n\r\n.cropper .img-container > img {\r\n\tmax-width: 100%\r\n}\r\n\r\n.cropper .docs-preview {\r\n\tmargin-right: -15px\r\n}\r\n\r\n.cropper .img-preview {\r\n\tfloat: left;\r\n\tmargin-right: 10px;\r\n\tmargin-bottom: 10px;\r\n\toverflow: hidden\r\n}\r\n\r\n.cropper .img-preview > img {\r\n\tmax-width: 100%\r\n}\r\n\r\n.cropper .preview-lg {\r\n\twidth: 263px;\r\n\theight: 148px\r\n}\r\n\r\n.cropper .preview-md {\r\n\twidth: 139px;\r\n\theight: 78px\r\n}\r\n\r\n.cropper .preview-sm {\r\n\twidth: 69px;\r\n\theight: 39px\r\n}\r\n\r\n.cropper .preview-xs {\r\n\twidth: 35px;\r\n\theight: 20px;\r\n\tmargin-right: 0\r\n}\r\n\r\n.cropper .docs-data > .input-group {\r\n\tmargin-bottom: 10px\r\n}\r\n\r\n.cropper .docs-data > .input-group > label {\r\n\tmin-width: 80px\r\n}\r\n\r\n.cropper .docs-data > .input-group > span {\r\n\tmin-width: 50px\r\n}\r\n\r\n.cropper .docs-buttons > .btn,\r\n.cropper .docs-buttons > .btn-group,\r\n.cropper .docs-buttons > .form-control {\r\n\tmargin-right: 5px;\r\n\tmargin-bottom: 10px\r\n}\r\n\r\n.cropper .docs-toggles > .btn,\r\n.cropper .docs-toggles > .btn-group,\r\n.cropper .docs-toggles > .dropdown {\r\n\tmargin-bottom: 10px\r\n}\r\n\r\n.cropper .docs-tooltip {\r\n\tdisplay: block;\r\n\tmargin: -6px -12px;\r\n\tpadding: 6px 12px\r\n}\r\n\r\n.cropper .docs-tooltip > .icon {\r\n\tmargin: 0 -3px;\r\n\tvertical-align: top\r\n}\r\n\r\n.cropper .tooltip-inner {\r\n\twhite-space: normal\r\n}\r\n\r\n.cropper .btn-upload .tooltip-inner,\r\n.cropper .btn-toggle .tooltip-inner {\r\n\twhite-space: nowrap\r\n}\r\n\r\n.cropper .btn-toggle {\r\n\tpadding: 6px\r\n}\r\n\r\n.cropper .btn-toggle > .docs-tooltip {\r\n\tmargin: -6px;\r\n\tpadding: 6px\r\n}\r\n\r\n@media (max-width: 400px) {\r\n\t.cropper .btn-group-crop {\r\n\t\tmargin-right: -15px !important\r\n\t}\r\n\t.cropper .btn-group-crop > .btn {\r\n\t\tpadding-left: 5px;\r\n\t\tpadding-right: 5px\r\n\t}\r\n\t.cropper .btn-group-crop .docs-tooltip {\r\n\t\tmargin-left: -5px;\r\n\t\tmargin-right: -5px;\r\n\t\tpadding-left: 5px;\r\n\t\tpadding-right: 5px\r\n\t}\r\n}\r\n\r\n.cropper .docs-options .dropdown-menu {\r\n\twidth: 100%\r\n}\r\n\r\n.cropper .docs-options .dropdown-menu > li {\r\n\tpadding: 3px 20px\r\n}\r\n\r\n.cropper .docs-options .dropdown-menu > li:hover {\r\n\tbackground-color: #f7f7f7\r\n}\r\n\r\n.cropper .docs-options .dropdown-menu > li > label {\r\n\tdisplay: block\r\n}\r\n\r\n.cropper .docs-cropped .modal-body {\r\n\ttext-align: center\r\n}\r\n\r\n.cropper .docs-cropped .modal-body > img,\r\n.cropper .docs-cropped .modal-body > canvas {\r\n\tmax-width: 100%\r\n}\r\n\r\n.cropper .docs-diagram .modal-dialog {\r\n\tmax-width: 352px\r\n}\r\n\r\n.cropper .docs-cropped canvas {\r\n\tmax-width: 100%\r\n}\r\n\r\n.form_wizard .stepContainer {\r\n\tdisplay: block;\r\n\tposition: relative;\r\n\tmargin: 0;\r\n\tpadding: 0;\r\n\tborder: 0 solid #CCC;\r\n\toverflow-x: hidden\r\n}\r\n\r\n.wizard_horizontal ul.wizard_steps {\r\n\tdisplay: table;\r\n\tlist-style: none;\r\n\tposition: relative;\r\n\twidth: 100%;\r\n\tmargin: 0 0 20px\r\n}\r\n\r\n.wizard_horizontal ul.wizard_steps li {\r\n\tdisplay: table-cell;\r\n\ttext-align: center\r\n}\r\n\r\n.wizard_horizontal ul.wizard_steps li a,\r\n.wizard_horizontal ul.wizard_steps li:hover {\r\n\tdisplay: block;\r\n\tposition: relative;\r\n\t-moz-opacity: 1;\r\n\tfilter: alpha(opacity=100);\r\n\topacity: 1;\r\n\tcolor: #666\r\n}\r\n\r\n.wizard_horizontal ul.wizard_steps li a:before {\r\n\tcontent: \"\";\r\n\tposition: absolute;\r\n\theight: 4px;\r\n\tbackground: #ccc;\r\n\ttop: 20px;\r\n\twidth: 100%;\r\n\tz-index: 4;\r\n\tleft: 0\r\n}\r\n\r\n.wizard_horizontal ul.wizard_steps li a.disabled .step_no {\r\n\tbackground: #ccc\r\n}\r\n\r\n.wizard_horizontal ul.wizard_steps li a .step_no {\r\n\twidth: 40px;\r\n\theight: 40px;\r\n\tline-height: 40px;\r\n\tborder-radius: 100px;\r\n\tdisplay: block;\r\n\tmargin: 0 auto 5px;\r\n\tfont-size: 16px;\r\n\ttext-align: center;\r\n\tposition: relative;\r\n\tz-index: 5\r\n}\r\n\r\n.wizard_horizontal ul.wizard_steps li a.selected:before,\r\n.step_no {\r\n\tbackground: #34495E;\r\n\tcolor: #fff\r\n}\r\n\r\n.wizard_horizontal ul.wizard_steps li a.done:before,\r\n.wizard_horizontal ul.wizard_steps li a.done .step_no {\r\n\tbackground: #1ABB9C;\r\n\tcolor: #fff\r\n}\r\n\r\n.wizard_horizontal ul.wizard_steps li:first-child a:before {\r\n\tleft: 50%\r\n}\r\n\r\n.wizard_horizontal ul.wizard_steps li:last-child a:before {\r\n\tright: 50%;\r\n\twidth: 50%;\r\n\tleft: auto\r\n}\r\n\r\n.wizard_verticle .stepContainer {\r\n\twidth: 80%;\r\n\tfloat: left;\r\n\tpadding: 0 10px\r\n}\r\n\r\n.actionBar {\r\n\twidth: 100%;\r\n\tborder-top: 1px solid #ddd;\r\n\tpadding: 10px 5px;\r\n\ttext-align: right;\r\n\tmargin-top: 10px\r\n}\r\n\r\n.actionBar .buttonDisabled {\r\n\tcursor: not-allowed;\r\n\tpointer-events: none;\r\n\topacity: .65;\r\n\tfilter: alpha(opacity=65);\r\n\tbox-shadow: none\r\n}\r\n\r\n.actionBar a {\r\n\tmargin: 0 3px\r\n}\r\n\r\n.wizard_verticle .wizard_content {\r\n\twidth: 80%;\r\n\tfloat: left;\r\n\tpadding-left: 20px\r\n}\r\n\r\n.wizard_verticle ul.wizard_steps {\r\n\tdisplay: table;\r\n\tlist-style: none;\r\n\tposition: relative;\r\n\twidth: 20%;\r\n\tfloat: left;\r\n\tmargin: 0 0 20px\r\n}\r\n\r\n.wizard_verticle ul.wizard_steps li {\r\n\tdisplay: list-item;\r\n\ttext-align: center\r\n}\r\n\r\n.wizard_verticle ul.wizard_steps li a {\r\n\theight: 80px\r\n}\r\n\r\n.wizard_verticle ul.wizard_steps li a:first-child {\r\n\tmargin-top: 20px\r\n}\r\n\r\n.wizard_verticle ul.wizard_steps li a,\r\n.wizard_verticle ul.wizard_steps li:hover {\r\n\tdisplay: block;\r\n\tposition: relative;\r\n\t-moz-opacity: 1;\r\n\tfilter: alpha(opacity=100);\r\n\topacity: 1;\r\n\tcolor: #666\r\n}\r\n\r\n.wizard_verticle ul.wizard_steps li a:before {\r\n\tcontent: \"\";\r\n\tposition: absolute;\r\n\theight: 100%;\r\n\tbackground: #ccc;\r\n\ttop: 20px;\r\n\twidth: 4px;\r\n\tz-index: 4;\r\n\tleft: 49%\r\n}\r\n\r\n.wizard_verticle ul.wizard_steps li a.disabled .step_no {\r\n\tbackground: #ccc\r\n}\r\n\r\n.wizard_verticle ul.wizard_steps li a .step_no {\r\n\twidth: 40px;\r\n\theight: 40px;\r\n\tline-height: 40px;\r\n\tborder-radius: 100px;\r\n\tdisplay: block;\r\n\tmargin: 0 auto 5px;\r\n\tfont-size: 16px;\r\n\ttext-align: center;\r\n\tposition: relative;\r\n\tz-index: 5\r\n}\r\n\r\n.wizard_verticle ul.wizard_steps li a.selected:before,\r\n.step_no {\r\n\tbackground: #34495E;\r\n\tcolor: #fff\r\n}\r\n\r\n.wizard_verticle ul.wizard_steps li a.done:before,\r\n.wizard_verticle ul.wizard_steps li a.done .step_no {\r\n\tbackground: #1ABB9C;\r\n\tcolor: #fff\r\n}\r\n\r\n.wizard_verticle ul.wizard_steps li:first-child a:before {\r\n\tleft: 49%\r\n}\r\n\r\n.wizard_verticle ul.wizard_steps li:last-child a:before {\r\n\tleft: 49%;\r\n\tleft: auto;\r\n\twidth: 0\r\n}\r\n\r\n.form_wizard .loader {\r\n\tdisplay: none\r\n}\r\n\r\n.form_wizard .msgBox {\r\n\tdisplay: none\r\n}\r\n\r\n.progress {\r\n\tborder-radius: 0\r\n}\r\n\r\n.progress-bar-info {\r\n\tbackground-color: #3498DB\r\n}\r\n\r\n.progress-bar-success {\r\n\tbackground-color: #26B99A\r\n}\r\n\r\n.progress_summary .progress {\r\n\tmargin: 5px 0 12px !important\r\n}\r\n\r\n.progress_summary .row {\r\n\tmargin-bottom: 5px\r\n}\r\n\r\n.progress_summary .row .col-xs-2 {\r\n\tpadding: 0\r\n}\r\n\r\n.progress_summary .more_info span {\r\n\ttext-align: right;\r\n\tfloat: right\r\n}\r\n\r\n.progress_summary .data span {\r\n\ttext-align: right;\r\n\tfloat: right\r\n}\r\n\r\n.progress_summary p {\r\n\tmargin-bottom: 3px;\r\n\twidth: 100%\r\n}\r\n\r\n.progress_title .left {\r\n\tfloat: left;\r\n\ttext-align: left\r\n}\r\n\r\n.progress_title .right {\r\n\tfloat: right;\r\n\ttext-align: right;\r\n\tfont-weight: 300\r\n}\r\n\r\n.progress.progress_sm {\r\n\tborder-radius: 0;\r\n\tmargin-bottom: 18px;\r\n\theight: 10px !important\r\n}\r\n\r\n.progress.progress_sm .progress-bar {\r\n\theight: 10px !important\r\n}\r\n\r\n.dashboard_graph p {\r\n\tmargin: 0 0 4px\r\n}\r\n\r\nul.verticle_bars {\r\n\twidth: 100%\r\n}\r\n\r\nul.verticle_bars li {\r\n\twidth: 23%;\r\n\theight: 200px;\r\n\tmargin: 0\r\n}\r\n\r\n.progress.vertical.progress_wide {\r\n\twidth: 35px\r\n}\r\n\r\n.alert-success {\r\n\tcolor: #ffffff;\r\n\tbackground-color: rgba(38, 185, 154, 0.88);\r\n\tborder-color: rgba(38, 185, 154, 0.88)\r\n}\r\n\r\n.alert-info {\r\n\tcolor: #E9EDEF;\r\n\tbackground-color: rgba(52, 152, 219, 0.88);\r\n\tborder-color: rgba(52, 152, 219, 0.88)\r\n}\r\n\r\n.alert-warning {\r\n\tcolor: #E9EDEF;\r\n\tbackground-color: rgba(243, 156, 18, 0.88);\r\n\tborder-color: rgba(243, 156, 18, 0.88)\r\n}\r\n\r\n.alert-danger,\r\n.alert-error {\r\n\tcolor: #E9EDEF;\r\n\tbackground-color: rgba(231, 76, 60, 0.88);\r\n\tborder-color: rgba(231, 76, 60, 0.88)\r\n}\r\n\r\n.ui-pnotify.dark .ui-pnotify-container {\r\n\tcolor: #E9EDEF;\r\n\tbackground-color: rgba(52, 73, 94, 0.88);\r\n\tborder-color: rgba(52, 73, 94, 0.88)\r\n}\r\n\r\n.custom-notifications {\r\n\tposition: fixed;\r\n\tmargin: 15px;\r\n\tright: 0;\r\n\tfloat: right;\r\n\twidth: 400px;\r\n\tz-index: 4000;\r\n\tbottom: 0\r\n}\r\n\r\nul.notifications {\r\n\tfloat: right;\r\n\tdisplay: block;\r\n\tmargin-bottom: 7px;\r\n\tpadding: 0;\r\n\twidth: 100%\r\n}\r\n\r\n.notifications li {\r\n\tfloat: right;\r\n\tmargin: 3px;\r\n\twidth: 36px;\r\n\tbox-shadow: 3px 3px 3px rgba(0, 0, 0, 0.3)\r\n}\r\n\r\n.notifications li:last-child {\r\n\tmargin-left: 0\r\n}\r\n\r\n.notifications a {\r\n\tdisplay: block;\r\n\ttext-align: center;\r\n\ttext-decoration: none;\r\n\ttext-transform: uppercase;\r\n\tpadding: 9px 8px\r\n}\r\n\r\n.tabbed_notifications .text {\r\n\tpadding: 5px 15px;\r\n\theight: 140px;\r\n\tborder-radius: 7px;\r\n\tbox-shadow: 6px 6px 6px rgba(0, 0, 0, 0.3)\r\n}\r\n\r\n.tabbed_notifications div p {\r\n\tdisplay: inline-block\r\n}\r\n\r\n.tabbed_notifications h2 {\r\n\tfont-weight: bold;\r\n\ttext-transform: uppercase;\r\n\twidth: 80%;\r\n\tfloat: left;\r\n\theight: 20px;\r\n\ttext-overflow: ellipsis;\r\n\toverflow: hidden;\r\n\tdisplay: block\r\n}\r\n\r\n.tabbed_notifications .close {\r\n\tpadding: 5px;\r\n\tcolor: #E9EDEF;\r\n\tfloat: right;\r\n\topacity: 1\r\n}\r\n\r\n.daterangepicker.dropdown-menu {\r\n\tfont-size: 13px;\r\n\tpadding: 0;\r\n\toverflow: hidden\r\n}\r\n\r\n.daterangepicker.picker_1 {\r\n\tbackground: #34495E;\r\n\tcolor: #ECF0F1\r\n}\r\n\r\n.daterangepicker.picker_1 table.table-condensed thead tr:first-child {\r\n\tbackground: #1ABB9C\r\n}\r\n\r\n.daterangepicker table.table-condensed thead tr:first-child th {\r\n\tline-height: 28px;\r\n\ttext-align: center\r\n}\r\n\r\n.daterangepicker.picker_1 table.table-condensed thead tr {\r\n\tbackground: #213345\r\n}\r\n\r\n.daterangepicker table.table-condensed thead tr {\r\n\tline-height: 14px\r\n}\r\n\r\n.daterangepicker table.table-condensed tbody tr:first-child td {\r\n\tpadding-top: 10px\r\n}\r\n\r\n.daterangepicker table.table-condensed th:first-child,\r\n.daterangepicker table.table-condensed td:first-child {\r\n\tpadding-left: 12px\r\n}\r\n\r\n.daterangepicker table.table-condensed th:last-child,\r\n.daterangepicker table.table-condensed td:last-child {\r\n\tpadding-right: 12px\r\n}\r\n\r\n.table-condensed > thead > tr > th,\r\n.table-condensed > tbody > tr > th,\r\n.table-condensed > tfoot > tr > th,\r\n.table-condensed > thead > tr > td,\r\n.table-condensed > tbody > tr > td,\r\n.table-condensed > tfoot > tr > td {\r\n\tpadding: 5px 7px;\r\n\ttext-align: center\r\n}\r\n\r\n.daterangepicker table.table-condensed tbody tr:last-child td {\r\n\tpadding-bottom: 10px\r\n}\r\n\r\n.daterangepicker.picker_2 table.table-condensed thead tr:first-child {\r\n\tcolor: inherit\r\n}\r\n\r\n.daterangepicker.picker_2 table.table-condensed thead tr {\r\n\tcolor: #1ABB9C\r\n}\r\n\r\n.daterangepicker.picker_3 table.table-condensed thead tr:first-child {\r\n\tbackground: #1ABB9C;\r\n\tcolor: #ECF0F1\r\n}\r\n\r\n.daterangepicker.picker_4 table.table-condensed tbody td {\r\n\tbackground: #ECF0F1;\r\n\tcolor: #34495E;\r\n\tborder: 1px solid #fff;\r\n\tpadding: 4px 7px\r\n}\r\n\r\n.daterangepicker.picker_4 table.table-condensed tbody td.active {\r\n\tbackground: #536A7F;\r\n\tcolor: #fff\r\n}\r\n\r\n.daterangepicker.picker_4 table.table-condensed thead tr:first-child {\r\n\tbackground: #34495E;\r\n\tcolor: #ECF0F1\r\n}\r\n\r\n.xdisplay_input {\r\n\twidth: 240px;\r\n\toverflow: hidden;\r\n\tpadding: 0\r\n}\r\n\r\n.xdisplay {\r\n\tbackground-color: #fff;\r\n\tbackground-clip: padding-box;\r\n\tborder: 1px solid #ccc;\r\n\tmargin-bottom: 20px;\r\n\tborder: 1px solid rgba(0, 0, 0, 0.15);\r\n\tborder-radius: 4px;\r\n\twidth: 230px;\r\n\toverflow: hidden;\r\n\tbox-shadow: 0 6px 12px rgba(0, 0, 0, 0.175)\r\n}\r\n\r\n.daterangepicker.opensright .ranges,\r\n.daterangepicker.opensright .calendar,\r\n.daterangepicker.openscenter .ranges,\r\n.daterangepicker.openscenter .calendar {\r\n\tfloat: right\r\n}\r\n\r\n.daterangepicker table {\r\n\twidth: 100%;\r\n\tmargin: 0\r\n}\r\n\r\n.daterangepicker td,\r\n.daterangepicker th {\r\n\ttext-align: center;\r\n\twidth: 20px;\r\n\theight: 20px;\r\n\tcursor: pointer;\r\n\twhite-space: nowrap\r\n}\r\n\r\n.daterangepicker td.off {\r\n\tcolor: #999\r\n}\r\n\r\n.daterangepicker td.disabled {\r\n\tcolor: #999\r\n}\r\n\r\n.daterangepicker td.available:hover,\r\n.daterangepicker th.available:hover {\r\n\tbackground: #eee;\r\n\tcolor: #34495E\r\n}\r\n\r\n.daterangepicker td.in-range {\r\n\tbackground: #E4E7EA;\r\n\tborder-radius: 0\r\n}\r\n\r\n.daterangepicker td.available+td.start-date {\r\n\tborder-radius: 4px 0 0 4px\r\n}\r\n\r\n.daterangepicker td.in-range+td.end-date {\r\n\tborder-radius: 0 4px 4px 0\r\n}\r\n\r\n.daterangepicker td.start-date.end-date {\r\n\tborder-radius: 4px !important\r\n}\r\n\r\n.daterangepicker td.active,\r\n.daterangepicker td.active:hover {\r\n\tbackground-color: #536A7F;\r\n\tcolor: #fff\r\n}\r\n\r\n.daterangepicker td.week,\r\n.daterangepicker th.week {\r\n\tfont-size: 80%;\r\n\tcolor: #ccc\r\n}\r\n\r\n.daterangepicker select.monthselect,\r\n.daterangepicker select.yearselect {\r\n\tfont-size: 12px;\r\n\tpadding: 1px;\r\n\theight: auto;\r\n\tmargin: 0;\r\n\tcursor: default;\r\n\theight: 30px;\r\n\tborder: 1px solid #ADB2B5;\r\n\tline-height: 30px;\r\n\tborder-radius: 0px !important\r\n}\r\n\r\n.daterangepicker select.monthselect {\r\n\tmargin-right: 2%;\r\n\twidth: 56%\r\n}\r\n\r\n.daterangepicker select.yearselect {\r\n\twidth: 40%\r\n}\r\n\r\n.daterangepicker select.hourselect,\r\n.daterangepicker select.minuteselect,\r\n.daterangepicker select.ampmselect {\r\n\twidth: 50px;\r\n\tmargin-bottom: 0\r\n}\r\n\r\n.daterangepicker_start_input {\r\n\tfloat: left\r\n}\r\n\r\n.daterangepicker_end_input {\r\n\tfloat: left;\r\n\tpadding-left: 11px\r\n}\r\n\r\n.daterangepicker th.month {\r\n\twidth: auto\r\n}\r\n\r\n.daterangepicker .daterangepicker_start_input label,\r\n.daterangepicker .daterangepicker_end_input label {\r\n\tcolor: #333;\r\n\tdisplay: block;\r\n\tfont-size: 11px;\r\n\tfont-weight: normal;\r\n\theight: 20px;\r\n\tline-height: 20px;\r\n\tmargin-bottom: 2px;\r\n\ttext-shadow: #fff 1px 1px 0px;\r\n\ttext-transform: uppercase;\r\n\twidth: 74px\r\n}\r\n\r\n.daterangepicker .ranges input {\r\n\tfont-size: 11px\r\n}\r\n\r\n.daterangepicker .ranges .input-mini {\r\n\tbackground-color: #eee;\r\n\tborder: 1px solid #ccc;\r\n\tborder-radius: 4px;\r\n\tcolor: #555;\r\n\tdisplay: block;\r\n\tfont-size: 11px;\r\n\theight: 30px;\r\n\tline-height: 30px;\r\n\tvertical-align: middle;\r\n\tmargin: 0 0 10px 0;\r\n\tpadding: 0 6px;\r\n\twidth: 74px\r\n}\r\n\r\n.daterangepicker .ranges .input-mini:hover {\r\n\tcursor: pointer\r\n}\r\n\r\n.daterangepicker .ranges ul {\r\n\tlist-style: none;\r\n\tmargin: 0;\r\n\tpadding: 0\r\n}\r\n\r\n.daterangepicker .ranges li {\r\n\tfont-size: 13px;\r\n\tbackground: #f5f5f5;\r\n\tborder: 1px solid #f5f5f5;\r\n\tcolor: #536A7F;\r\n\tpadding: 3px 12px;\r\n\tmargin-bottom: 8px;\r\n\tborder-radius: 5px;\r\n\tcursor: pointer\r\n}\r\n\r\n.daterangepicker .ranges li.active,\r\n.daterangepicker .ranges li:hover {\r\n\tbackground: #536A7F;\r\n\tborder: 1px solid #536A7F;\r\n\tcolor: #fff\r\n}\r\n\r\n.daterangepicker .calendar {\r\n\tdisplay: none;\r\n\tmax-width: 270px\r\n}\r\n\r\n.daterangepicker.show-calendar .calendar {\r\n\tdisplay: block\r\n}\r\n\r\n.daterangepicker .calendar.single .calendar-date {\r\n\tborder: none\r\n}\r\n\r\n.daterangepicker.single .ranges,\r\n.daterangepicker.single .calendar {\r\n\tfloat: none\r\n}\r\n\r\n.daterangepicker .ranges {\r\n\twidth: 160px;\r\n\ttext-align: left;\r\n\tmargin: 4px\r\n}\r\n\r\n.daterangepicker .ranges .range_inputs > div {\r\n\tfloat: left\r\n}\r\n\r\n.daterangepicker .ranges .range_inputs > div:nth-child(2) {\r\n\tpadding-left: 11px\r\n}\r\n\r\n.daterangepicker.opensleft .ranges,\r\n.daterangepicker.opensleft .calendar {\r\n\tfloat: left;\r\n\tmargin: 4px\r\n}\r\n\r\n.daterangepicker .icon {\r\n\twidth: 20px;\r\n\theight: 20px;\r\n\tdisplay: inline-block;\r\n\tvertical-align: middle\r\n}\r\n\r\n.fc-state-default {\r\n\tbackground: #f5f5f5;\r\n\tcolor: #73879C\r\n}\r\n\r\n.fc-state-down,\r\n.fc-state-active {\r\n\tcolor: #333;\r\n\tbackground: #ccc\r\n}\r\n\r\n.dropzone {\r\n\tmin-height: 300px;\r\n\tborder: 1px solid #e5e5e5\r\n}\r\n\r\n/* 06/15/2017 Paul.  8px is too much padding.  Decrease to 6px. */\r\n.table > thead > tr > th,\r\n.table > tbody > tr > th,\r\n.table > tfoot > tr > th,\r\n.table > thead > tr > td,\r\n.table > tbody > tr > td,\r\n.table > tfoot > tr > td\r\n{\r\n\tpadding: 6px;\r\n\tline-height: 1.42857143;\r\n\tvertical-align: top;\r\n\tborder-top: 1px solid #ddd;\r\n}\r\n\r\n/* 06/15/2017 Paul.  The process table is a single cell, so we don't need any padding. */\r\n.table > tbody > tr > td[class=\" MyProcessCell\"]\r\n{\r\n\tpadding: 0px;\r\n}\r\n\r\n/* 12/31/2017 Paul.  Arctic colors. */\r\n.btn-primary, .btn-default\r\n{\r\n\ttext-shadow: none;\r\n\tbackground-image: none;\r\n\tbackground-repeat: inherit;\r\n\tbackground-position: inherit;\r\n\tbackground-color: #F08276;\r\n\tborder: none;\r\n\tborder-radius: 3px;\r\n\tpadding: 0 20px 0 20px;\r\n\tcolor: white;\r\n\tcursor: pointer;\r\n\tfont-size: 13px;\r\n\tfont-weight: 500;\r\n\ttext-transform: uppercase;\r\n\tmargin: 0;\r\n\theight: 30px;\r\n\tline-height: 30px;\r\n}\r\n.btn-default\r\n{\r\n\tmargin: 8px 0px 8px 0px;\r\n}\r\n/* 05/23/2021 Paul.  Move webkit-file-upload-button to Arctic theme so that only Arctic gets the orange button. */\r\n/*\r\n::-webkit-file-upload-button\r\n{\r\n\ttext-shadow: none;\r\n\tbackground-image: none;\r\n\tbackground-repeat: inherit;\r\n\tbackground-position: inherit;\r\n\tbackground-color: #F08276;\r\n\tborder: none;\r\n\tborder-radius: 3px;\r\n\tpadding: 0 20px 0 20px;\r\n\tcolor: white;\r\n\tcursor: pointer;\r\n\tfont-size: 13px;\r\n\tfont-weight: 500;\r\n\ttext-transform: uppercase;\r\n\tmargin: 0;\r\n\theight: 30px;\r\n\tline-height: 30px;\r\n}\r\n*/\r\n::-ms-browse\r\n{\r\n\ttext-shadow: none;\r\n\tbackground-image: none;\r\n\tbackground-repeat: inherit;\r\n\tbackground-position: inherit;\r\n\tbackground-color: #F08276;\r\n\tborder: none;\r\n\tborder-radius: 3px;\r\n\tpadding: 0 20px 0 20px;\r\n\tcolor: white;\r\n\tcursor: pointer;\r\n\tfont-size: 13px;\r\n\tfont-weight: 500;\r\n\ttext-transform: uppercase;\r\n\tmargin: 0;\r\n\theight: 30px;\r\n\tline-height: 30px;\r\n}\r\n.btn-primary:hover, .btn-primary:focus, .btn-default:hover, .btn-default:focus\r\n{\r\n\tbackground-color: #808f9c;\r\n}\r\n::-webkit-file-upload-button:hover\r\n{\r\n\tbackground-color: #808f9c;\r\n}\r\n::-webkit-file-upload-button:focus\r\n{\r\n\tbackground-color: #808f9c;\r\n}\r\n::-ms-browse:hover\r\n{\r\n\tbackground-color: #808f9c;\r\n}\r\n::-ms-browse:focus\r\n{\r\n\tbackground-color: #808f9c;\r\n}\r\n.x_panel\r\n{\r\n\tbackground-color: white;\r\n}\r\n.form-group\r\n{\r\n\tbackground-color: white;\r\n}\r\n.form-control\r\n{\r\n\tborder: 1px solid #a4e8d5;\r\n}\r\n.control-label\r\n{\r\n\tcolor: #534c64;\r\n}\r\n.form-group input[type=text].form-control, input[type=password].form-control, .form-group input[type=file].form-control, .form-group select.form-control, .form-group textarea.form-control\r\n{\r\n\tbackground-color: #d7f5ed;\r\n\tborder: 1px solid #a4e8d5;\r\n\tborder-radius: 4px;\r\n\tline-height: 30px;\r\n\tmargin: 8px 0px 8px 0px;\r\n\tpadding: 4px;\r\n}\r\n\r\n/* 01/06/2018 Paul.  Add DATA_FORMAT to ListBox support multi-select CSV.  */\r\n.multiple-select\r\n{\r\n\twidth: 35%;\r\n}\r\n.multiple-select > .ms-choice > span\r\n{\r\n\tbackground-color: #d7f5ed;\r\n\tborder: 1px solid #a4e8d5;\r\n\tborder-radius: 4px;\r\n}\r\n.multiple-select > button.ms-choice\r\n{\r\n\tbackground-color: #d7f5ed;\r\n\tborder: 1px solid #a4e8d5;\r\n\tborder-radius: 4px;\r\n}\r\n.multiple-select > .ms-drop\r\n{\r\n\tbackground-color: #d7f5ed;\r\n\tborder: 1px solid #a4e8d5;\r\n\tborder-radius: 4px;\r\n}\r\n/* 01/07/2018 Paul.  Auto-complete is getting hidden behind form-control. */\r\n.input-group .form-control\r\n{\r\n\tz-index: 1;\r\n}\r\n/* 04/28/2019 Paul.  Remove bootstrap setting.  */\r\n@media (min-width: 576px)\r\n{\r\n\t.modal-dialog {\r\n\t\tmax-width: unset;\r\n\t}\r\n}\r\n/* 04/28/2019 Paul.  Latest Bootstrap drops bold. */\r\nlabel\r\n{\r\n\tfont-weight: bold;\r\n}\r\n/* 05/04/2019 Paul.  Bootstrap does not wrap buttons. */\r\n.btn-group\r\n{\r\n\tdisplay: flex;\r\n\tflex-flow: row wrap;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
